import React, { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import {
    BASE_URL, DOC_BASE_URL, attendeeTypeActionId, cityActionId, countryActionId, exhibitorBadgeDaysActionId, visitDaysPricingActionId,
    GSTvalidationActionId, industryChaptersActionId, paymentPortalLink, pincodeActionId, primaryChapterListActionId, seminarInterestActionId, countryIWithCodeActionId, stateActionId, educationRoleTypeActionId, surchargeListActionId, toastError, toastSuccess, visitPurposeActionId, visitorInterestActionId, visitorTypeListActionId
} from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action"
import { withRouter } from "../../../utils/withRouter";
import { Tab, Nav, ToggleButton, ButtonGroup, ListGroup, Container, Row, Stack, Dropdown, Form } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import Resizer from "react-image-file-resizer";
import { data } from "jquery";
import { combineVisitorRegistrationDetail2_action, updateGroupVisitorDays_action, swapVisitorDate_action, cancelVisitorCharges_action, updateVisitorEstimate_action, visitorRegistrationUpdate_action, deleteVisaDoc_action } from "../../../actions/visitor_module_action/visitor_form_action/visitor_form_action"
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../../utils/Validator";
import Modal from "react-modal";
import { getVisitorRegistrationCredentials_action, getCoordinatorVisitor_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { payment_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { sendPaymentForm_action } from "../../../actions/payment_action/payment_action";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import HeaderWithLogo from "../../../common_components/header_with_logo"
import AdminDrawer from "../../../common_components/admin_module_drawer"
// Split a saved phone value "code-number"; without "-" the whole value is the number
const splitPhoneValue = (value) => {
  if (value == null) return undefined;
  const text = value.toString();
  const index = text.indexOf("-");
  return index === -1 ? ["", text] : [text.slice(0, index), text.slice(index + 1)];
};



class VisitorFormView extends Component {

    // Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isOtherPreName: false,
            isSameAsMobNo: false,
            isDisplayStateList: false,
            isDisplayCityList: false,
            isDisplayPincodeList: false,
            needVisaAssistance: false,
            isDisplayPassCountryList: false,
            isAgree: false,
            isVisaApplied: false,
            isOpen: false,
            isOpen2: false,
            isPassportFilePresent: "",
            isVisaUpdated: false,
            isGrpDelegation: false,
            isDisplayDelegationCountryList: false,
            isInterstOne: false,
            isInterestTwo: false,
            isParkingChargable: false,
            isCarParking: 0,
            parkingCharges: 0,
            isParkingAvailable: false,
            paymentAccessCode: 'AVVI64IL27CE56IVEC',
            encPayload: '',
            isPaid: false,

            // Fields 
            country: "",
            countryId: "",
            attendeeType: "",
            attendeeTypeId: "",
            otherName: "",
            preName: "",
            firstName: "",
            middleName: "",
            lastName: "",
            designation: "",
            institute: "",
            preMobNo: "",
            mobNo: "",
            preWhatsAppMobNo: "",
            whatsAppMobNo: "",
            regState: "",
            city: "",
            pincode: "",
            website: "",
            email: "",
            preTelNo: "",
            telNo: "",
            preTel1No: "",
            tel1No: "",
            passName: "",
            preApplicantMobNo: "",
            applicantMobNo: "",
            applicantEmail: "",
            passNo: "",
            passDate: "",
            passExipryDate: "",
            passCountryId: "",
            passCountry: "",
            passportFile: "",
            remarks: "",
            passPortFileName: "",
            passportFileType: "",
            leader: "",
            delegationCountry: "",
            delegationCountryId: "",
            arrivalDate: "",
            departureDate: "",
            delegationRemark: "",
            preffDate: "",
            prefTime: "",
            b2bRemark: "",
            educationRoleTypeList: [],
            educationRoleTypeId: '',
            educationRoleTypeIdErr: '',
            eduRoleName: '',
            // Lists
            countryList: [],
            attendeeList: [],
            daysList: [],
            stateList: [],
            tempStateList: [],
            cityList: [],
            tempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            level1: [],
            visitPurposeList: [],
            passCountryList: [],
            tempPassCountryList: [],
            interestList: [],
            industryChapterList: [],
            delgationCountryList: [],
            tempDelegationCountryList: [],
            seminarInterestList: [],
            primaryChapterListData: [],
            level0: [],
            level1: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel2: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],

            // Err Messages
            attendeeTypeErr: "",
            daysErr: "",
            firstNameErr: "",
            designationErr: "",
            instituteErr: "",
            mobNoErr: "",
            whatsAppMobNoErr: "",
            regStateErr: "",
            cityErr: "",
            pincodeErr: "",
            chapterErr: "",
            visitPurposeErr: "",
            passNameErr: "",
            applicantMobNoErr: "",
            applicantEmailErr: "",
            passNoErr: "",
            passDateErr: "",
            passExipryDateErr: "",
            passCountryErr: "",
            passportFileErr: "",
            leaderErr: "",
            delegationCountryErr: "",
            arrivalDateErr: "",
            departureDateErr: "",
            delegationRemarkErr: "",
            preffDateErr: "",
            preffTimeErr: "",
            b2bRemarkErr: "",
            ChapterHallErr: "",
            identityCardFile: '',
            identityCardFileType: '',
            identityCardFileErr: '',
            identityCardFileName: '',
            PIID: '',
            visitorTypeList: [],
            VisitorTypeID: '',

            isCoordinator: false,
            showINVdetails: false,
            CoordinatorID: '',
            visitorList: [],
            selectedVisitorID: '',
            isVisitorSelect: false,
            coordinatorFN: '',
            coordinatorLN: '',
            coordinatorExhVisitorID: '',
            noOfDaysSelected: 0,
            paymentLink: '',

            isRegistrationComplete: false,
            isOpen4: false,
            pricingList: [],
            isExhibitionFree: false,
            isInvoice: false,
            INVPersonName: '',
            INVCompanyName: '',
            INVAddress: '',
            INVTanNo: '',
            GSTNo: '',
            PANNo: '',
            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownStateModal: false,
            focusedIndexStateModal: -1,

            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            isOpenDropDownCityModal: false,
            focusedIndexCityModal: -1,

            isOpenDropDownPin: false,
            focusedIndexPin: -1,
            isOpenDropDownPinModal: false,
            focusedIndexPinModal: -1,
            isRegistrationComplete: false,

            INVPersonNameErr: '',
            INVCompanyNameErr: '',
            INVAddressErr: '',
            INVTanNoErr: '',
            GSTNoErr: '',
            PANNoErr: '',
            stateId: '',
            countryIdINV: '',
            pincodeINV: '',
            regStateINV: '',
            cityINV: '',

            newestimateDetails: [],
            estimatePop: false,

            visitorCharges: '',
            totaltaxable: '',
            CGST: '',
            SGST: '',
            IGST: '',
            totalCharges: '',

            isIndi: false,
            groupVisitDaysList: [],

            changeVisitDays: false,
            changeVisitDaysId: '',
            tempDaysList: [],

            currentTime: '',
            ExhSrtTime: '',
            cancelPOP: false,
            repayPOP: false,
            successPOP: false,
            toShow: 0,
            isForeignVisitorPop: false,
            conversionRate: '',
            isPaidByUSD: true,
            pgViewAddChargesModal: false,
            additionalChargesUSDper: 0,
            additionalChargesUSD: 0,
            pgViewChargesFillList: [],
            updateType: '',
            metadata: [],
            pgViewAddChargesModal: false,
            pgViewChargesModal: false,
            ChargesPop: false,
            seminarCharges: '',
            seminarCGST: '',
            seminarSGST: '',
            seminarIGST: '',
            TotalPayable: '',
            HTMLEDITOR: false,
            HtmlContent: '',
            toShowExtraDaysinPop: false,
            cantSelectSeminarFlag: false,
            ExhVisitorID: '',
            AccountID: '',
        }
        this.submitfrm = React.createRef()
        this.getFillList = this.getFillList.bind(this)
        this.onAttendeeSelect = this.onAttendeeSelect.bind(this)
        this.onSelectDates = this.onSelectDates.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onSelectPrimaryChapter = this.onSelectPrimaryChapter.bind(this)
        this.onPassportCountrySearch = this.onPassportCountrySearch.bind(this)
        this.renderPassCountryList = this.renderPassCountryList.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.onUpdate = this.onUpdate.bind(this)
        this.getVisitorRegistrationDetails = this.getVisitorRegistrationDetails.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onSelectPurpose = this.onSelectPurpose.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.getVisitorCredentials = this.getVisitorCredentials.bind(this)
        this.getDrawerDetails = this.getDrawerDetails.bind(this)
        this.otherDetailsChange = this.otherDetailsChange.bind(this)
        this.onDelegationCountrySearch = this.onDelegationCountrySearch.bind(this)
        this.renderDelegationCountryList = this.renderDelegationCountryList.bind(this)
        this.handlePrefTime = this.handlePrefTime.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.onFileClick = this.onFileClick.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.navToPayment = this.navToPayment.bind(this)
        this.record = this.record.bind(this)
        this.onCheckLevel1 = this.onCheckLevel1.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.recordTwo = this.recordTwo.bind(this)
        this.onVisitorSelect = this.onVisitorSelect.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordThree = this.recordThree.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.getCoordinatorVisitor = this.getCoordinatorVisitor.bind(this)
        this.onCountrySelect = this.onCountrySelect.bind(this)
        this.onEduRoleSelect = this.onEduRoleSelect.bind(this)
        this.onGSTchange = this.onGSTchange.bind(this)
        this.onSelectGroupDates = this.onSelectGroupDates.bind(this)
        this.onUpdateGroupDays = this.onUpdateGroupDays.bind(this)
        this.getPendingEstiamtes = this.getPendingEstiamtes.bind(this)
        this.onCancelPayment = this.onCancelPayment.bind(this)
        this.onSubmitdaysSwap = this.onSubmitdaysSwap.bind(this)
        this.onCancelSwap = this.onCancelSwap.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onSubmitdaysSwap(popArg[0])
            }
            if (confirmationObj.action == 1) {
                this.navToPayment()
            }
            if (confirmationObj.action == 2) {
                this.onUpdateGroupDays()
            }
            if (confirmationObj.action == 3) {
                this.onSubmitdaysSwap()
            }
            if (confirmationObj.action == 4) {
                this.onUpdate(popArg[0], popArg[1], popArg[2])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    // On Component Load 
    componentDidMount() {
        // Country List 
        console.log(JSON.parse(sessionStorage.getItem('visitorVisitDays')), '284', this.state.groupVisitDaysList)
        this.setState({
            ExhVisitorID: this.props.location.state != null && this.props.location.state.id != null ? this.props.location.state.id : false,
            AccountID: this.props.location.state != null && this.props.location.state.AccountID != null ? this.props.location.state.AccountID : false,
            // ExhVisitorID: this.props.location.state != null && this.props.location.state.Coordinator != null ? this.props.location.state.id : false,
        }, () => {
            if (this.state.ExhVisitorID != '' && this.state.ExhVisitorID != null) {
                this.getFillList(countryActionId, '', '', '', '', '').then(() => {
                    this.getFillList(attendeeTypeActionId, '', '', '', '', '').then(() => {
                        this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "").then(() => {
                            this.getFillList(pincodeActionId, '', '', '', '', '').then(() => {
                                this.getFillList(stateActionId, '', '', '', '', '').then(() => {
                                    this.getFillList(cityActionId, '', '', '', '', '').then(() => {
                                        this.getFillList(primaryChapterListActionId, '', '', '', '', '').then(() => {
                                            this.getFillList(industryChaptersActionId, '', '', '', '', '').then(() => {
                                                this.getFillList(visitPurposeActionId, '', '', '', '', '').then(() => {
                                                    this.getFillList(visitorInterestActionId, '', '', '', '', '').then(() => {
                                                        this.getFillList(educationRoleTypeActionId, "", '', '', '', '').then(() => {

                                                            this.getFillList(seminarInterestActionId, '', '', '', '', this.state.ExhVisitorID).then(() => {
                                                                this.getFillList(visitorTypeListActionId, '', "", "", "", "").then(() => {
                                                                    this.getFillList(GSTvalidationActionId, '', "", "", "", "").then(() => {
                                                                        this.getFillList(visitDaysPricingActionId, '', "", "", "", "").then(() => {

                                                                            this.getDrawerDetails()
                                                                            this.getFillList(countryIWithCodeActionId, '', '', '', sessionStorage.getItem("exhibitionCode"), '').then(() => {
                                                                                this.getVisitorCredentials(0).then(() => {
                                                                                    this.getCoordinatorVisitor().then(() => {

                                                                                        // Calling Get Visitor Details
                                                                                        setTimeout(() => {
                                                                                            this.getFillList(surchargeListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                                                                                            this.getVisitorRegistrationDetails()
                                                                                            if (true) {
                                                                                                this.setState({ isIndi: true })
                                                                                            }
                                                                                            for (var i = 0; i < this.state.groupVisitDaysList.length; i++) {
                                                                                                this.state.groupVisitDaysList[i].isSelected = false
                                                                                                if (this.state.selectedVisitorID != '' && this.state.selectedVisitorID != null) {
                                                                                                    if (this.state.selectedVisitorID == this.state.groupVisitDaysList[i].AccountID) {
                                                                                                        this.state.groupVisitDaysList[i].isSelected = true
                                                                                                    }
                                                                                                } else {
                                                                                                    if (this.state.groupVisitDaysList[i].isCoordinator) {
                                                                                                        this.state.groupVisitDaysList[i].isSelected = true
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            this.setState({ groupVisitDaysList: this.state.groupVisitDaysList }, () => {
                                                                                            })
                                                                                            //////////////////////////////////////////////////////
                                                                                            var param = this.props.params != '' && Object.keys(this.props.params).length != 0 && this.props.params != undefined && this.props.params != null ? this.props.params : null
                                                                                            var status = param != null ? param.status != undefined && param.status != '' && param.status != null ? param.status : null : null
                                                                                            console.log('=====================>', status, Object.keys(this.props.params).length)
                                                                                            if (status != null) {
                                                                                                this.state.isCoordinator && this.getCoordinatorVisitor().then(() => {
                                                                                                    this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "").then(() => {
                                                                                                        var tempSessionList = JSON.parse(sessionStorage.getItem('visitorVisitDays'))
                                                                                                        for (var i = 0; i < tempSessionList.length; i++) {
                                                                                                            this.state.groupVisitDaysList.map((item) => {
                                                                                                                if (tempSessionList[i].ExhVisitorID == item.ExhVisitorID) {
                                                                                                                    for (var j = 0; j < tempSessionList[i].visitDaysList.length; j++) {
                                                                                                                        item.finalDaysList.map((item2) => {
                                                                                                                            if (item2.VisitDate == tempSessionList[i].visitDaysList[j].date) {
                                                                                                                                item2.isSelect = true
                                                                                                                                item2.isReadOnly = true
                                                                                                                                item2.isPending = tempSessionList[i].visitDaysList[j].Outstanding != null && tempSessionList[i].visitDaysList[j].Outstanding != 0 ? true : false
                                                                                                                            }
                                                                                                                        })
                                                                                                                    }
                                                                                                                }
                                                                                                            })
                                                                                                        }
                                                                                                        setTimeout(() => {
                                                                                                            for (var i = 0; i < this.state.groupVisitDaysList.length; i++) {
                                                                                                                this.state.groupVisitDaysList[i].isSelected = false
                                                                                                                if (this.state.selectedVisitorID != '' && this.state.selectedVisitorID != null) {
                                                                                                                    if (this.state.selectedVisitorID == this.state.groupVisitDaysList[i].AccountID) {
                                                                                                                        this.state.groupVisitDaysList[i].isSelected = true
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    if (this.state.groupVisitDaysList[i].isCoordinator) {
                                                                                                                        this.state.groupVisitDaysList[i].isSelected = true
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                            this.setState({ groupVisitDaysList: this.state.groupVisitDaysList }, () => {
                                                                                                                console.log(JSON.parse(sessionStorage.getItem('visitorVisitDays')), '355', this.state.groupVisitDaysList)
                                                                                                            })
                                                                                                        }, 200);
                                                                                                    })
                                                                                                })
                                                                                                if (status == 'Success') {
                                                                                                    toastSuccess("Payment Successful")
                                                                                                    this.setState({ successPOP: true })
                                                                                                } else if (status == 'Failure') {
                                                                                                    toastError('Due to some technical reason your payment failed please try again later or contact to India ITME Society.')
                                                                                                } else if (status == 'Invalid') {
                                                                                                    toastError('Payment for the order is already processed')
                                                                                                }
                                                                                            }
                                                                                        }, 500);
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })

                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            } else {
                toastError("Something went wrong...")
            }
        })
        // Attendee List
        // Days List Action

        // Calling City , State , Pincode filllist on country Select

        // Primary Chapters
        // Industry Chapters
        // Visit Purpose List 
        // Visitor Interest List 
        // Visitor Interest List 





        if (this.props.params != null && this.props.params.status == "failed") {
            toast.error('There is some problem. Please try again later!', {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
        }


    }
    createGroupVisitDaysList() {

    }
    // Get Drawer Details
    getDrawerDetails() {
        this.setState({ isLoading: true })
        this.props.getDrawerDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getDrawerDetails", data.data)
                    sessionStorage.setItem("sessionVisitorDrawerData", JSON.stringify(data.data))

                    // Formatting Address
                    var address = data.data[0] != null && data.data[0] != "" && data.data[0]['Address'] != null && data.data[0]['Address'] != "" &&
                        data.data[0]['Address']
                    var addArray = address != "" && address != null && address.split(",")
                    sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray))

                    // Formating Mobile Numbers
                    var mobNo = data.data[0] != null && data.data[0] != "" && data.data[0]['MobileNo'] != null && data.data[0]['MobileNo'] != "" &&
                        data.data[0]['MobileNo']
                    var MobArray = mobNo != "" && mobNo != null && mobNo.split(",")
                    sessionStorage.setItem("FormatedMobNo", JSON.stringify(MobArray))
                    // this.setState({ isLoading: false })

                    var time = sessionStorage.getItem("ExhibitionStartTime") != null ? new Date(sessionStorage.getItem("ExhibitionStartTime")).toTimeString().split(' ')[0] : null
                    // var ExhDate=
                    this.setState({
                        currentTime: data.data[0].CurrentDateTime,
                        ExhSrtTime: time
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // // Get Exhibitior Details
    // getVisitorCredentials(status) {
    //     this.setState({ isLoading: true })
    //     this.props.getVisitorRegistrationCredentials_action()
    //         .then((data) => {
    //             if (data.error != 1) {
    //                 console.log("Get getVisitorCredentials", data.data[0])
    //                 sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0]))
    //             }
    //             else {
    //                 this.setState({ isLoading: false })
    //                 toastError(data.msg)
    //             }
    //         }).catch((err) => {
    //             console.log(err)
    //         })
    // }

    getVisitorCredentials(status) {
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getVisitorRegistrationCredentials_action(false, this.state.AccountID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log("Get getVisitorCredentials", data.data[0])
                        status == 0 && sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0]))
                        status == 1 && sessionStorage.setItem('SelectedVisitorDataSS', JSON.stringify(data.data[0]))
                        this.setState({
                            isRegistrationComplete: data.data[0].isRegistrationComplete == 1 ? true : false
                        })
                        sessionStorage.setItem('isRegistrationComplete', data.data[0].isRegistrationComplete)
                        if (status == 0 && data.data[0].isCoordinator) {
                            this.setState({ coordinatorFN: JSON.parse(sessionStorage.getItem('loginDataSS')).FirstName, coordinatorLN: JSON.parse(sessionStorage.getItem('loginDataSS')).LastName })
                            this.setState({ isCoordinator: true, CoordinatorID: data.data[0].ExhVisitorID, coordinatorExhVisitorID: data.data[0].ExhVisitorID })
                        }
                        setTimeout(() => {
                            resolve(true)
                        }, 200);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    getCoordinatorVisitor() {
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getCoordinatorVisitor_action(this.state.CoordinatorID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log("Get getCoordinatorVisitor_action", data.data[0])
                        // var obj = {}
                        // obj.AccountID = this.state.CoordinatorID
                        // obj.ExhVisitorID = this.state.coordinatorExhVisitorID
                        // obj.PersonIncharge = this.state.coordinatorFN
                        // obj.LastNamePersonIncharge = this.state.coordinatorLN
                        // data.data.unshift(obj)
                        // if (data.data[0].isCoordinator) {
                        var isselectedVisitorID = false
                        data.data[0].map(item => {
                            if (item.AccountID == this.state.CoordinatorID) {
                                this.setState({ selectedVisitorID: item.AccountID })
                                isselectedVisitorID = true
                            }
                        })

                        // sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0]))
                        // if (data.data[0].isCoordinator) {
                        this.setState({ visitorList: data.data[0] })
                        data.data[1].length > 0 && data.data[1].map(item => {
                            for (var i = 0; i < data.data[0].length; i++) {
                                if (item.ExhVisitorID == data.data[0][i].ExhVisitorID) {
                                    item.Institute_Organisation = data.data[0][i].Institute_Organisation
                                    item.PersonIncharge = data.data[0][i].PersonIncharge + ' ' + data.data[0][i].LastNamePersonIncharge
                                    item.VisitorRegistrationNo = data.data[0][i].VisitorRegistrationNo
                                    // item.Institute_Organisation = data.data[0][i].Institute_Organisation
                                }
                            }
                        })
                        var tempId = []
                        var tempVisitDaysList = []
                        data.data[1].length > 0 && data.data[1].map(item => {
                            if (!tempId.includes(item.ExhVisitorID)) {
                                tempId.push(item.ExhVisitorID)
                                tempVisitDaysList.push(item)
                            }
                        })
                        tempVisitDaysList.length > 0 && tempVisitDaysList.map(item => {
                            var visitDaysList = []
                            var tempOutstanding = 0
                            data.data[1].length > 0 && data.data[1].map(item2 => {
                                if (item.ExhVisitorID == item2.ExhVisitorID) {
                                    visitDaysList.push({ 'date': item2.VisitDate, 'Outstanding': item2.Outstanding, 'ExhVisitorID': item2.ExhVisitorID })
                                    tempOutstanding = tempOutstanding + item2.Outstanding
                                }
                                if (item2.Outstanding != 0 && item2.Outstanding != null) {
                                    this.setState({ PIID: item2.ProformaInvoiceID })
                                }
                            })
                            item.visitDaysList = visitDaysList
                            item.Outstanding = tempOutstanding
                        })
                        tempVisitDaysList.length > 0 && tempVisitDaysList.map(item => {
                            data.data[0].length > 0 && data.data[0].map(item2 => {
                                if (item2.ExhVisitorID == item.ExhVisitorID) {
                                    item.TotalPayable = item2.TotalPayable
                                    item.AccountID = item2.AccountID
                                    item.isCoordinator = item2.isCoordinator

                                }
                            })
                        })
                        sessionStorage.setItem("visitorVisitDays", JSON.stringify(tempVisitDaysList))
                        console.log(JSON.parse(sessionStorage.getItem('visitorVisitDays')), '555', this.state.groupVisitDaysList)
                        // }
                        // this.setState({ isLoading: false })

                        resolve(true)
                    }
                    else {
                        resolve(true)
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    onVisitorSelect(item) {
        const { isLoading, isCoordinator, visitorList, isVisitorSelect, selectedVisitorID, groupVisitDaysList } = this.state
        var tempSelectedId = item.AccountID
        this.setState({ selectedVisitorID: tempSelectedId, isVisitorSelect: true }, () => {
            this.getVisitorCredentials(1).then(() => {
                groupVisitDaysList.map(data => {
                    if (item.ExhVisitorID == data.ExhVisitorID) {
                        data.isSelected = true
                    } else {
                        data.isSelected = false
                    }
                })
                this.setState({ groupVisitDaysList: groupVisitDaysList })
                // Calling Get Visor Details
                setTimeout(() => {
                    this.getVisitorRegistrationDetails()
                }, 500);
                // this.setState({ isLoading: false })
            })
        })
    }


    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, xtra) {
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data != null ? data.data : [],
                                passCountryList: data != null ? data.data : [],
                                tempPassCountryList: data != null ? data.data : [],
                                delgationCountryList: data != null ? data.data : [],
                                tempDelegationCountryList: data != null ? data.data : [],
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === surchargeListActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                pgViewChargesFillList: data.data, isLoading: false,
                            })
                            // data.data.length > 0 && data.data.map(item => {
                            //     item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                            // })
                        }
                        // state list
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitorTypeListActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                visitorTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === countryIWithCodeActionId) {
                            console.log("country data", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                            sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                            sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                            sessionStorage.setItem("ExhibitionName", data.data[0]['ExhibitionName'])

                            // this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')
                            resolve(true)
                        }
                        if (actionID === educationRoleTypeActionId) {
                            console.log("educationRoleTypeActionId data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                educationRoleTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        // Days List
                        // Days List
                        if (actionID === exhibitorBadgeDaysActionId) {
                            console.log("exhibitor data", data.data)
                            var DateList = []
                            var DateListModal = []
                            // data.data.map(item => {
                            //     DateList.push(item)
                            // })
                            // data.data.map(item => {
                            //     DateListModal.push(item)
                            // })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    "isPending": false
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                DateList.push(mapData)
                                // DateListModal.push(mapData)
                            })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                // DateList.push(mapData)
                                DateListModal.push(mapData)
                            })
                            var tempSessionList = JSON.parse(sessionStorage.getItem("visitorVisitDays")) ?? []
                            var isOutstanding = false

                            for (var i = 0; i < tempSessionList.length; i++) {
                                tempSessionList[i].finalDaysList = []
                                data.data.map((item) => {
                                    // item.isSelect = false
                                    // item.isReadOnly = false
                                    // item.Code = item.VisitDate
                                    var mapData = {
                                        "Code": item['DateValue'],
                                        "VisitDate": item['DateValue'],
                                        "isSelect": false,
                                        "isReadOnly": false,
                                        "isPending": false
                                        // 'PriceINR': item['PriceINR'],
                                        // 'PriceUSD': item['PriceUSD'],
                                        // 'PromoCode': null,
                                        // 'PromoCodeDiscount': null
                                    }
                                    // DateListModal.push(mapData)
                                    tempSessionList[i].finalDaysList.push(mapData)
                                })
                                for (var j = 0; j < tempSessionList[i].visitDaysList.length; j++) {
                                    tempSessionList[i].finalDaysList.map((item) => {
                                        if (item.VisitDate == tempSessionList[i].visitDaysList[j].date) {

                                            item.isSelect = true
                                            item.isReadOnly = true
                                            item.isPending = tempSessionList[i].visitDaysList[j].Outstanding != null && tempSessionList[i].visitDaysList[j].Outstanding != 0 ? true : false
                                            if (tempSessionList[i].visitDaysList[j].Outstanding != null && tempSessionList[i].visitDaysList[j].Outstanding != 0) {
                                                isOutstanding = true
                                            }
                                        }
                                    })
                                }
                                console.log(tempSessionList[i], 'tempSessionList',)
                                // if (tempSessionList[i].)

                            }
                            if (false && xtra != 1) {
                                if (isOutstanding) {
                                    // this.setState({ groupVisitDaysList: groupVisitDaysList }, () => {
                                    var updatedVisitorDaysList = []
                                    for (var i = 0; i < tempSessionList.length; i++) {
                                        console.log(tempSessionList[i], tempSessionList[i].visitDaysList, 'tempSessionListtempSessionListtempSessionList')
                                        for (var j = 0; j < tempSessionList[i].finalDaysList.length; j++) {
                                            if (tempSessionList[i].finalDaysList[j].isSelect) {
                                                updatedVisitorDaysList.push({
                                                    "visitDay": tempSessionList[i].finalDaysList[j].VisitDate,
                                                    "isPaid": tempSessionList[i].finalDaysList[j].isPending ? 0 : tempSessionList[i].finalDaysList[j].isReadOnly ? 1 : 0,
                                                    "ExhVisitorID": tempSessionList[i].ExhVisitorID
                                                })
                                            }
                                        }
                                    }
                                    this.setState({ isLoading: true })
                                    this.props.updateVisitorEstimate_action(updatedVisitorDaysList, false, [])
                                        .then((data) => {
                                            console.log(data)
                                            if (data.error != 1) {
                                                this.setState({ isLoading: false, isRegistrationComplete: true })
                                                // sessionStorage.setItem('isRegistrationComplete', 1)
                                                // this.getVisitorRegistrationDetails()
                                                for (var i = 0; i < data.data[0].length; i++) {
                                                    if (data.data[0][i].Narration == 'Total Taxable') {
                                                        this.setState({ totaltaxable: data.data[0][i].TotalAmt })
                                                    }
                                                    if (data.data[0][i].Narration == 'Grand Total') {
                                                        this.setState({ totalCharges: data.data[0][i].TotalAmt })
                                                    }
                                                    if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
                                                        this.setState({ visitorCharges: data.data[0][i].TotalAmt })
                                                    }
                                                    if (data.data[0][i].Narration == 'CGST') {
                                                        this.setState({ CGST: data.data[0][i].TotalAmt })
                                                    }
                                                    if (data.data[0][i].Narration == 'SGST') {
                                                        this.setState({ SGST: data.data[0][i].TotalAmt })
                                                    }
                                                    if (data.data[0][i].Narration == 'IGST') {
                                                        this.setState({ IGST: data.data[0][i].TotalAmt })
                                                    }
                                                }
                                                // this.setState({
                                                //     // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                                                //     estimatePop: true
                                                // })
                                            } else {
                                                this.setState({ isLoading: false })
                                            }
                                        })
                                        .catch((err) => {
                                            console.log(err)
                                        })
                                    console.log(updatedVisitorDaysList)

                                    // })
                                }
                            }
                            this.setState({
                                daysList: DateList,
                                daysModalList: DateListModal,
                                isLoading: false,
                                groupVisitDaysList: tempSessionList
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            console.log(JSON.parse(sessionStorage.getItem('visitorVisitDays')), '763', this.state.groupVisitDaysList)
                            // sessionStorage.setItem("isExhibitionFree", JSON.stringify(data.data[0]['isExhibitionFree']))
                            resolve(true)
                        }
                        if (actionID === visitDaysPricingActionId) {
                            console.log("exhibitor data", data.data)
                            this.setState({
                                // daysList: DateList,
                                pricingList: data.data
                                // daysModalList: DateListModal,
                                // isLoading: false,
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            this.setState({
                                isExhibitionFree: data.data.length == 0,
                            })
                            sessionStorage.setItem("isExhibitionFree", data.data.length == 0)
                            resolve(true)

                        }
                        // Attendee Type List
                        if (actionID === attendeeTypeActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                attendeeList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        //Chapter List
                        if (actionID === primaryChapterListActionId) {
                            console.log("primaryChapterListActionId 121212", data.data)
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        // console.log(arr[i].ChapterName)
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }

                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                    data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                }
                                if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                    data.data['primaryChapter'].splice(i, 1)
                                }
                                console.log(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            console.log(data.data['primaryChapter'])
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        // Industry Chapter List
                        if (actionID === industryChaptersActionId) {
                            console.log("industryChaptersActionId 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.IsSelect = false
                            })
                            this.setState({
                                industryChapterList: data.data,
                            })
                            setTimeout(() => {
                                this.setState({
                                    // isLoading: false,
                                })
                            }, 3000);
                            resolve(true)
                        }
                        // Visit Purpose list
                        if (actionID === visitPurposeActionId) {
                            console.log(" Visit Purpose List data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                                item.otherDetail = ""
                            })
                            this.setState({
                                visitPurposeList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === GSTvalidationActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                gstValidtionList: data.data, isLoading: false,
                            })
                            resolve(true)
                        }
                        //Visitor Interest List
                        if (actionID === visitorInterestActionId) {
                            console.log("Visitor Interest List 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                            })
                            this.setState({
                                interestList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        //Visitor Semninar Interest List
                        if (actionID === seminarInterestActionId) {
                            data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                            console.log("Visitor Interest List 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                if (item.ParentSeminarID != null) {
                                    item.Day = ''
                                }
                                item.isPending = false
                                item.isReadOnly = false
                                item.isSelect = false
                            })
                            const result = this.calculateRowspan(data.data);
                            this.setState({
                                seminarInterestList: result,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    calculateRowspan(data) {
        // Create a map to count children for each parent seminar
        const parentChildMap = {};

        // Initialize Rowspan for each item and count the children
        data.forEach(item => {
            item.Rowspan = 0; // Default Rowspan for all items

            if (item.ParentSeminarID !== null) {
                // Increment child count for the parent
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });

        // Assign Rowspan to parent seminars
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                // If it's a parent, Rowspan is itself plus its children
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });

        return data;
    }

    // Input Fields Validation
    inputValidate() {
        const { attendeeTypeId, daysList, designation, institute, mobNo, whatsAppMobNo, regState, countryId, city, pincode, level1,
            visitPurposeList, needVisaAssistance, passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate,
            passCountryId, passportFile, isGrpDelegation, leader, delegationCountryId, arrivalDate, departureDate, delegationRemark, isInvoice,
            industryChapterList, isInterestTwo, educationRoleTypeId, prefTime, preffDate, b2bRemark, primaryChapterListData, level2, level3, level4,
            INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
        } = this.state
        if (attendeeTypeId == "") {
            this.setState({ attendeeTypeErr: "Please Select Attendee Type" });
        } else {
            if (attendeeTypeId == 3) {
                if (educationRoleTypeId == '') {
                    this.setState({ educationRoleTypeIdErr: "Please Select Education Role Type" });
                }
            }
        }
        if (!(daysList.some(obj => obj.isSelect == true))) {
            this.setState({ daysErr: "Please Select Days" })
        }
        if (designation == "") {
            this.setState({ designationErr: "Please enter designation" });
        }
        if (institute == "") {
            this.setState({ instituteErr: "Please enter institue/Organization" });
        }
        if (mobNo == "") {
            this.setState({ mobNoErr: "Please enter mobile no" });
        }
        if (whatsAppMobNo == "") {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
        }
        if (regState == "" && countryId == "91") {
            this.setState({ regStateErr: "Please enter province/state" });
        }
        if (city == "") {
            this.setState({ cityErr: "Please enter city" });
        }
        if (pincode == "") {
            this.setState({ pincodeErr: "Please enter Pincode" });
        }
        if (!(industryChapterList.some(obj => obj.IsSelect == true))) {
            this.setState({ chapterErr: "Please Select Industry Segment" })
        }
        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
        if (!(filerArray.some(obj => obj.IsSelect == true))) {
            this.setState({ ChapterHallErr: "Please Select Product" })
        }
        if (!(visitPurposeList.some(obj => obj.isSelect == true))) {
            this.setState({ visitPurposeErr: "Please Select Purpose of visit" })
        }
        // Visa assistance validation
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
            }
            if (passCountryId == "") {
                this.setState({ passCountryErr: "Please Select Country " });
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    return
                }
            }
        }
        else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: ""
            })
        }
        if (isGrpDelegation) {
            if (leader == "") {
                this.setState({ leaderErr: "Please enter Leader/Organisation" });
            }
            if (delegationCountryId == "") {
                this.setState({ delegationCountryErr: "Please enter Country" });
            }
            if (arrivalDate == "") {
                this.setState({ arrivalDateErr: "Please enter Arrival Date" });
            }
            if (departureDate == "") {
                this.setState({ departureDateErr: "Please enter Departure Date" });
            }
            if (delegationRemark == "") {
                this.setState({ delegationRemarkErr: "Please enter Delegation Remark" });
            }
        }
        else {
            this.setState({
                leaderErr: "",
                delegationCountryErr: "",
                arrivalDateErr: "",
                departureDateErr: "",
                delegationRemarkErr: "",
            })
        }
        if (isInvoice) {
            if (INVPersonName == '' || INVPersonName == null) {
                this.setState({
                    INVPersonNameErr: 'Please enter Person Incharge Name'
                })
            }
            if (INVCompanyName == '' || INVCompanyName == null) {
                this.setState({
                    INVCompanyNameErr: 'Please enter Company'
                })
            }
            if (INVAddress == '' || INVAddress == null) {
                this.setState({
                    INVAddressErr: 'Please enter Address'
                })
            }
            if (INVTanNo == '' || INVTanNo == null) {
                this.setState({
                    INVTanNoErr: 'Please enter TAN No'
                })
            }
            if (GSTNo == '' || GSTNo == null) {
                this.setState({
                    GSTNoErr: 'Please enter GST No'
                })
            }
            if (PANNo == '' || PANNo == null) {
                this.setState({
                    PANNoErr: 'Please enter PAN No'
                })
            }
        }
        // if (isInterestTwo) {
        //     if (preffDate == "") {
        //         this.setState({ preffDateErr: "Please enter Preffered Date" });
        //     }
        //     if (prefTime == "") {
        //         this.setState({ preffTimeErr: "Please enter Preffered Time" });
        //     }
        // } else {
        //     this.setState({
        //         preffTimeErr: "", preffTimeErr: ""
        //     })
        // }

    }

    // On Select Attendee 
    onAttendeeSelect(e) {
        const { attendeeList, educationRoleTypeId, educationRoleTypeList } = this.state
        var checked = e.target.checked
        var id = e.target.value
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (checked) {
                if (id == data.AttendeeTypeID) {
                    data.isChecked = true
                    this.setState({ attendeeTypeId: data.AttendeeTypeID, attendeeTypeErr: "" })
                    if (id == 3) {
                        if (educationRoleTypeId != '') {
                            educationRoleTypeList.length > 0 && educationRoleTypeList.map((elem) => {
                                if (educationRoleTypeId == elem.EducationRoleTypeID) {
                                    this.setState({ designation: elem.EducationRoleTypeName })
                                }
                            })
                        } else {
                            this.setState({ designation: '' })
                        }
                    }
                } else {
                    data.isChecked = false
                }
            } else {
                data.isChecked = false
            }
        })
        this.setState({ attendeeList: attendeeList, educationRoleTypeIdErr: "" })
    }

    onEduRoleSelect(e, mode) {
        const { educationRoleTypeList, designation, educationRoleTypeId } = this.state
        var id = e.target.value
        // var id = e.target.value
        // console.log(educationRoleTypeList, e.target)

        educationRoleTypeList.length > 0 && educationRoleTypeList.map((data) => {
            if (id == data.EducationRoleTypeID) {
                if (id == 5) {
                    if (mode == 1) {
                        this.setState({ designationModal: '' })
                    } else {
                        this.setState({ designation: '', identityCardFile: '', identityCardFileType: '', identityCardFileErr: '', identityCardFileName: '' })
                    }
                } else {
                    if (mode == 1) {
                        this.setState({ designationModal: data.EducationRoleTypeName, designationErrModal: '' })
                    } else {
                        this.setState({ designation: data.EducationRoleTypeName, designationErr: '', identityCardFile: '', identityCardFileType: '', identityCardFileErr: '', identityCardFileName: '' })
                    }
                }
            }
        })
        const selectedRole = educationRoleTypeList.find(d => d.EducationRoleTypeID == id)
        if (mode == 1) {
            this.setState({ educationRoleTypeIdModal: id, educationRoleTypeIdErrModal: "" })
        } else {
            this.setState({ educationRoleTypeId: id, educationRoleTypeIdErr: "", eduRoleName: selectedRole ? selectedRole.EducationRoleTypeName : '' })
        }
        // console.log("attendeeList------->", educationRoleTypeList)
        // this.setState({ educationRoleTypeList: educationRoleTypeList, designation: '' })
    }

    // On Select Dates
    onSelectDates(e) {
        const { daysList } = this.state
        var code = e.target.value
        var checked = e.target.checked
        daysList.length > 0 && daysList.map((data) => {
            if (checked) {
                if (code == data.Code) {
                    data.isSelect = true
                }
            } else {
                if (code == data.Code) {
                    data.isSelect = false
                }

            }
        })
        console.log("hgdddhdjdjdjdkdj", daysList)
        this.setState({ daysList: daysList, daysErr: "" })
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    // On Same As Mobile No Click
    onSameAsMobNoClick(e) {
        const { isSameAsMobNo, mobNo, preMobNo } = this.state
        this.setState({ isSameAsMobNo: !isSameAsMobNo })
        var checked = e.target.checked
        if (checked) {
            this.setState({
                whatsAppMobNo: mobNo,
                preWhatsAppMobNo: preMobNo,
                whatsAppMobNoErr: ""
            })
        } else {
            this.setState({
                whatsAppMobNo: "",

            })

        }
    }

    // search state
    onStateSearch(e) {
        const { tempStateList, stateList } = this.state
        if (e.target.value != '') {
            var searchStateList = tempStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                stateId: '',
                regState: e.target.value,
                regStateErr: "",
                tempStateList: searchStateList,
                isDisplayStateList: true
            })
        } else {
            this.setState({
                stateId: '',
                regState: e.target.value,
                tempStateList: stateList,
                isDisplayStateList: false
            })
        }
    }

    // render state
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regState: data.Description, isDisplayStateList: false, stateId: data.Code })}
                        >{data.Description}</li>

                    ))
                }
            </ul>
        )
    }

    onGSTchange(value) {
        const { GSTNo, GSTNoErr, gstValidtionList, regState, stateId } = this.state
        var code = value
        console.log(code.length, 'rere', stateId)
        if (code.length >= 2) {
            var code = value.slice(0, 2)
            console.log(code.length, gstValidtionList, 'rere')
            console.log('stateId', stateId)
            for (var i = 0; i < gstValidtionList.length; i++) {
                if (stateId != '' && stateId != null) {
                    if (gstValidtionList[i].StateID == stateId) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else {
                            this.setState({
                                GSTNo: value,
                                GSTNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            GSTNo: value,
                        });
                    }
                } else {
                    if (gstValidtionList[i].StateName.trim().toLowerCase() == regState.trim().toLowerCase()) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else {
                            this.setState({
                                GSTNo: value,
                                GSTNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            GSTNo: value,
                        });
                    }
                }
                // console.log(code, gstValidtionList[i].StateID, stateId, parseInt(gstValidtionList[i].GSTCode))
            }
        }
        else {
            this.setState({
                GSTNo: value,
            });
        }
    }

    // search city
    onCitySearch(e) {
        const { cityList, tempCityList } = this.state
        if (e.target.value != '') {
            var searchCityList = tempCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                city: e.target.value,
                cityErr: "",
                tempCityList: searchCityList,
                isDisplayCityList: true
            })
        } else {
            this.setState({
                city: e.target.value,
                tempCityList: cityList,
                isDisplayCityList: false
            })
        }
    }

    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    //Pincode Search
    onPincodeSearch(e) {
        const { pincodeList, tempPincodeList, pincode } = this.state
        if (e.target.value != '') {
            var searchPincodeList = tempPincodeList.filter(data => {
                return (
                    data
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                pincode: e.target.value,
                pincodeErr: "",
                tempPincodeList: searchPincodeList,
                isDisplayPincodeList: true
            })
        } else {
            this.setState({
                pincode: e.target.value,
                tempPincodeList: pincodeList,
                isDisplayPincodeList: false
            })
        }
    }

    // render pincode
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                pincode: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    // On Primary Chapter Select
    onSelectPrimaryChapter(e) {
        const { industryChapterList } = this.state
        var id = e.target.value
        var checked = e.target.checked

        industryChapterList.length > 0 && industryChapterList.map((data) => {
            if (checked) {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = true
                }
            }
            else {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = false
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", industryChapterList)
        this.setState({ industryChapterList: industryChapterList, chapterErr: "" })
    }

    // On Purpose Select
    onSelectPurpose(e) {
        const { visitPurposeList } = this.state
        var code = e.target.value
        var checked = e.target.checked

        visitPurposeList.length > 0 && visitPurposeList.map((data) => {
            if (checked) {
                if (code == data.PurposeofVisitID) {
                    data.isSelect = true

                }
            }
            else {
                if (code == data.PurposeofVisitID) {
                    data.isSelect = false
                    data.otherDetail = ""
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", visitPurposeList)
        this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: "" })
    }

    // On PassPort Country Search
    onPassportCountrySearch(e) {
        const { passCountryList, tempPassCountryList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempPassCountryList ++++----------->", tempPassCountryList)

            var searchCoutryList = tempPassCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                passCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                passCountryErr: '',
                tempPassCountryList: searchCoutryList,
                isDisplayPassCountryList: true,
                isVisaUpdated: true
            })
        }
        else {

            this.setState({
                passCountry: e.target.value,
                tempPassCountryList: passCountryList,
                isDisplayPassCountryList: false
            })
        }
    }

    // Render Country for PassPort Country
    renderPassCountryList() {
        const { tempPassCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPassCountryList.length > 0 && tempPassCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                passCountry: data.Description, passCountryId: data.Code,
                                isDisplayPassCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On File Pick
    onFilePick = async (e, file, key) => {
        e.preventDefault()
        console.log("File01010101------", file, key)
        const { } = this.state
        this.setState({ isVisaUpdated: true })
        if (file.length != 0) {

            if (file[0]['size'] >= 5 * 1024 * 1024) {
                console.log("consdition1111111111111111111")
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    passportFile: '',
                    passPortFileName: '',
                    passportFileType: '',
                    passportFilePath: '',
                })
                document.getElementById("passportFile").value = ""
                if (key == 1) {
                    this.setState({ passportFile: "" })
                    document.getElementById("passportFile").value = ""
                } else if (key == 2) {
                    this.setState({ visitorLetterFile: "" })
                    document.getElementById("visitorLetter").value = ""
                }
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        if (key == 1) {
                            this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })

                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        if (key == 1) {
                            this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    if (key == 1) {
                        this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "", })
                    } else if (key == 2) {
                        this.setState({ visitorLetterFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    this.setState({
                        passportFile: '',
                        passPortFileName: '',
                        passportFileType: '',
                        passportFilePath: '',
                    })
                    document.getElementById("passportFile").value = ""
                    if (key == 1) {
                        this.setState({ passportFile: "" })
                        document.getElementById("passportFile").value = ""
                    } else if (key == 2) {
                        this.setState({ visitorLetterFile: "" })
                        document.getElementById("visitorLetter").value = ""
                    }
                }
            }
        } else {
            this.setState({
                passportFile: '',
                passPortFileName: '',
                passportFileType: '',
                passportFilePath: '',
            })
            document.getElementById("passportFile").value = ""
        }
    }

    // on Cross click
    onCrossClick(key) {
        const { passportFileType, isPassportFilePresent, passportFile } = this.state
        if (isPassportFilePresent) {
            const { isOpen } = this.state
            this.setState({ isOpen: !isOpen })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            if (key == 1) {
                this.setState({ passportFile: "" })
                document.getElementById("passportFile").value = ""
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
    }

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    resizeIdentityCard = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                60,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onIdentityCardFilePick = async (e) => {
        const file = e.target.files
        if (file.length > 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allowed.')
                return
            }
            const name = file[0]['name'].toString().toLowerCase()
            if (name.includes('.pdf') || name.includes('.jpeg') || name.includes('.png') || name.includes('.jpg')) {
                let result
                let fileType
                if (name.includes('.pdf')) {
                    result = await this.onPdfSelect(file[0])
                    fileType = 'pdf'
                } else {
                    result = await this.resizeIdentityCard(file[0])
                    fileType = 'image'
                }
                this.setState({ identityCardFile: result, identityCardFileType: fileType, identityCardFileName: file[0]['name'], identityCardFileErr: '' })
            } else {
                toastError('Only jpg, jpeg, png and pdf files are allowed.')
            }
        }
    }

    // On Select Interests
    onSelectInterest(e) {
        const { interestList } = this.state
        var code = e.target.value
        var checked = e.target.checked
        console.log(code, checked)
        interestList.length > 0 && interestList.map((data) => {
            if (checked) {
                if (code == data.AreaofInterestID) {
                    data.isSelect = true
                    if (code == 1) {
                        this.setState({
                            isInterstOne: true
                        })
                    } else if (code == 2) {
                        this.setState({ isInterestTwo: true })
                    }
                }
            }
            else {
                if (code == data.AreaofInterestID) {
                    data.isSelect = false
                    if (code == 1) {
                        this.setState({
                            isInterstOne: false
                        })
                    } else if (code == 2) {
                        this.setState({ isInterestTwo: false })
                    }
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", interestList)
        this.setState({ interestList: interestList })
    }

    updateVisitorEstimate() {
        const { countryId, attendeeTypeId, firstName, lastName, middleName, designation, institute, mobNo, whatsAppMobNo, city, pincode,
            email, attendeeTypeErr, daysErr, designationErr, instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, cityErr, pincodeErr,
            chapterErr, visitPurposeErr, passNameErr, applicantMobNoErr, applicantEmailErr, passNoErr, passDateErr, passExipryDateErr,
            passCountryErr, passportFileErr, isAgree, preName, isSameAsMobNo, regState, website, telNo, tel1No, needVisaAssistance,
            passName, applicantEmail, applicantMobNo, passNo, passDate, passExipryDate, passCountryId, passportFile, remarks, daysList,
            level1, visitPurposeList, interestList, preMobNo, preWhatsAppMobNo, preTelNo, preTel1No, preApplicantMobNo, passportFileType,
            isVisaUpdated, seminarInterestList, leaderErr, delegationCountryErr, arrivalDateErr, departureDateErr, delegationRemarkErr,
            preffDateErr, preffTimeErr, isInterstOne, isGrpDelegation, leader, delegationCountryId, arrivalDate, departureDate,
            delegationRemark, prefTime, preffDate, industryChapterList, b2bRemark, b2bRemarkErr, isCarParking, isParkingAvailable,
            isParkingChargable, parkingCharges, educationRoleTypeId, educationRoleTypeIdErr, isPaid, ChapterHallErr, primaryChapterListData, level2, level3, level4, isVisitorSelect, pricingList, isInvoice, INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
        } = this.state

    }

    // On Update Click
    onUpdate(e, flag, flag2) {
        e != undefined && e.preventDefault()
        this.inputValidate()

        setTimeout(async () => {
            const { countryId, attendeeTypeId, firstName, lastName, middleName, designation, PIID, institute, mobNo, whatsAppMobNo, city, pincode,
                email, attendeeTypeErr, daysErr, designationErr, instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, cityErr, pincodeErr,
                chapterErr, visitPurposeErr, passNameErr, applicantMobNoErr, applicantEmailErr, passNoErr, passDateErr, passExipryDateErr,
                passCountryErr, passportFileErr, isAgree, preName, isSameAsMobNo, regState, website, telNo, tel1No, needVisaAssistance,
                passName, applicantEmail, applicantMobNo, passNo, passDate, passExipryDate, passCountryId, passportFile, remarks, daysList,
                level1, visitPurposeList, interestList, preMobNo, preWhatsAppMobNo, preTelNo, preTel1No, preApplicantMobNo, passportFileType,
                isVisaUpdated, seminarInterestList, leaderErr, delegationCountryErr, arrivalDateErr, departureDateErr, delegationRemarkErr,
                preffDateErr, preffTimeErr, isInterstOne, isGrpDelegation, leader, delegationCountryId, arrivalDate, departureDate,
                delegationRemark, prefTime, preffDate, industryChapterList, b2bRemark, b2bRemarkErr, isCarParking, isParkingAvailable,
                isParkingChargable, parkingCharges, educationRoleTypeId, educationRoleTypeIdErr, isPaid, ChapterHallErr, primaryChapterListData, level2, level3, level4, isVisitorSelect, pricingList, isInvoice, INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo,
                INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
            } = this.state


            /// Setting data in session storage For Insert Next
            sessionStorage.setItem("sessionrPreMobNo", preMobNo)
            sessionStorage.setItem("sessionrPreWhatsappMobNo", preWhatsAppMobNo)
            sessionStorage.setItem("sessionrPreTelNo", preTelNo)
            sessionStorage.setItem("sessionrPreTel1No", preTel1No)
            sessionStorage.setItem("sessionrPreApplicantMobNo", preApplicantMobNo)
            // preparing Selected Days for udt
            const selectedDays = daysList.filter(data => data.isSelect == true)
            var dateList = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                dateList.push(data)
            })
            const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
            var seminarInterestListData = []
            selectedSeminarList.map((data) => {
                if (data.isSelect) {
                    // } else {
                    var data = {
                        "SeminarID": data.SeminarID,
                    }
                    seminarInterestListData.push(data)
                }
            })
            var toreturn = true
            var visitDaysNoArr = []
            if (isInterstOne && seminarInterestListData.length == 0) {
                toastError("Please select atleast 1 seminar")
                return
            }
            if (pricingList.length != 0) {
                for (var i = 0; i < pricingList.length; i++) {
                    visitDaysNoArr.push(pricingList[i].VisitDays)
                    if (pricingList[i].VisitDays == dateList.length) {
                        toreturn = false
                        break
                    }
                }
                if (toreturn) {
                    toastError(`Visit pass only allowed for ${visitDaysNoArr.toString()} days`)
                    // modalErr = false
                    return
                }
            }
            // Preparing Udt For Chapter List
            const selectedChapter = industryChapterList.filter(data => data.IsSelect == true)
            var chapterList = []
            selectedChapter.map((data) => {
                var data = {
                    "ChapterID": data.IndustrySegmentID,
                    "ChapterNames": data['Industrial Segment']
                }
                chapterList.push(data)
            })
            // Preparing Udt For Hall Chapter List
            var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
            var filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
            var chapterListData2 = []
            filerArray.map((data) => {
                var data = {
                    "ChapterID": data.ChapterID,
                    "ChapterNames": data.ChapterName
                }
                chapterListData2.push(data)
            })
            // Preparing Udt For Purpose Of Visit List
            const selectedVisitPurposeList = visitPurposeList.filter(data => data.isSelect == true)
            var purposeList = []
            selectedVisitPurposeList.map((data) => {
                var data = {
                    "PurposeOfVisitID": data.PurposeofVisitID,
                    "OtherDetails": data.otherDetail
                }
                purposeList.push(data)
            })
            var otherPOV = false
            purposeList.map((data) => {
                otherPOV = data.PurposeofVisitID == 10 && data.OtherDetails == '' || data.OtherDetails == null ? true : false
                console.log('datadatadata', data)
                // var data = {
                //     "PurposeofVisitID": data.PurposeofVisitID,
                //     "OtherDetails": data.otherDetail
                // }
                // purposeOfVisitlistData.push(data)
            })
            console.log('datadatadata', otherPOV)
            if (otherPOV) {
                console.log("purposeList")
                this.setState({ visitPurposeErr: "Please enter other purpose of visit" })
                // Err = false
            }

            // Preparing Udt For Interest List
            const selectedInterestList = interestList.filter(data => data.isSelect == true)
            var interestListData = []
            selectedInterestList.map((data) => {
                var data = {
                    "AreaOfInterestID": data.AreaofInterestID,
                }
                interestListData.push(data)
            })
            // Preparing Udt For Seminar Interest List

            if (attendeeTypeId == 3) {
                if (educationRoleTypeId == '' || educationRoleTypeId == null) {
                    this.setState({ educationRoleTypeIdErr: "Please Select Education Role Type" });
                }
            }
            if (attendeeTypeId != "" && designation != "" && institute != "" && !otherPOV && (attendeeTypeId == 3 ? educationRoleTypeId != "" : true) &&
                mobNo != "" && whatsAppMobNo != "" && city != "" && pincode != "" && email != "") {
                if (attendeeTypeErr == "" && daysErr == "" && designationErr == "" && instituteErr == "" && chapterErr == "" && visitPurposeErr == "" && educationRoleTypeIdErr == ""
                    && passNameErr == "" && applicantMobNoErr == "" && applicantEmailErr == "" && passNoErr == "" && passDateErr == "" && passExipryDateErr == "" &&
                    passCountryErr == "" && passportFileErr == "" && leaderErr == "" && delegationCountryErr == "" && arrivalDateErr == "" &&
                    departureDateErr == "" && delegationRemarkErr == "" && preffDateErr == "" && preffTimeErr == "" && ChapterHallErr == "") {
                    // if (isInterstOne ? seminarInterestList.some(obj => obj.isSelect) : true) {
                    var isInvoiceErr = false
                    if (isInvoice) {
                        if (INVPersonName == '' || INVCompanyName == '' || INVAddress == '' || INVTanNo == '' || GSTNo == '' || PANNo == '' || INVPersonName == null || INVCompanyName == null || INVAddress == null || INVTanNo == null || GSTNo == null || PANNo == null) {
                            isInvoiceErr = true
                        }
                        if (INVPersonNameErr != '' || INVCompanyNameErr != '' || INVAddressErr != '' || INVTanNoErr != '' || GSTNoErr != '' || PANNoErr != '') {
                            isInvoiceErr = true
                        }
                    }
                    if (isInvoiceErr) {
                        toastError("Enter Mandatory Fields")
                    } else {
                        if (isAgree) {
                            this.setState({ isLoading: true })
                            var toEstimate = false
                            if (this.state.isCoordinator) {

                            } else {
                                for (var i = 0; i < daysList.length; i++) {
                                    if (((daysList[i].isSelect && !daysList[i].isReadOnly) || daysList[i].isPending)) {
                                        toEstimate = true
                                        break
                                    }
                                }
                            }
                            for (var i = 0; i < seminarInterestList.length; i++) {
                                if (((seminarInterestList[i].isSelect && !seminarInterestList[i].isReadOnly) || seminarInterestList[i].isPending)) {
                                    if (seminarInterestList[i].isSelect && seminarInterestList[i].SeminarTypeID == 3) {
                                        toEstimate = true
                                        break
                                    }
                                }
                            }
                            // for (var i = 0; i < seminarInterestList.length; i++) {
                            //     // selectedSeminarList.map((data) => {
                            //     if (seminarInterestList[i].isSelect) {
                            //         var isIncluded = false
                            //         this.state.daysList.map((data2) => {
                            //             if (data2.VisitDate == moment.utc(seminarInterestList[i].Date).format("DD MMM YYYY")) {
                            //                 if (data2.isSelect) {
                            //                     isIncluded = true
                            //                 } else {
                            //                     data2.isSelect = true
                            //                     toEstimate = true
                            //                 }
                            //             }
                            //         })
                            //         // if (!isIncluded) {
                            //         //     this.state.daysList.map((data2) => {
                            //         //     })
                            //         // }
                            //     }
                            //     // })
                            // }
                            // this.setState({ daysList: this.state.daysList })
                            // setTimeout(() => {
                            //     console.log(this.state.daysList, seminarInterestList)
                            // }, 200);
                            // return
                            if (toEstimate && flag != 1 && this.state.isIndi) {
                                var updatedVisitorDaysList = []
                                var updatedseminarInterestList = []

                                if (this.state.isCoordinator) {

                                } else {
                                    for (var i = 0; i < daysList.length; i++) {
                                        if (daysList[i].isSelect) {
                                            updatedVisitorDaysList.push({
                                                "visitDay": daysList[i].VisitDate,
                                                "isPaid": daysList[i].isPending ? 0 : daysList[i].isReadOnly ? 1 : 0,
                                                "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                                            })
                                        }
                                    }
                                    for (var i = 0; i < seminarInterestList.length; i++) {
                                        // if (seminarInterestList[i].isReadOnly) {
                                        if (seminarInterestList[i].isSelect && seminarInterestList[i].SeminarTypeID == 3) {
                                            updatedseminarInterestList.push({
                                                "SeminarID": seminarInterestList[i].SeminarID,
                                                "isPaid": seminarInterestList[i].isPending ? 0 : seminarInterestList[i].isReadOnly ? 1 : 0,
                                                // "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                                            })
                                            var isIncluded = false
                                            updatedVisitorDaysList.map((data2) => {
                                                if (data2.visitDay == moment.utc(seminarInterestList[i].Date).format("DD MMM YYYY")) {
                                                    isIncluded = true
                                                }
                                            })
                                            if (!isIncluded) {
                                                updatedVisitorDaysList.push({ ExhVisitorID: JSON.parse(sessionStorage.getItem("VisitorDataSS")).ExhVisitorID, visitDay: moment.utc(seminarInterestList[i].Date).format("DD MMM YYYY"), "isPaid": 0, })
                                            }
                                        }
                                        // }
                                    }
                                }
                                console.log("nononono", updatedVisitorDaysList, daysList)
                                this.props.updateVisitorEstimate_action(updatedVisitorDaysList, false, updatedseminarInterestList)
                                    .then((data) => {
                                        if (data.error != 1) {
                                            this.setState({ isLoading: false, isRegistrationComplete: true })
                                            // sessionStorage.setItem('isRegistrationComplete', 1)
                                            // this.getVisitorRegistrationDetails()
                                            for (var i = 0; i < data.data[0].length; i++) {
                                                if (data.data[0][i].Narration == 'Total Taxable') {
                                                    this.setState({ totaltaxable: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration.split(" ")[0].trim() == 'Seminar') {
                                                    this.setState({ seminarCharges: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration == 'Grand Total') {
                                                    this.setState({ totalCharges: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
                                                    this.setState({ visitorCharges: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration == 'CGST') {
                                                    this.setState({ CGST: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration == 'SGST') {
                                                    this.setState({ SGST: data.data[0][i].TotalAmt })
                                                }
                                                if (data.data[0][i].Narration == 'IGST') {
                                                    this.setState({ IGST: data.data[0][i].TotalAmt })
                                                }
                                            }
                                            setTimeout(() => {
                                                this.setState({
                                                    toShow: this.state.totalCharges,
                                                    additionalChargesUSD: ((this.state.additionalChargesUSDper / 100) * this.state.totalCharges).toFixed(2),
                                                    // conversionRate: data.data['registrationDetails'][0].ConversionRate,
                                                    // additionalChargesUSDper: data.data['registrationDetails'][0].additionalChargesUSD,
                                                })
                                                this.setState({
                                                    // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                                                    estimatePop: true,
                                                    repayPOP: false,
                                                    cancelPOP: false
                                                })
                                            }, 200);
                                        } else {
                                            this.setState({ isLoading: false })
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err)
                                    })
                            } else {
                                var updatedVisitorDaysList = []
                                var updatedseminarInterestListData = []
                                if (flag == 1) {
                                    for (var i = 0; i < daysList.length; i++) {
                                        if (daysList[i].isSelect) {
                                            updatedVisitorDaysList.push({
                                                "visitDay": daysList[i].VisitDate,
                                                "isPaid": daysList[i].isPending ? 0 : daysList[i].isReadOnly ? 1 : 0,
                                                "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                                            })
                                        }
                                    }
                                    // const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
                                    for (var i = 0; i < seminarInterestList.length; i++) {
                                        if (seminarInterestList[i].isSelect) {
                                            // } else {
                                            var data = {
                                                "SeminarID": seminarInterestList[i].SeminarID,
                                                "isPaid": seminarInterestList[i].SeminarTypeID == 3 ? seminarInterestList[i].isPending ? 0 : seminarInterestList[i].isReadOnly ? 1 : 0 : 0,
                                            }
                                            var isIncluded = false
                                            var neDate = ''
                                            updatedVisitorDaysList.map((data2) => {
                                                if (data2.visitDay == moment.utc(seminarInterestList[i].Date).format("DD MMM YYYY")) {
                                                    isIncluded = true
                                                }
                                            })
                                            if (!isIncluded) {
                                                updatedVisitorDaysList.push({ ExhVisitorID: JSON.parse(sessionStorage.getItem("VisitorDataSS")).ExhVisitorID, visitDay: moment.utc(seminarInterestList[i].Date).format("DD MMM YYYY"), "isPaid": 0, })
                                            }
                                            updatedseminarInterestListData.push(data)
                                        }
                                    }
                                } else {
                                    dateList.map(item => {
                                        item.isPaid = 1
                                    })
                                    updatedVisitorDaysList = dateList
                                    seminarInterestListData.map(item => {
                                        item.isPaid = 1
                                    })
                                    updatedseminarInterestListData = seminarInterestListData
                                }
                                // var updatedSeminarList = []
                                // if (flag == 1) {
                                //     for (var i = 0; i < seminarInterestList.length; i++) {
                                //         if (seminarInterestList[i].isSelect) {
                                //             updatedSeminarList.push({
                                //                 "SeminarID": seminarInterestList[i].SeminarID,
                                //                 "isPaid": seminarInterestList[i].SeminarTypeID == 3 ? seminarInterestList[i].isPending ? 0 : seminarInterestList[i].isReadOnly ? 1 : 0 : 0,
                                //                 "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                                //             })
                                //         }
                                //     }
                                // } else {
                                //     seminarInterestList.map(item => {
                                //         item.isPaid = item.SeminarTypeID == 3 ? 1 : 0
                                //     })
                                //     updatedSeminarList = seminarInterestList
                                // }
                                if (PIID != '' && PIID != null) {
                                    await this.onCancelPayment(1)
                                }
                                setTimeout(() => {
                                    console.log(this.state.daysList, updatedVisitorDaysList, updatedseminarInterestListData)
                                }, 200);
                                this.props.visitorRegistrationUpdate_action(countryId, attendeeTypeId, preName, firstName, middleName, lastName, designation,
                                    institute, mobNo, whatsAppMobNo, isSameAsMobNo, city, regState, pincode, website, email, telNo, tel1No, needVisaAssistance,
                                    passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate, passCountryId, passportFile, remarks,
                                    isAgree, this.state.isCoordinator ? [] : updatedVisitorDaysList, chapterList, purposeList, interestListData, passportFileType, isVisaUpdated, isGrpDelegation,
                                    leader, delegationCountryId, arrivalDate, departureDate, delegationRemark, preffDate, prefTime,
                                    updatedseminarInterestListData, b2bRemark, isCarParking, parkingCharges, chapterListData2, isVisitorSelect == true ? true : false, this.state.isInterestTwo, this.state.isInterstOne, attendeeTypeId == 3 ? educationRoleTypeId : '',
                                    this.state.identityCardFile, this.state.identityCardFileType, this.state.identityCardPath ? this.state.identityCardPath.replace(DOC_BASE_URL, '') : '')
                                    .then((data) => {
                                        if (data.error != 1) {
                                            this.setState({ isLoading: false, isRegistrationComplete: true })
                                            sessionStorage.setItem('isRegistrationComplete', 1)
                                            // console.log(data.data[6][0].ProformaInvoiceID, 'data.data[6][0].ProformaInvoiceID')
                                            if (flag == 1) {
                                                console.log(data.data[6] != undefined, data.data[6][0] != undefined, data.data[6][0].ProformaInvoiceID != undefined)
                                                if (data.data[6] != undefined && data.data[6][0] != undefined && data.data[6][0].ProformaInvoiceID != undefined) {
                                                    this.setState({ PIID: data.data[6][0].ProformaInvoiceID }, () => {
                                                        // if (this.state.totalCharges != null && this.state.totalCharges != '') {
                                                        this.navToPayment()
                                                        // }
                                                    })
                                                }
                                            } else {
                                                console.log("tor Registration Update", flag)
                                                this.getVisitorRegistrationDetails()
                                                toastSuccess("Visitor Registration Updated")
                                            }
                                            // if (isParkingAvailable && isParkingChargable && parkingCharges > 0 && isCarParking == 1 &&
                                            //     !isPaid) {
                                            //     this.navToPayment()
                                            // } else {
                                            //     toastSuccess("Visitor Registration Updated")
                                            // }
                                        } else {
                                            this.setState({ isLoading: false })
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err)
                                    })
                            }
                        }
                        else {
                            toastError("Please Accept Terms & Conditions")
                        }
                    }
                    // } else {
                    //     toastError("Please Select atleast one Seminar")
                    // }
                }
                else {
                    toastError("Please Fill Mandatory Input Fields")
                }
            }
            else {
                toastError("Please Fill Mandatory Input Fields")
            }
        }, 500);
    }

    // Nav To Payment
    navToPayment() {
        const { parkingCharges, visitorList, countryId, VisitorTypeID, remark, visitorCharges, isCarParking, promoCodeDiscount, toPay, totalCharges } = this.state
        // const totalCharges = visitorCharges + (isCarParking ? parkingCharges : 0) - promoCodeDiscount

        var cancel_url = `${BASE_URL}/visitor/paymentResponse`
        var redirect_url = `${BASE_URL}/visitor/paymentResponse`;//need to ask to redirect

        var request = {
            order_id: `${JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID}`,
            currency: `${countryId == 91 ? 'INR' : 'USD'}`,
            amount: `${totalCharges}`,
            redirect_url: `${redirect_url}`,
            cancel_url: `${redirect_url}`,
            merchant_param1: `${'1'}`,
            language: `EN`
        }

        var mapData = {
            'orderParams': request
        }

        // this.props.payment_action(mapData)
        //     .then((data) => {
        //         if (data != null) {
        //             console.log("payment response : ", data)
        //             this.setState({ encPayload: data.data })
        //             setTimeout(() => {
        //                 console.log("submit form", this.submitfrm)
        //                 this.submitfrm.current.submit()
        //                 // this.props.navigate('/payment', { state: { encPayload: this.state.encPayload, } })
        //             }, 1000);
        //         } else {
        //             this.setState({ isLoading: false })
        //             toast.error('There is some problem. Please try again later!', {
        //                 theme: 'colored',
        //                 autoClose: 3000,
        //                 hideProgressBar: true,
        //             })
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err)
        //     })
        var moreInfo = null
        this.setState({ isLoading: true })
        var exhIds = []
        var accids = []
        for (var i = 0; i < visitorList.length; i++) {
            exhIds.push(visitorList[i].ExhVisitorID)
            accids.push(visitorList[i].AccountID)
        }
        var exhIdsstr = exhIds.length > 0 ? exhIds.toString() : ''
        var accidsstr = accids.length > 0 ? accids.toString() : ''
        this.props.sendPaymentForm_action(sessionStorage.getItem("sessionExhibitionID"),
            VisitorTypeID == 2 ? exhIdsstr : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID,
            countryId == 91 ? totalCharges : this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2),
            // 100,
            countryId == 91 ? 'INR' : 'USD', [{ ProformaInvoiceID: this.state.PIID }], 'visitorForm', moreInfo, remark, VisitorTypeID == 2 ? accidsstr : JSON.parse(sessionStorage.getItem('VisitorDataSS')).AccountID, sessionStorage.getItem("userEmailSS"), countryId == 91 ? false : this.state.isPaidByUSD)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data != null) {
                        console.log("payment response : ", data)

                        // this.setState({ encPayload: data.data }, () => {
                        //     this.submitfrm.current.submit()
                        // })
                        this.setState({ paymentLink: data.data }, () => {
                            // this.submitfrm.current.submit()
                            // window.open(data.data, '_blank')
                            window.location.replace(data.data)

                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError('There is some problem. Please try again later!')
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Get Visitor Registration Details
    getVisitorRegistrationDetails() {
        setTimeout(() => {
            const { attendeeList, daysList, visitorTypeList, industryChapterList, visitPurposeList, interestList, seminarInterestList, primaryChapterListData,
                level2, level3, level4, isVisitorSelect } = this.state
            // this.setState({ isLoading: true })
            this.props.combineVisitorRegistrationDetail2_action(this.state.AccountID, this.state.ExhVisitorID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({})
                        daysList.length > 0 && daysList.map((item) => {
                            item.isSelect = false
                        })
                        industryChapterList.length > 0 && industryChapterList.map((item) => {
                            item.IsSelect = false
                        })
                        primaryChapterListData.length > 0 && primaryChapterListData.map((item) => {
                            item.IsSelect = false
                        })
                        level2.length > 0 && level2.map((item) => {
                            item.IsSelect = false
                        })
                        level3.length > 0 && level3.map((item) => {
                            item.IsSelect = false
                        })
                        level4.length > 0 && level4.map((item) => {
                            item.IsSelect = false
                        })
                        interestList.length > 0 && interestList.map((item) => {
                            item.isSelect = false
                        })
                        seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                            data.isSelect = false
                        })
                        this.setState({ isInterstOne: false })
                        this.setState({ isInterestTwo: false })

                        this.setState({
                            countryId: '',
                            attendeeTypeId: '',
                            // attendeeList: attendeeList,
                            daysList: daysList,
                            preName: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            designation: '',
                            institute: '',
                            preMobNo: '',
                            mobNo: '',
                            preWhatsAppMobNo: '',
                            whatsAppMobNo: '',
                            isSameAsMobNo: '',
                            regState: '',
                            city: '',
                            pincode: '',
                            website: '',
                            email: '',
                            preTelNo: '',
                            telNo: '',
                            preTel1No: '',
                            tel1No: '',
                            industryChapterList: industryChapterList,
                            // visitPurposeList: visitPurposeList,
                            primaryChapterListData: primaryChapterListData,
                            level2: level2,
                            level3: level3,
                            level4: level4,
                            needVisaAssistance: '',
                            passName: '',
                            preApplicantMobNo: '',
                            applicantMobNo: '',
                            applicantEmail: '',
                            passNo: '',
                            passDate: '',
                            passExipryDate: '',
                            passCountry: '',
                            passCountryId: '',
                            passportFile: '',
                            interestList: interestList,
                            remarks: '',
                            isAgree: '',
                            isVisaApplied: false,
                            isPassportFilePresent: false,
                            isGrpDelegation: false,
                            leader: "",
                            delegationCountry: "",
                            delegationCountryId: "",
                            arrivalDate: '',
                            departureDate: '',
                            delegationRemark: "",
                            preffDate: '',
                            prefTime: "",
                            b2bRemark: "",
                            isParkingAvailable: "",
                            isParkingChargable: false,
                            parkingCharges: 0,
                            isCarParking: 0,
                            isPaid: 0,
                            seminarInterestList: seminarInterestList,
                            // isLoading: false,
                        })


                        console.log("getVisitorRegistrationDetails", data.data['registrationDetails'][0])
                        // Updating Attendee List
                        var attendeeId = data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : ''
                        attendeeList.length > 0 && attendeeList.map((item) => {
                            if (item.AttendeeTypeID == attendeeId) {
                                item.isChecked = true
                            }
                        })
                        // Days List Prepare on basis on get Days list
                        var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                        daysList.length > 0 && daysList.map((item) => {
                            selectedDaysList.length > 0 && selectedDaysList.map((element) => {
                                if (element.VisitDate == item.VisitDate) {
                                    item.isSelect = true
                                    item.isReadOnly = true
                                }
                            })
                        })
                        console.log("selectedDaysListselectedDaysListselectedDaysList", selectedDaysList)

                        // Split Phone Numbers and country Code 
                        //  Mobile No
                        var mob1 = data.data['registrationDetails'][0]['MobileNo']
                        const parts = splitPhoneValue(mob1);
                        const Mob1Code = parts[0]
                        const Mob1No = parts[1]
                        // WhatsApp Mobile No
                        var mob2 = data.data['registrationDetails'][0]['WhatsappNo']
                        const parts2 = splitPhoneValue(mob2)
                        const Mob2Code = parts2[0]
                        const Mob2No = parts2[1]
                        // TelePhone No
                        var tel = data.data['registrationDetails'][0]['Telephone']
                        const parts3 = splitPhoneValue(tel)
                        const telCode = parts3[0]
                        const telNumber = parts3[1]
                        // Telephone 1 Mobile No
                        var tel1 = data.data['registrationDetails'][0]['Telephone1']
                        const parts4 = splitPhoneValue(tel1)
                        const tel1Code = parts4[0]
                        const tel1Number = parts4[1]
                        // Chapter List Prepare on basis on get Days list
                        var selectedChapters = data.data['chapterList'] != null ? data.data['chapterList'] : []
                        industryChapterList.length > 0 && industryChapterList.map((item) => {
                            selectedChapters.length > 0 && selectedChapters.map((element) => {
                                if (element.ChapterID == item.IndustrySegmentID) {
                                    item.IsSelect = true
                                }
                            })
                        })
                        // Hall Chapter List prepare 
                        var SelectedHallChapters = data.data['hallChapterList'] != null ? data.data['hallChapterList'] : []
                        primaryChapterListData.length > 0 && primaryChapterListData.map((item) => {
                            SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                                if (element.MappingChapterID == item.ChapterID) {
                                    item.IsSelect = true
                                }
                            })
                        })
                        level2.length > 0 && level2.map((item) => {
                            SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                                if (element.MappingChapterID == item.ChapterID) {
                                    item.IsSelect = true
                                }
                            })
                        })
                        level3.length > 0 && level3.map((item) => {
                            SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                                if (element.MappingChapterID == item.ChapterID) {
                                    item.IsSelect = true
                                }
                            })
                        })
                        level4.length > 0 && level4.map((item) => {
                            SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                                if (element.MappingChapterID == item.ChapterID) {
                                    item.IsSelect = true
                                }
                            })
                        })


                        // visit Purpose List Prepare on basis on get Days list
                        var selectedVisitPurpose = data.data['visitPurposeList'] != null ? data.data['visitPurposeList'] : []
                        visitPurposeList.length > 0 && visitPurposeList.map((item) => {
                            selectedVisitPurpose.length > 0 && selectedVisitPurpose.map((element) => {
                                if (element.PurposeofVisitID == item.PurposeofVisitID) {
                                    item.isSelect = true
                                    item.otherDetail = element.OtherDetails
                                }
                            })
                        })
                        // Applicant Mobile No
                        var appMobNo = data.data['registrationDetails'][0]['ApplicantMobileNo']
                        var parts5 = '';
                        var appMobCode = '';
                        var appMobileNo = '';
                        if (appMobNo != null && appMobNo != '') {
                            parts5 = appMobNo.includes('-') && appMobNo.split("-")
                            appMobCode = parts5[0]
                            appMobileNo = parts5[1]
                        }

                        // Area Of Interest  List Prepare on basis on get Days list
                        var selectedInterest = data.data['areaOfInterestList'] != null ? data.data['areaOfInterestList'] : []
                        interestList.length > 0 && interestList.map((item) => {
                            selectedInterest.length > 0 && selectedInterest.map((element) => {
                                if (element.AreaofInterestID == 1) {
                                    this.setState({ isInterstOne: true })
                                } else if (element.AreaofInterestID == 2) {
                                    this.setState({ isInterestTwo: true })
                                }
                                if (element.AreaofInterestID == item.AreaofInterestID) {
                                    item.isSelect = true
                                }
                            })
                        })

                        // var selectedInterest = data.data['areaOfInterestList'] != null ? data.data['areaOfInterestList'] : []
                        interestList.length > 0 && interestList.map((item) => {
                            //     selectedInterest.length > 0 && selectedInterest.map((element) => {
                            if (item.AreaofInterestID == 1 && data.data['registrationDetails'][0].IsInterestedforSeminar) {
                                this.setState({ isInterstOne: true })
                            } else if (item.AreaofInterestID == 2 && data.data['registrationDetails'][0].IsInterestedforb2b) {
                                this.setState({ isInterestTwo: true })
                            }
                            //         if (element.AreaofInterestID == item.AreaofInterestID) {
                            //             item.isSelect = true
                            //         }
                            //     })
                        })

                        // Seminar Interest List Prepare on Basis on get Days list 
                        var selectedSeminarList = data.data['seminarInterestList'] != null ? data.data['seminarInterestList'] : []
                        seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                            selectedSeminarList.length > 0 && selectedSeminarList.map((item) => {
                                if (item.SeminarID == data.SeminarID) {
                                    data.isReadOnly = true
                                    data.isSelect = true
                                }
                            })
                        })

                        // visitorTypeList.length > 0 && visitorTypeList.map(item => {
                        //     item.VisitorType == data.data['registrationDetails'][0]['VisitorType'] && this.setState({ VisitorTypeID: item.VisitorTypeID })
                        // })

                        var filePath = data.data['registrationDetails'][0]['PassportFilePath'] != null ? data.data['registrationDetails'][0]['PassportFilePath'] : ''
                        var array = data.data['registrationDetails'][0]['PassportFilePath'] != null &&
                            data.data['registrationDetails'][0]['PassportFilePath'] != "" && filePath.split("/")
                        const FileName = array[array.length - 1]

                        this.setState({ passPortFileName: FileName })


                        this.setState({
                            VisitorTypeID: data.data['registrationDetails'][0].VisitorTypeID ?? '',
                            countryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                            attendeeTypeId: data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : '',
                            attendeeList: attendeeList,
                            daysList: daysList,
                            preName: data.data['registrationDetails'][0]['Title'] != null ? data.data['registrationDetails'][0]['Title'] : '',
                            firstName: data.data['registrationDetails'][0]['FirstName'] != null ? data.data['registrationDetails'][0]['FirstName'] : '',
                            middleName: data.data['registrationDetails'][0]['MiddleName'] != null ? data.data['registrationDetails'][0]['MiddleName'] : '',
                            lastName: data.data['registrationDetails'][0]['LastName'] != null ? data.data['registrationDetails'][0]['LastName'] : '',
                            designation: data.data['registrationDetails'][0]['Designation'] != null ? data.data['registrationDetails'][0]['Designation'] : '',
                            institute: data.data['registrationDetails'][0]['Institute_Organisation'] != null ? data.data['registrationDetails'][0]['Institute_Organisation'] : '',
                            preMobNo: Mob1Code,
                            mobNo: Mob1No,
                            preWhatsAppMobNo: Mob2Code,
                            whatsAppMobNo: Mob2No,
                            isSameAsMobNo: data.data['registrationDetails'][0]['IsSameAsMobileNo'] != null ? data.data['registrationDetails'][0]['IsSameAsMobileNo'] : '',
                            regState: data.data['registrationDetails'][0]['State'] != null ? data.data['registrationDetails'][0]['State'] : '',
                            city: data.data['registrationDetails'][0]['City'] != null ? data.data['registrationDetails'][0]['City'] : '',
                            pincode: data.data['registrationDetails'][0]['Pincode'] != null ? data.data['registrationDetails'][0]['Pincode'] : '',
                            website: data.data['registrationDetails'][0]['Website'] != null ? data.data['registrationDetails'][0]['Website'] : '',
                            email: data.data['registrationDetails'][0]['Email'] != null ? data.data['registrationDetails'][0]['Email'] : '',
                            preTelNo: telCode,
                            telNo: telNumber,
                            preTel1No: tel1Code,
                            tel1No: tel1Number,
                            industryChapterList: industryChapterList,
                            visitPurposeList: visitPurposeList,
                            primaryChapterListData: primaryChapterListData,
                            level2: level2,
                            level3: level3,
                            level4: level4,
                            needVisaAssistance: data.data['registrationDetails'][0]['isVisaAssistance'] != null ? data.data['registrationDetails'][0]['isVisaAssistance'] : '',
                            passName: data.data['registrationDetails'][0]['NameOnPassport'] != null ? data.data['registrationDetails'][0]['NameOnPassport'] : '',
                            preApplicantMobNo: appMobCode,
                            applicantMobNo: appMobileNo,
                            applicantEmail: data.data['registrationDetails'][0]['ApplicantEmailID'] != null ? data.data['registrationDetails'][0]['ApplicantEmailID'] : '',
                            passNo: data.data['registrationDetails'][0]['PassportNo'] != null ? data.data['registrationDetails'][0]['PassportNo'] : '',
                            passDate: data.data['registrationDetails'][0]['PassportIssueDate'] != null ? new Date(data.data['registrationDetails'][0]['PassportIssueDate']) : '',
                            passExipryDate: data.data['registrationDetails'][0]['PassportExpiryDate'] != null ? new Date(data.data['registrationDetails'][0]['PassportExpiryDate']) : '',
                            passCountry: data.data['registrationDetails'][0]['PassportIssuingCountryName'] != null ? data.data['registrationDetails'][0]['PassportIssuingCountryName'] : '',
                            passCountryId: data.data['registrationDetails'][0]['PassportIssuingCountryID'] != null ? data.data['registrationDetails'][0]['PassportIssuingCountryID'] : '',
                            passportFile: data.data['registrationDetails'][0]['PassportFilePath'] != null ? data.data['registrationDetails'][0]['PassportFilePath'] : '',
                            interestList: interestList,
                            remarks: data.data['registrationDetails'][0]['Remarks'] != null ? data.data['registrationDetails'][0]['Remarks'] : '',
                            isAgree: data.data['registrationDetails'][0]['ISAgree'] != null ? data.data['registrationDetails'][0]['ISAgree'] : '',
                            isVisaApplied: data.data['registrationDetails'][0]['isVisaAssistance'] != null ? data.data['registrationDetails'][0]['isVisaAssistance'] : false,
                            isPassportFilePresent: data.data['registrationDetails'][0]['PassportFilePath'] != null && data.data['registrationDetails'][0]['PassportFilePath'] != "" ? true : false,
                            isGrpDelegation: data.data['registrationDetails'][0]['IsGroupDelegation'] != null ? data.data['registrationDetails'][0]['IsGroupDelegation'] : false,
                            leader: data.data['registrationDetails'][0]['DelegationName'] != null ? data.data['registrationDetails'][0]['DelegationName'] : "",
                            delegationCountry: data.data['registrationDetails'][0]['DelegationCountryName'] != null ? data.data['registrationDetails'][0]['DelegationCountryName'] : "",
                            delegationCountryId: data.data['registrationDetails'][0]['DelegationCountryID'] != null ? data.data['registrationDetails'][0]['DelegationCountryID'] : "",
                            arrivalDate: data.data['registrationDetails'][0]['DelegationArrivalDate'] != null ? new Date(data.data['registrationDetails'][0]['DelegationArrivalDate']) : '',
                            departureDate: data.data['registrationDetails'][0]['DelegationDepartureDate'] != null ? new Date(data.data['registrationDetails'][0]['DelegationDepartureDate']) : '',
                            delegationRemark: data.data['registrationDetails'][0]['DelegationRemark'] != null ? data.data['registrationDetails'][0]['DelegationRemark'] : "",
                            educationRoleTypeId: data.data['registrationDetails'][0]['EducationRoleTypeID'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeID'] : '',
                            eduRoleName: data.data['registrationDetails'][0]['EducationRoleTypeName'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeName'] : '',
                            identityCardPath: data.data['registrationDetails'][0]['IdentityCardPath'] != null && data.data['registrationDetails'][0]['IdentityCardPath'] != '' ? `${DOC_BASE_URL}${data.data['registrationDetails'][0]['IdentityCardPath']}` : '',
                            preffDate: data.data['registrationDetails'][0]['B2BDepartureDate'] != null ? new Date(data.data['registrationDetails'][0]['B2BDepartureDate']) : '',
                            prefTime: data.data['registrationDetails'][0]['B2BPreferredTime'] != null ? data.data['registrationDetails'][0]['B2BPreferredTime'] : "",
                            b2bRemark: data.data['registrationDetails'][0]['B2BRemark'] != null ? data.data['registrationDetails'][0]['B2BRemark'] : "",
                            isParkingAvailable: data.data['registrationDetails'][0]['CarparkingAvailable'] != null ? data.data['registrationDetails'][0]['CarparkingAvailable'] : "",
                            isParkingChargable: data.data['registrationDetails'][0]['ParkingChargable'] != null ? data.data['registrationDetails'][0]['ParkingChargable'] : false,
                            parkingCharges: data.data['registrationDetails'][0]['ParkingCharges'] != null ? data.data['registrationDetails'][0]['ParkingCharges'] : 0,
                            isCarParking: data.data['registrationDetails'][0]['CarParking'] != null ? data.data['registrationDetails'][0]['CarParking'] : 0,
                            isPaid: data.data['registrationDetails'][0]['CarParking'] != null ? data.data['registrationDetails'][0]['CarParking'] : 0,
                            isInvoice: data.data['registrationDetails'][0]['isInvoice'] != null ? data.data['registrationDetails'][0]['isInvoice'] : '',
                            INVAddress: data.data['registrationDetails'][0]['INVAddress_V'] != null ? data.data['registrationDetails'][0]['INVAddress_V'] : '',
                            INVCompanyName: data.data['registrationDetails'][0]['INVCompanyName_V'] != null ? data.data['registrationDetails'][0]['INVCompanyName_V'] : '',
                            INVPersonName: data.data['registrationDetails'][0]['INVPersonName_V'] != null ? data.data['registrationDetails'][0]['INVPersonName_V'] : '',
                            INVTanNo: data.data['registrationDetails'][0]['INVTanNo'] != null ? data.data['registrationDetails'][0]['INVTanNo'] : '',
                            GSTNo: data.data['registrationDetails'][0]['GSTNo'] != null ? data.data['registrationDetails'][0]['GSTNo'] : '',
                            PANNo: data.data['registrationDetails'][0]['PanNo'] != null ? data.data['registrationDetails'][0]['PanNo'] : '',
                            showINVdetails: data.data['registrationDetails'][0]['isCoordinator'] == null ? true : data.data['registrationDetails'][0]['isCoordinator'],
                            seminarInterestList: seminarInterestList,
                            noOfDaysSelected: selectedDaysList.length,
                            isLoading: false,
                            countryIdINV: data.data['registrationDetails'][0]['INVCountryID_V'] != null ? data.data['registrationDetails'][0]['INVCountryID_V'] : '',
                            pincodeINV: data.data['registrationDetails'][0]['INVPinCode_V'] != null ? data.data['registrationDetails'][0]['INVPinCode_V'] : '',
                            regStateINV: data.data['registrationDetails'][0]['INVState_V'] != null ? data.data['registrationDetails'][0]['INVState_V'] : '',
                            cityINV: data.data['registrationDetails'][0]['INVCity_V'] != null ? data.data['registrationDetails'][0]['INVCity_V'] : '',
                            PIID: '',
                        }, () => {
                            if (data.data['registrationDetails'][0]['CountryID'] == 91) {
                                this.getFillList(pincodeActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                                this.getFillList(stateActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                                this.getFillList(cityActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                            }
                            setTimeout(() => {

                                this.setState({
                                    isOpenDropDownState: false,
                                    focusedIndexState: -1,
                                    isOpenDropDownStateModal: false,
                                    focusedIndexStateModal: -1,

                                    isOpenDropDownCity: false,
                                    focusedIndexCity: -1,
                                    isOpenDropDownCityModal: false,
                                    focusedIndexCityModal: -1,

                                    isOpenDropDownPin: false,
                                    focusedIndexPin: -1,
                                    isOpenDropDownPinModal: false,
                                    focusedIndexPinModal: -1,
                                    isLoading: false,
                                })
                            }, 100);
                        })
                        console.log(JSON.parse(sessionStorage.getItem('visitorVisitDays')), '2466', this.state.daysList)
                        if (false == null) {
                            var outstandingList = data.data['outstandingList']
                            var totalCharges = 0
                            for (var a = 0; a < outstandingList.length; a++) {
                                if (outstandingList[a].Outstanding != 0) {
                                    for (var i = 0; i < this.state.daysList.length; i++) {
                                        if (outstandingList[a].VisitDate == this.state.daysList[i].VisitDate) {
                                            this.state.daysList[i].isPending = true
                                            this.state.daysList[i].Outstanding = outstandingList[a].Outstanding
                                            this.setState({ PIID: outstandingList[a].ProformaInvoiceID })
                                        }
                                    }
                                    totalCharges = totalCharges + outstandingList[a].Outstanding
                                }
                            }
                            selectedSeminarList.length > 0 && selectedSeminarList.map((item) => {
                                if (item.Outstanding != 0) {
                                    seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                                        if (item.SeminarID == data.SeminarID) {
                                            data.isPending = true
                                            data.Outstanding = item.Outstanding
                                            this.setState({ PIID: item.ProformaInvoiceID })
                                        }
                                    })
                                    totalCharges = totalCharges + item.Outstanding
                                }
                            })

                            this.setState({ totalCharges: totalCharges })
                            this.setState({
                                toShow: totalCharges,
                            })
                        } else if (false) {
                            for (var i = 0; i < this.state.groupVisitDaysList.length; i++) {
                                this.state.groupVisitDaysList[i].isSelected = false
                                if (this.state.selectedVisitorID != '' && this.state.selectedVisitorID != null) {
                                    if (this.state.selectedVisitorID == this.state.groupVisitDaysList[i].AccountID) {
                                        this.state.groupVisitDaysList[i].isSelected = true
                                    }
                                } else {
                                    if (this.state.groupVisitDaysList[i].isCoordinator) {
                                        this.state.groupVisitDaysList[i].isSelected = true
                                    }
                                }
                            }
                            this.setState({ groupVisitDaysList: this.state.groupVisitDaysList })
                        } else if (!false) {
                            var outstandingList = data.data['outstandingList']
                            for (var a = 0; a < outstandingList.length; a++) {
                                if (outstandingList[a].Outstanding != 0) {
                                    for (var i = 0; i < this.state.daysList.length; i++) {
                                        if (outstandingList[a].VisitDate == this.state.daysList[i].VisitDate) {
                                            this.state.daysList[i].isPending = true
                                            this.state.daysList[i].Outstanding = outstandingList[a].Outstanding
                                            // this.setState({ PIID: outstandingList[a].ProformaInvoiceID })
                                        }
                                    }
                                }
                            }
                            this.setState({ daysList: daysList })
                        }
                        setTimeout(() => {
                            this.setState({
                                toShow: this.state.totalCharges,
                                additionalChargesUSD: ((data.data['registrationDetails'][0].additionalChargesUSD / 100) * this.state.totalCharges).toFixed(2),
                                conversionRate: data.data['registrationDetails'][0].ConversionRate,
                                additionalChargesUSDper: data.data['registrationDetails'][0].additionalChargesUSD,
                            })
                        }, 500);

                    } else {
                        this.setState({ isLoading: false })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }, 3000);

    }

    // Delete Exhibitor BAdge Document Delete
    handleDelete(e) {
        e.preventDefault()
        const { isOpen } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaDoc_action()
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isOpen: !isOpen, passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    otherDetailsChange(e) {
        const { visitPurposeList } = this.state
        var value = e.target.value

        visitPurposeList.length > 0 && visitPurposeList.map((data) => {
            if (data.PurposeofVisitID == 10 && data.isSelect) {
                data.otherDetail = value
            } else {
                data.otherDetail = ""
            }
        })
        this.setState({ visitPurposeList: visitPurposeList })
        console.log("sssssssssssssssssssssss", visitPurposeList)
    }

    // On Delegation Country Search
    onDelegationCountrySearch(e) {
        const { delgationCountryList, tempDelegationCountryList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempDelegationCountryList ++++----------->", tempDelegationCountryList)

            var searchCoutryList = tempDelegationCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                delegationCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                delegationCountryErr: '',
                tempDelegationCountryList: searchCoutryList,
                isDisplayDelegationCountryList: true
            })
        }
        else {

            this.setState({
                delegationCountry: e.target.value,
                tempDelegationCountryList: delgationCountryList,
                isDisplayDelegationCountryList: false
            })
        }
    }

    // Render Country for Delegation Country
    renderDelegationCountryList() {
        const { tempDelegationCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempDelegationCountryList.length > 0 && tempDelegationCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                delegationCountry: data.Description, delegationCountryId: data.Code,
                                isDisplayDelegationCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On Check Preferred Time
    handlePrefTime(e) {
        const prefTiming = e.target.value;
        if (prefTiming >= '09:00' && prefTiming <= '17:00') {
            this.setState({ prefTime: prefTiming });
        } else {
            toastError('Preferred time must be between 9:00 and 17:00')
        }
    }

    // On Checked seminar
    onCheckedSeminar(e, id) {
        const { seminarInterestList } = this.state
        const checked = e.target.checked
        if (false == null) {
            if (checked != undefined) {
                seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                    if (data.SeminarID == id) {
                        if (checked) {
                            data.isSelect = true
                            var isIncluded = false
                            this.state.daysList.map((data2) => {
                                if (data2.isSelect && data2.isReadOnly) {
                                    if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                        isIncluded = true
                                    }
                                }
                            })
                            // setTimeout(() => {
                            if (!isIncluded) {
                                this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                                this.state.daysList.map((data2) => {
                                    // if (data2.isSelect && data2.isReadOnly) {
                                    if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                        data2.isSelect = true
                                    }
                                    // }
                                })
                            } else {
                                this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                            }
                            // }, 0);
                        } else {
                            data.isSelect = false
                            this.setState({ toShowExtraDaysinPop: false })
                        }
                        if (data.SeminarTypeID != 3) {
                            this.setState({ TotalPayable: '' })
                        }
                    }
                })
            } else {
                seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                    if (data.SeminarID == id) {
                        if (data.isSelect) {
                            data.isSelect = false
                            this.setState({ toShowExtraDaysinPop: false })
                        } else {
                            data.isSelect = true
                            var isIncluded = false
                            this.state.daysList.map((data2) => {
                                if (data2.isSelect && data2.isReadOnly) {
                                    if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                        isIncluded = true
                                    }
                                }
                            })
                            // setTimeout(() => {
                            if (!isIncluded) {
                                this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                                this.state.daysList.map((data2) => {
                                    // if (data2.isSelect && data2.isReadOnly) {
                                    if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                        data2.isSelect = true
                                    }
                                    // }
                                })
                            } else {
                                this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                            }
                            // }, 5);
                        }
                        if (data.SeminarTypeID != 3) {
                            this.setState({ TotalPayable: '' })
                        }
                    }
                })
            }
        } else {
            if (false == false) {
                this.setState({ TotalPayable: '', cantSelectSeminarFlag: true, ChargesPop: true })
            } else {
                if (checked != undefined) {
                    seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                        if (data.SeminarID == id) {
                            if (checked) {
                                var isIncluded = false
                                this.state.groupVisitDaysList.map((data2) => {
                                    if (data2.isSelected) {
                                        data2.finalDaysList.map(item => {
                                            if (item.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                                if (item.isSelect && item.isReadOnly) {
                                                    console.log("data", item, data)
                                                    isIncluded = true
                                                }
                                            }
                                        })
                                    }
                                })
                                // setTimeout(() => {
                                if (!isIncluded) {
                                    this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                                } else {
                                    data.isSelect = true
                                    this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                                }
                                // }, 0);
                            } else {
                                data.isSelect = false
                                this.setState({ toShowExtraDaysinPop: false })
                            }
                            if (data.SeminarTypeID != 3) {
                                this.setState({ TotalPayable: '' })
                            }
                        }
                    })
                } else {
                    seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                        if (data.SeminarID == id) {
                            if (data.isSelect) {
                                data.isSelect = false
                                this.setState({ toShowExtraDaysinPop: false })
                            } else {
                                var isIncluded = false
                                this.state.groupVisitDaysList.map((data2) => {
                                    if (data2.isSelected) {
                                        data2.finalDaysList.map(item => {
                                            if (item.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                                if (item.isSelect && item.isReadOnly) {
                                                    console.log("data", item, data)
                                                    isIncluded = true
                                                }
                                            }
                                        })
                                    }
                                })
                                // setTimeout(() => {
                                if (!isIncluded) {
                                    this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                                } else {
                                    data.isSelect = true
                                    this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                                }
                                // }, 5);
                            }
                            if (data.SeminarTypeID != 3) {
                                this.setState({ TotalPayable: '' })
                            }
                        }
                    })
                }
            }
        }
        console.log("aaaaaaaaaaa", e.target.checked, seminarInterestList)
        this.setState({})
    }

    onFileClick() {
        this.toggleModal();
        // const url = "images/B2BEXHIBITOR.pdf"
        // window.open(url, "_blank");
    }

    toggleModal() {
        const { isOpen2 } = this.state
        this.setState({ isOpen2: !isOpen2 })
    }

    onCheckLevel1(e, id) {
        const { level2, primaryChapterListLevel2, primaryChapterListLevel3, primaryChapterListLevel4, primaryChapterListData, level3, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < primaryChapterListData.length; i++) {
            if (primaryChapterListData[i]['ChapterID'] == id) {
                if (event == true) {
                    primaryChapterListData[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level2.forEach((level2) => {
                        if (level2.ParentChapterID == id) {
                            level2.IsSelect = true

                            level3.forEach((level3) => {
                                if (level2.ChapterID == level3.ParentChapterID) {
                                    level3.IsSelect = true

                                    level4.forEach((level4) => {
                                        if (level3.ChapterID == level4.ParentChapterID) {
                                            level4.IsSelect = true

                                        }
                                    });
                                }
                            });
                        }
                    });

                } else {
                    primaryChapterListData[i]['IsSelect'] = false

                    level2.forEach((level2) => {
                        if (level2.ParentChapterID == id) {
                            level2.IsSelect = false

                            level3.forEach((level3) => {
                                if (level2.ChapterID == level3.ParentChapterID) {
                                    level3.IsSelect = false

                                    level4.forEach((level4) => {
                                        if (level3.ChapterID == level4.ParentChapterID) {
                                            level4.IsSelect = false

                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        }
        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);

    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, primaryChapterListLevel3, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2[i]['IsSelect'] = false

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        console.log("tempLevel1", tempLevel1)

        for (let i = 0; i < primaryChapterListData.length; i++) {
            for (let j = 0; j < level2.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.IsSelect == 1)
                        console.log("allSelectedChecked", allSelectedChecked)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['IsSelect'] = true
                        } else {
                            primaryChapterListData[i]['IsSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);


    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level3, primaryChapterListLevel4, level2, level4, primaryChapterListData } = this.state
        this.setState({ level4DummyId: id })
        const event = e.target.checked

        var modelevel2 = []
        var modelevel3 = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                console.log("***********", level3[i])
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })

        console.log("finalListlevel2", finalListlevel2)


        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {

                            level4.IsSelect = true
                        }
                    });

                } else {
                    level3[i]['IsSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.IsSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.IsSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['IsSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                    console.log("allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['IsSelect'] = true
                                    } else {
                                        primaryChapterListData[j]['IsSelect'] = false
                                    }
                                }
                                else {
                                    level2[index]['IsSelect'] = false
                                    primaryChapterListData[j]['IsSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);

    }

    record(level2data) {
        const { primaryChapterListLevel2, level2, level3, level4 } = this.state
        var tempLevel1 = [];
        for (var j = 0; j < level2.length; j++) {
            if (level2data.ChapterID == level2[j]['ParentChapterID']) {
                tempLevel1.push(level2[j]);
                primaryChapterListLevel2.push(level2[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2data.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel1.length > 0 && tempLevel1.map((level2data, i) => (
                            <>
                                {
                                    // level2data.ParentChapterID == primaryChapterRadio &&
                                    <div class="accordion-body">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header check-out" id={'heading_l1_' + level2data.ChapterID}>

                                                <button class={"accordion-button collapsed  tit-name"}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={'#collapse_l1_' + level2data.ChapterID} aria-expanded="false"
                                                    aria-controls={'collapse_l1_' + level2data.ChapterID}>
                                                    {level2data.IsCheckbox &&
                                                        <input type="checkbox" className="from-left-sp check-out-in" name="" key={level2data.ChapterID}
                                                            checked={level2data.IsSelect}
                                                            disabled
                                                            onClick={e => this.onCheckLevel2(e, level2data.ChapterID, tempLevel1)}
                                                        />
                                                    }
                                                    {level2data.ChapterName}
                                                </button>
                                            </h2>
                                            {this.recordTwo(level2data, level3, level4)}
                                        </div>
                                    </div>
                                }

                            </>
                        ))
                    }
                </div>
            </>
        );
    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3 } = this.state
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"
                                                        disabled
                                                        name="" id={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }
                                                <label style={{ background: 'none', cursor: 'pointer' }} className="p-0" for={level3data.ChapterID}>{level3data.ChapterName}</label></button>
                                        </h2>
                                        {this.recordThree(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4 } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step" style={{ display: 'flex' }}>

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" name="" id={level4data.ChapterID} checked={level4data.IsSelect} disabled
                                        onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                }
                                <label style={{ background: 'none', cursor: 'pointer' }} className="p-0" for={level4data.ChapterID}>{level4data.ChapterName}</label>

                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level4, exhibitDetailsList, level3, level2, level4DummyId, primaryChapterListLevel3, primaryChapterListLevel4, primaryChapterListData } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })




        console.log("************** finalListlevel2", finalListlevel2)
        // console.log("************** finalListlevel3", finalListlevel3)


        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    for (let k = 0; k < level2.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.IsSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['IsSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.IsSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['IsSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                                console.log("************** allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['IsSelect'] = true

                                                } else {
                                                    primaryChapterListData[j]['IsSelect'] = false
                                                }

                                            } else {
                                                level2[k]['IsSelect'] = false
                                            }


                                        }
                                        else {
                                            level3[index]['IsSelect'] = false
                                            level2[k]['IsSelect'] = false
                                            primaryChapterListData[j]['IsSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level4: level4, level3: level3, level2: level2 })
        }, 100);


    }

    handleSearchChange = (event, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: event.target.value, isOpenDropDownState: event.target.value.length > 0, tempStateList: this.filterItems(event.target.value, mode, status), focusedIndexState: -1 });
            }
            else if (status == 1) {
                console.log(event, 'event')
                this.setState({ regStateModal: event.target.value, isOpenDropDownStateModal: event.target.value.length > 0, tempStateListModal: this.filterItems(event.target.value, mode, status), focusedIndexStateModal: -1 });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: event.target.value, isOpenDropDownCity: event.target.value.length > 0, tempCityList: this.filterItems(event.target.value, mode, status), focusedIndexCity: -1 });
            }
            else if (status == 1) {
                this.setState({ cityModal: event.target.value, isOpenDropDownCityModal: event.target.value.length > 0, tempCityListModal: this.filterItems(event.target.value, mode, status), focusedIndexCityModal: -1 });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: event.target.value, isOpenDropDownPin: event.target.value.length > 0, tempPincodeList: this.filterItems(event.target.value, mode, status), focusedIndexPin: -1 });
            }
            else if (status == 1) {
                this.setState({ pincodeModal: event.target.value, isOpenDropDownPinModal: event.target.value.length > 0, tempPincodeListModal: this.filterItems(event.target.value, mode, status), focusedIndexPinModal: -1 });
            }
        }
    };

    filterItems = (searchTerm, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                console.log('this.state.stateListModal', this.state.stateListModal)
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 1) {
            if (status == 0) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 2) {
            if (status == 0) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        }
    };

    // Handle selecting an option from the dropdown
    handleSelect = (option, mode, status) => {
        console.log(option)
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: option.Description, focusedIndexState: -1, tempStateList: [], isOpenDropDownState: false, }, () => {
                    // this.callStateList(option.Description, option.Code)
                });
            } else if (status == 1) {
                this.setState({ regStateModal: option.Description, focusedIndexStateModal: -1, tempCityListModal: [], isOpenDropDownStateModal: false, });
                // this.callStateListModal(option.Description, option.Code)

            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: option.Description, focusedIndexCity: -1, tempCityList: [], isOpenDropDownCity: false, });
            } else if (status == 1) {
                this.setState({ cityModal: option.Description, focusedIndexCityModal: -1, tempStateListModal: [], isOpenDropDownCityModal: false, });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: option.Pincode, focusedIndexPin: -1, tempCityList: [], isOpenDropDownPin: false, });
            } else if (status == 1) {
                this.setState({ pincodeModal: option.Pincode, focusedIndexPinModal: -1, tempCityListModal: [], isOpenDropDownPinModal: false, });
            }
        }
    };

    handleKeyDown = (e, mode, status) => {
        const { focusedIndexState, tempPincodeList, tempPincodeListModal, focusedIndexPin, focusedIndexPinModal, tempStateList, focusedIndexStateModal, tempStateListModal, tempCityList, focusedIndexCity, focusedIndexCityModal, tempCityListModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexState: Math.min(focusedIndexState + 1, tempStateList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexState: Math.max(focusedIndexState - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexState >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateList[focusedIndexState], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    console.log(tempStateListModal.length)
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexStateModal: Math.min(focusedIndexStateModal + 1, tempStateListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexStateModal: Math.max(focusedIndexStateModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexStateModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateListModal[focusedIndexStateModal], mode, status);
                }
            }
        } else if (mode == 1) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCity: Math.min(focusedIndexCity + 1, tempCityList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCity >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityList[focusedIndexCity], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCityModal: Math.min(focusedIndexCityModal + 1, tempCityListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCityModal: Math.max(focusedIndexCityModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCityModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityListModal[focusedIndexCityModal], mode, status);
                }
            }
        } else if (mode == 2) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPin: Math.min(focusedIndexPin + 1, tempPincodeList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPin: Math.max(focusedIndexPin - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPin >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeList[focusedIndexPin], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPinModal: Math.min(focusedIndexPinModal + 1, tempPincodeListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPinModal: Math.max(focusedIndexPinModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPinModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeListModal[focusedIndexPinModal], mode, status);
                }
            }
        }
    };

    handleHover = (index, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: index });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: index });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ focusedIndexCity: index });
            } else if (status == 1) {
                this.setState({ focusedIndexCityModal: index });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ focusedIndexPin: index });
            } else if (status == 1) {
                this.setState({ focusedIndexPinModal: index });
            }
        }
    };

    scrollIntoView = (mode, status) => {
        // console.log(mode, status)
        const { focusedIndexState, focusedIndexStateModal, focusedIndexPin, focusedIndexPinModal, focusedIndexCity, focusedIndexCityModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexState];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom < dropdownBottom) {
                //     dropdownMenu.scrollTop =-50;
                //     console.log(dropdownMenu.scrollTop )
                // }
                // else if (itemTop > dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 1) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexCity];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 2) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexPin];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        }
    };

    onCountrySelect(e, status) {
        const { tempPassCountryList } = this.state
        var countryId = e.target.value
        console.log(tempPassCountryList, countryId)
        // for(var i=0;i<)
        if (countryId != '') {
            if (status == 1) {
                this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                var countryCode = tempPassCountryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNoModal: `+${countryCode}`,
                    preWhatsAppMobNoModal: `+${countryCode}`,
                    preApplicantMobNoModal: `+${countryCode}`,
                })
                if (countryId == 91) {
                    this.setState({ needVisaAssistanceModal: false })
                    this.setState({
                        passNameErrModal: "",
                        applicantMobNoErrModal: "",
                        applicantEmailErrModal: "",
                        passNoErrModal: "",
                        passDateErrModal: "",
                        passExipryDateErrModal: "",
                        passCountryErrModal: "",
                        passportFileErrModal: "",
                        applicantEmailErrModal: "",
                        mobNoModal: '',
                        whatsAppMobNoModal: '',
                        mobNoErrModal: '',
                        whatsAppMobNoErrModal: '',
                        pincodeModal: ''
                    });
                }
                // this.getFillList(pincodeActionId, '', '', countryId, '', '')
                // this.getFillList(stateActionId, '', '', countryId, '', '')
                // this.getFillList(cityActionId, '', '', countryId, '', '')
            } else if (status == 2) {
                // this.setState({ passCountry: countryId, passCountryErr: "" })
                var countryName = tempPassCountryList.filter(obj => obj.Code == parseInt(countryId))[0].Description
                this.setState({
                    passCountry: countryName, passCountryId: countryId,
                })
                // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                // this.setState({
                //     preMobNo: `+${countryCode}`,
                //     preWhatsAppMobNo: `+${countryCode}`
                // })
            } else if (status == 3) {
                // this.setState({ delegationCountry: countryId, delegationCountryErr: "" })
                this.setState({ passCountryModal: countryId, passCountryErrModal: "" })
                // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                // this.setState({
                //     preMobNo: `+${countryCode}`,
                //     preWhatsAppMobNo: `+${countryCode}`
                // })
            } else {
                this.setState({ countryId: countryId, countryIdErr: "" })
                var countryCode = tempPassCountryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNo: `+${countryCode}`,
                    preWhatsAppMobNo: `+${countryCode}`,
                    preApplicantMobNo: `+${countryCode}`,
                })
                if (countryId == 91) {
                    this.setState({ needVisaAssistance: false })
                    this.setState({
                        passNameErr: "",
                        applicantMobNoErr: "",
                        applicantEmailErr: "",
                        passNoErr: "",
                        passDateErr: "",
                        passExipryDateErr: "",
                        passCountryErr: "",
                        passportFileErr: "",
                        applicantEmailErr: "",
                        mobNo: '',
                        whatsAppMobNo: '',
                        mobNoErr: '',
                        whatsAppMobNoErr: '',
                        pincode: ''
                    });
                }
                // Calling City , State , Pincode filllist on country Select
                // this.getFillList(pincodeActionId, '', '', countryId, '', '')
                // this.getFillList(stateActionId, '', '', countryId, '', '')
                // this.getFillList(cityActionId, '', '', countryId, '', '')
            }
            setTimeout(() => {
                this.setState({
                    isDisplayPincodeList: false,
                    isDisplayCityList: false,
                    isDisplayStateList: false,
                    isDisplayPincodeListModal: false,
                    isDisplayCityListModal: false,
                    isDisplayStateListModal: false,
                })
            }, 200);
        }

        // if (status == 1) {
        //     this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
        //     var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
        //     this.setState({
        //         preMobNoModal: `+${countryCode}`,
        //         preWhatsAppMobNoModal: `+${countryCode}`
        //     })
        //     this.getFillList(pincodeActionId, '', '', countryId, '', '')
        //     this.getFillList(stateActionId, '', '', countryId, '', '')
        //     this.getFillList(cityActionId, '', '', countryId, '', '')
        //     setTimeout(() => {
        //         this.setState({
        //             isDisplayPincodeList: false,
        //             isDisplayCityList: false,
        //             isDisplayStateList: false,
        //             isDisplayGroupPincodeList: false,
        //             isDisplayGroupCityList: false,
        //             isDisplayGroupStateList: false,
        //         })
        //     }, 200);
        // } else if (status == 2) {
        //     this.setState({ passCountry: countryId, passCountryErr: "" })
        //     // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
        //     // this.setState({
        //     //     preMobNoModal: `+${countryCode}`,
        //     //     preWhatsAppMobNoModal: `+${countryCode}`
        //     // })
        // } else if (status == 3) {
        //     this.setState({ delegationCountry: countryId, delegationCountryErr: "" })
        //     // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
        //     // this.setState({
        //     //     preMobNoModal: `+${countryCode}`,
        //     //     preWhatsAppMobNoModal: `+${countryCode}`
        //     // })
        // } else {
        //     this.setState({ countryId: countryId, countryIdErr: "" })
        //     var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
        //     this.setState({
        //         preMobNo: `+${countryCode}`,
        //         preWhatsAppMobNo: `+${countryCode}`
        //     })
        //     // Calling City , State , Pincode filllist on country Select
        //     this.getFillList(pincodeActionId, '', '', countryId, '', '')
        //     this.getFillList(stateActionId, '', '', countryId, '', '')
        //     this.getFillList(cityActionId, '', '', countryId, '', '')
        // }
    }


    onSelectGroupDates(e, obj, flag) {
        const { isLoading, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, changeVisitDays, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cityINV } = this.state
        groupVisitDaysList.map(item => {
            if (item.ExhVisitorID == obj.ExhVisitorID) {
                item.finalDaysList.map(item2 => {
                    if (item2.Code == e.target.value) {
                        if (item2.isSelect) {
                            item2.isSelect = false
                        } else {
                            item2.isSelect = true
                        }
                    }
                })
            }
        })
        this.setState({ groupVisitDaysList: groupVisitDaysList }, () => {
            if (!changeVisitDays) {
                var updatedVisitorDaysList = []
                for (var i = 0; i < groupVisitDaysList.length; i++) {
                    for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                        if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                            updatedVisitorDaysList.push({
                                "visitDay": groupVisitDaysList[i].finalDaysList[j].VisitDate,
                                "isPaid": groupVisitDaysList[i].finalDaysList[j].isPending ? 0 : groupVisitDaysList[i].finalDaysList[j].isReadOnly ? 1 : 0,
                                "ExhVisitorID": groupVisitDaysList[i].ExhVisitorID
                            })
                        }
                    }
                }
                this.setState({ isLoading: true })
                this.props.updateVisitorEstimate_action(updatedVisitorDaysList, false, [])
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.setState({ isLoading: false, isRegistrationComplete: true })
                            // sessionStorage.setItem('isRegistrationComplete', 1)
                            // this.getVisitorRegistrationDetails()
                            for (var i = 0; i < data.data[0].length; i++) {
                                if (data.data[0][i].Narration == 'Total Taxable') {
                                    this.setState({ totaltaxable: data.data[0][i].TotalAmt })
                                }
                                if (data.data[0][i].Narration == 'Grand Total') {
                                    this.setState({ totalCharges: data.data[0][i].TotalAmt })
                                    this.setState({
                                        toShow: data.data[0][i].TotalAmt,
                                        additionalChargesUSD: ((this.state.additionalChargesUSDper / 100) * data.data[0][i].TotalAmt).toFixed(2),
                                        // conversionRate: data.data['registrationDetails'][0].ConversionRate,
                                        // additionalChargesUSDper: data.data['registrationDetails'][0].additionalChargesUSD,
                                    })
                                }
                                if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
                                    this.setState({ visitorCharges: data.data[0][i].TotalAmt })
                                }
                                if (data.data[0][i].Narration == 'CGST') {
                                    this.setState({ CGST: data.data[0][i].TotalAmt })
                                }
                                if (data.data[0][i].Narration == 'SGST') {
                                    this.setState({ SGST: data.data[0][i].TotalAmt })
                                }
                                if (data.data[0][i].Narration == 'IGST') {
                                    this.setState({ IGST: data.data[0][i].TotalAmt })
                                }
                            }
                            // this.setState({
                            //     // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                            //     estimatePop: true
                            // })
                        } else {
                            this.setState({ isLoading: false })
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                console.log(updatedVisitorDaysList)
            }

        })
    }

    getPendingEstiamtes() {
        const { isLoading, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cityINV } = this.state
        var updatedVisitorDaysList = []
        for (var i = 0; i < daysList.length; i++) {
            // for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
            if (daysList[i].isSelect) {
                updatedVisitorDaysList.push({
                    "visitDay": daysList[i].VisitDate,
                    "isPaid": daysList[i].isPending ? 0 : 1,
                    "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                })
            }
            // }
        }
        this.setState({ isLoading: true })
        this.props.updateVisitorEstimate_action(updatedVisitorDaysList, false, [])
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false, isRegistrationComplete: true })
                    // sessionStorage.setItem('isRegistrationComplete', 1)
                    // this.getVisitorRegistrationDetails()
                    for (var i = 0; i < data.data[0].length; i++) {
                        if (data.data[0][i].Narration == 'Total Taxable') {
                            this.setState({ totaltaxable: data.data[0][i].TotalAmt })
                        }
                        if (data.data[0][i].Narration == 'Grand Total') {
                            this.setState({ totalCharges: data.data[0][i].TotalAmt })
                        }
                        if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
                            this.setState({ visitorCharges: data.data[0][i].TotalAmt })
                        }
                        if (data.data[0][i].Narration == 'CGST') {
                            this.setState({ CGST: data.data[0][i].TotalAmt })
                        }
                        if (data.data[0][i].Narration == 'SGST') {
                            this.setState({ SGST: data.data[0][i].TotalAmt })
                        }
                        if (data.data[0][i].Narration == 'IGST') {
                            this.setState({ IGST: data.data[0][i].TotalAmt })
                        }
                    }
                    this.setState({
                        // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                        estimatePop: true
                    })
                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    async onUpdateGroupDays(e, flag) {
        e != undefined && e.preventDefault()
        const { isLoading, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cityINV, PIID } = this.state


        var visitDaysNoArr = []
        var dateListDays = []
        var toreturn = false
        for (var i = 0; i < groupVisitDaysList.length; i++) {

            var selectedDays = groupVisitDaysList[i].finalDaysList.filter(data => data.isSelect == true)
            dateListDays.push(selectedDays.length)
            // selectedDays.map((data) => {
            //     var data = {
            //         "visitDay": data.VisitDate
            //     }
            //     dateList.push(data)
            // })
        }
        for (var i = 0; i < pricingList.length; i++) {
            visitDaysNoArr.push(pricingList[i].VisitDays)
        }
        if (pricingList.length != 0) {
            for (var j = 0; j < dateListDays.length; j++) {
                var isMatch = false
                for (var i = 0; i < pricingList.length; i++) {
                    console.log(pricingList[i].VisitDays, dateListDays[j])
                    if (pricingList[i].VisitDays == dateListDays[j]) {
                        isMatch = true
                    }
                }
                if (!isMatch) {
                    toreturn = true
                    break
                }

            }
            if (toreturn) {
                toastError(`Visit pass only allowed for ${visitDaysNoArr.toString()} days`)
                // modalErr = false
                return
            }
        }
        // return

        var updatedVisitorDaysList = []
        var isCancel = false
        if (false != null) {
            for (var i = 0; i < groupVisitDaysList.length; i++) {
                for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                        updatedVisitorDaysList.push({
                            "visitDay": groupVisitDaysList[i].finalDaysList[j].VisitDate,
                            "isPaid": groupVisitDaysList[i].finalDaysList[j].isPending ? 0 : groupVisitDaysList[i].finalDaysList[j].isReadOnly ? 1 : 0,
                            "ExhVisitorID": groupVisitDaysList[i].ExhVisitorID
                        })
                    }
                    if (groupVisitDaysList[i].finalDaysList[j].isPending) {
                        isCancel = true
                    }
                }
            }
            if (isCancel) {
                await this.onCancelPayment(1)
            }
            this.setState({ isLoading: true })
            this.props.updateGroupVisitorDays_action(updatedVisitorDaysList, false,)
                .then((data) => {
                    console.log(data)
                    if (data.error != 1) {
                        this.setState({ isLoading: false, isRegistrationComplete: true })
                        if (data.data[0] != undefined && data.data[0][0] != undefined && data.data[0][0].ProformaInvoiceID != undefined) {
                            this.setState({ PIID: data.data[0][0].ProformaInvoiceID }, () => {
                                // if (this.state.totalCharges != null && this.state.totalCharges != '') {
                                this.navToPayment()
                                // }
                            })
                        }
                        // sessionStorage.setItem('isRegistrationComplete', 1)
                        // this.getVisitorRegistrationDetails()
                        // for (var i = 0; i < data.data[0].length; i++) {
                        //     if (data.data[0][i].Narration == 'Total Taxable') {
                        //         this.setState({ totaltaxable: data.data[0][i].TotalAmt })
                        //     }
                        //     if (data.data[0][i].Narration == 'Grand Total') {
                        //         this.setState({ totalCharges: data.data[0][i].TotalAmt })
                        //     }
                        //     if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
                        //         this.setState({ visitorCharges: data.data[0][i].TotalAmt })
                        //     }
                        //     if (data.data[0][i].Narration == 'CGST') {
                        //         this.setState({ CGST: data.data[0][i].TotalAmt })
                        //     }
                        //     if (data.data[0][i].Narration == 'SGST') {
                        //         this.setState({ SGST: data.data[0][i].TotalAmt })
                        //     }
                        //     if (data.data[0][i].Narration == 'IGST') {
                        //         this.setState({ IGST: data.data[0][i].TotalAmt })
                        //     }
                        // }
                        // this.setState({
                        //     // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                        //     estimatePop: true
                        // })
                    } else {
                        this.setState({ isLoading: false })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            console.log(updatedVisitorDaysList)
        } else {
            // for (var i = 0; i < daysList.length; i++) {
            //     // for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
            //     if (daysList[i].isSelect) {
            //         updatedVisitorDaysList.push({
            //             "visitDay": daysList[i].VisitDate,
            //             "isPaid": daysList[i].isPending ? 0 : 1,
            //             "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
            //         })
            //     }
            //     // }
            // }
            // this.setState({ isLoading: true })
            // this.props.updateGroupVisitorDays_action(updatedVisitorDaysList, false,)
            //     .then((data) => {
            //         console.log(data)
            //         if (data.error != 1) {
            //             this.setState({ isLoading: false, isRegistrationComplete: true })
            // if (data.data[0] != undefined && data.data[0][0] != undefined && data.data[0][0].ProformaInvoiceID != undefined) {
            // this.setState({ PIID: data.data[0][0].ProformaInvoiceID }, () => {
            // if (this.state.totalCharges != null && this.state.totalCharges != '') {
            // this.navToPayment()
            // }
            // })
            // }
            // sessionStorage.setItem('isRegistrationComplete', 1)
            // this.getVisitorRegistrationDetails()
            // for (var i = 0; i < data.data[0].length; i++) {
            //     if (data.data[0][i].Narration == 'Total Taxable') {
            //         this.setState({ totaltaxable: data.data[0][i].TotalAmt })
            //     }
            //     if (data.data[0][i].Narration == 'Grand Total') {
            //         this.setState({ totalCharges: data.data[0][i].TotalAmt })
            //     }
            //     if (data.data[0][i].Narration == 'Visitor Registration Charges ') {
            //         this.setState({ visitorCharges: data.data[0][i].TotalAmt })
            //     }
            //     if (data.data[0][i].Narration == 'CGST') {
            //         this.setState({ CGST: data.data[0][i].TotalAmt })
            //     }
            //     if (data.data[0][i].Narration == 'SGST') {
            //         this.setState({ SGST: data.data[0][i].TotalAmt })
            //     }
            //     if (data.data[0][i].Narration == 'IGST') {
            //         this.setState({ IGST: data.data[0][i].TotalAmt })
            //     }
            // }
            // this.setState({
            //     // newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
            //     estimatePop: true
            // })
            //     } else {
            //         this.setState({ isLoading: false })
            //     }
            // })
            // .catch((err) => {
            //     console.log(err)
            // })
        }

    }


    onCancelPayment(flag) {
        const { isLoading, PIID, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cityINV } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            var updatedVisitorDaysList = []
            var updatedSeminarList = []
            if (isCoordinator) {
                for (var i = 0; i < groupVisitDaysList.length; i++) {
                    for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                        if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                            if (groupVisitDaysList[i].finalDaysList[j].isPending) {
                                updatedVisitorDaysList.push({
                                    "visitDay": groupVisitDaysList[i].finalDaysList[j].VisitDate,
                                    // "isPaid": daysList[i].isPending ? 0 : 1,
                                    "ExhVisitorID": groupVisitDaysList[i].ExhVisitorID
                                })
                            }
                        }
                    }
                    // if (groupVisitDaysList[i] != undefined && groupVisitDaysList[i].Outstanding != undefined) {
                    //     if (groupVisitDaysList[i].Outstanding != 0) {
                    //         toShowOut = true
                    //     }
                    // }
                }
            } else {
                for (var i = 0; i < seminarInterestList.length; i++) {
                    // for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (seminarInterestList[i].isPending) {
                        updatedSeminarList.push({
                            "SeminarID": seminarInterestList[i].SeminarID,
                            // "isPaid": daysList[i].isPending ? 0 : 1,
                            "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                        })
                    }
                    // }
                }
                for (var i = 0; i < daysList.length; i++) {
                    // for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (daysList[i].isPending) {
                        updatedVisitorDaysList.push({
                            "visitDay": daysList[i].VisitDate,
                            // "isPaid": daysList[i].isPending ? 0 : 1,
                            "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                        })
                    }
                    // }
                }
            }
            console.log(updatedVisitorDaysList, updatedSeminarList)
            this.props.cancelVisitorCharges_action(updatedVisitorDaysList, JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID, updatedSeminarList)
                .then((data) => {
                    console.log(data)
                    if (data.error != 1) {
                        // flag != 1 && 
                        flag != 1 && this.getCoordinatorVisitor().then(() => {
                            this.setState({ isLoading: true })
                            this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "", 1).then(() => {
                                this.getFillList(seminarInterestActionId, "", "", "", "", false == null ? this.state.ExhVisitorID : '', 1).then(() => {
                                    this.setState({ isLoading: true })
                                    this.getVisitorRegistrationDetails()
                                    for (var i = 0; i < this.state.groupVisitDaysList.length; i++) {
                                        this.state.groupVisitDaysList[i].isSelected = false
                                        if (this.state.selectedVisitorID != '' && this.state.selectedVisitorID != null) {
                                            if (this.state.selectedVisitorID == this.state.groupVisitDaysList[i].AccountID) {
                                                this.state.groupVisitDaysList[i].isSelected = true
                                            }
                                        } else {
                                            if (this.state.groupVisitDaysList[i].isCoordinator) {
                                                this.state.groupVisitDaysList[i].isSelected = true
                                            }
                                        }
                                    }
                                })
                            })
                        })
                        this.setState({ cancelPOP: false })

                        //             // flag != 1 && 
                        resolve(true)

                    }
                }).catch((err) => {
                    console.log(err)
                })
        })
    }

    changeVisitDays(id) {
        const { isLoading, PIID, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, changeVisitDays, cityINV } = this.state
        if (changeVisitDays) {
            this.setState({ changeVisitDays: false })
        } else {
            this.setState({ changeVisitDays: true })
        }
        if (isCoordinator) {
            var tempArr = JSON.parse(JSON.stringify(groupVisitDaysList))
            // this.state.groupVisitDaysList.map(item => {
            //     if (item.ExhVisitorID == id) {
            //     }
            // })
            this.setState({ tempDaysList: tempArr })
            groupVisitDaysList.length > 0 && groupVisitDaysList.map((item) => {
                if (item.ExhVisitorID == id) {
                    item.finalDaysList.length > 0 && item.finalDaysList.map(item2 => {
                        if (item2.isReadOnly) {
                            item2.isReadOnly = false
                        }
                    })
                }
            })
            this.setState({ groupVisitDaysList: groupVisitDaysList, changeVisitDaysId: id })
        } else {
            var tempArr = JSON.parse(JSON.stringify(this.state.daysList))
            this.setState({ tempDaysList: tempArr })
            daysList.length > 0 && daysList.map((item) => {
                if (item.isReadOnly) {
                    item.isReadOnly = false
                }
            })
            this.setState({ daysList: daysList })
        }
        console.log(daysList, tempArr)
    }

    onSubmitdaysSwap(id) {
        const { isLoading, PIID, country, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName,
            otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cityINV, tempDaysList } = this.state
        var countdays = 0
        var updatedVisitorDaysList = []
        if (isCoordinator) {
            tempDaysList.length > 0 && tempDaysList.map((item) => {
                if (item.ExhVisitorID == id) {
                    item.finalDaysList.length > 0 && item.finalDaysList.map((item2) => {

                        if (item2.isReadOnly) {
                            if (new Date(`${item2.VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                            } else {
                                countdays = countdays + 1
                            }
                        }
                    })
                }
            })
            var countDaysmain = 0
            for (var i = 0; i < groupVisitDaysList.length; i++) {
                if (groupVisitDaysList[i].ExhVisitorID == id) {
                    for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                        if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                            if (new Date(`${groupVisitDaysList[i].finalDaysList[j].VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                            } else {
                                // countdays = countdays + 1
                                countDaysmain = countDaysmain + 1
                            }
                        }
                    }
                }
            }
            if (countDaysmain == countdays) {
                for (var i = 0; i < groupVisitDaysList.length; i++) {
                    for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                        if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                            // if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                            updatedVisitorDaysList.push({
                                "visitDay": groupVisitDaysList[i].finalDaysList[j].VisitDate,
                                // "isPaid": daysList[i].isPending ? 0 : 1,
                                "ExhVisitorID": groupVisitDaysList[i].ExhVisitorID
                            })
                            // }
                        }
                    }
                    // if (groupVisitDaysList[i] != undefined && groupVisitDaysList[i].Outstanding != undefined) {
                    //     if (groupVisitDaysList[i].Outstanding != 0) {
                    //         toShowOut = true
                    //     }
                    // }
                }
                this.props.swapVisitorDate_action(updatedVisitorDaysList, JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.getCoordinatorVisitor().then(() => {
                                this.setState({ isLoading: true })
                                this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "", 1).then(() => {
                                    this.setState({ isLoading: true, changeVisitDays: false })
                                    this.getVisitorRegistrationDetails()
                                    console.log(this.state.groupVisitDaysList, '1212313')
                                    for (var i = 0; i < this.state.groupVisitDaysList.length; i++) {
                                        this.state.groupVisitDaysList[i].isSelected = false
                                        if (this.state.selectedVisitorID != '' && this.state.selectedVisitorID != null) {
                                            if (this.state.selectedVisitorID == this.state.groupVisitDaysList[i].AccountID) {
                                                this.state.groupVisitDaysList[i].isSelected = true
                                            }
                                        } else {
                                            if (this.state.groupVisitDaysList[i].isCoordinator) {
                                                this.state.groupVisitDaysList[i].isSelected = true
                                            }
                                        }
                                    }
                                })
                            })
                        }
                    })
            } else {
                toastError(`you can swipe ${countdays} ${countdays > 1 ? "days" : "day"} only`)
            }
        } else {

            tempDaysList.length > 0 && tempDaysList.map((item) => {
                if (item.isReadOnly) {
                    if (item.isReadOnly) {
                        if (new Date(`${item.VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                        } else {
                            countdays = countdays + 1
                        }
                    }
                    // countdays = countdays + 1
                }
            })
            var countDaysmain = 0
            for (var i = 0; i < daysList.length; i++) {
                if (daysList[i].isSelect) {
                    if (new Date(`${daysList[i].VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                    } else {
                        // countdays = countdays + 1    
                        countDaysmain = countDaysmain + 1
                    }
                }
            }
            if (countDaysmain == countdays) {
                for (var i = 0; i < daysList.length; i++) {
                    // for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (daysList[i].isSelect) {
                        updatedVisitorDaysList.push({
                            "visitDay": daysList[i].VisitDate,
                            // "isPaid": daysList[i].isPending ? 0 : 1,
                            "ExhVisitorID": JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
                        })
                    }
                    // }
                }
                this.props.swapVisitorDate_action(updatedVisitorDaysList, JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.getCoordinatorVisitor().then(() => {
                                this.setState({ isLoading: true })
                                this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "", 1).then(() => {
                                    this.setState({ isLoading: true, changeVisitDays: false })
                                    this.getVisitorRegistrationDetails()
                                })
                            })
                        }
                    })
            } else {
                toastError(`Please Select ${countdays} ${countdays > 1 ? "days" : "day"} only`)
            }
        }
    }

    onCancelSwap(id) {
        const { isLoading, isCoordinator, groupVisitDaysList, changeVisitDays, PIID } = this.state
        var tempArr = JSON.parse(JSON.stringify(this.state.tempDaysList))

        if (isCoordinator) {

            this.setState({
                groupVisitDaysList: tempArr, tempDaysList: [], changeVisitDays: false
            })
        } else {
            this.setState({
                daysList: tempArr, tempDaysList: [], changeVisitDays: false
            })
        }
    }
    togglePGCharges(mode, flag, metadata) {
        const { scripts, GroupDetailsList, countryId, isForeignVisitorPop } = this.state
        this.setState({ updateType: flag, metadata: metadata })
        if (mode != 2) {
            // if (sessionStorage.getItem("VisitorTypeID") == 1) {
            if (countryId != 91) {
                this.setState({ isForeignVisitorPop: true })
                return
            } else {

            }
            // } else {
            //     for (var i = 0; i < GroupDetailsList.length; i++) {
            //         if (GroupDetailsList[i].CountryName.trim().toLowerCase() != 'india') {
            //             this.setState({ isForeignVisitorPop: true })
            //             return
            //         }
            //     }
            // }
        }
        if (mode == 2) {
            this.setState({ metadata: [] })
            this.setState({ isForeignVisitorPop: false })
        }
        if (countryId == 91) {
            this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        } else {
            this.setState({ pgViewAddChargesModal: !this.state.pgViewAddChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        }
    }
    render() {
        const { isLoading, repayPOP, PIID, country, changeVisitDays, pgViewChargesModal, pgViewChargesFillList, countryId, countryList, attendeeType, attendeeTypeErr, attendeeList, daysErr, daysList, isOtherPreName, otherName, firstNameErr, firstName, preName, middleName, lastName, designation, designationErr, institute, instituteErr, pgViewAddChargesModal,
            mobNo, mobNoErr, preMobNo, preWhatsAppMobNo, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, regState, regStateErr,
            isDisplayStateList, city, cityErr, isDisplayCityList, pincode, pincodeErr, isDisplayPincodeList, website, email, telNo, preTelNo,
            tel1No, preTel1No, chapterErr, level1, visitPurposeErr, visitPurposeList, needVisaAssistance, passName, passNameErr, applicantMobNo,
            preApplicantMobNo, applicantMobNoErr, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountry, passCountryErr, isDisplayPassCountryList, passportFile, passportFileErr, interestList, remarks,
            isAgree, isVisaApplied, passPortFileName, isOpen, isPassportFilePresent, isVisaUpdated, industryChapterList, isGrpDelegation,
            leader, leaderErr, delegationCountry, delegationCountryErr, isDisplayDelegationCountryList, arrivalDate, arrivalDateErr, departureDate,
            departureDateErr, delegationRemark, delegationRemarkErr, isInterestTwo, isInterstOne, preffDate, preffDateErr, prefTime, preffTimeErr,
            seminarInterestList, b2bRemark, b2bRemarkErr, isOpen2, isCarParking, isParkingChargable, parkingCharges, isParkingAvailable,
            paymentAccessCode, encPayload, noOfDaysSelected, isCoordinator, visitorList, selectedVisitorID, isPaid, primaryChapterListData, level0, level2, level3, level4, ChapterHallErr, isExhibitionFree, pricingList, isOpen4, isInvoice, INVPersonName, INVCompanyName,
            visitorCharges, totaltaxable, CGST, SGST, IGST, totalCharges, INVAddress, INVTanNo, GSTNo, PANNo,
            INVPersonNameErr, isIndi, isOpenConfirmationModal, INVCompanyNameErr, groupVisitDaysList, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr, showINVdetails, countryIdINV, pincodeINV, regStateINV, cancelPOP, cityINV, successPOP, additionalChargesUSD,
            additionalChargesUSDper,
            isOpenDropDownCity, isOpenDropDownCityModal, isOpenDropDownPin, isOpenDropDownPinModal, isOpenDropDownState, isOpenDropDownStateModal, isRegistrationComplete, isVisitorSelect, tempCityList, tempDaysList, tempDelegationCountryList, tempPassCountryList, tempPincodeList, tempStateList } = this.state
        var toShowEduRole = false
        console.log(seminarInterestList, 'seminarInterestListseminarInterestList', groupVisitDaysList)
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (data.AttendeeTypeName == "Education Sector & Others") {
                if (data.isChecked) {
                    toShowEduRole = true
                }
            }
        })
        var isTableUpdateEnable = false
        var toShowOut = false
        var toShowOutGroup = false
        var selectedDays = 0
        if (isCoordinator) {
            for (var i = 0; i < groupVisitDaysList.length; i++) {
                for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (groupVisitDaysList[i].finalDaysList[j].isSelect) {
                        if (groupVisitDaysList[i].finalDaysList[j].isReadOnly == false || groupVisitDaysList[i].finalDaysList[j].isPending) {
                            isTableUpdateEnable = true
                            selectedDays = selectedDays + 1
                        }
                        if (groupVisitDaysList[i].finalDaysList[j].isPending) {
                            toShowOutGroup = true
                        }
                    }

                }
                // if (groupVisitDaysList[i] != undefined && groupVisitDaysList[i].Outstanding != undefined) {
                //     if (groupVisitDaysList[i].Outstanding != 0) {
                //         toShowOut = true
                //     }
                // }
            }
        } else {
            for (var i = 0; i < this.state.daysList.length; i++) {
                if (this.state.daysList[i].isSelect) {
                    if (this.state.daysList[i].isReadOnly == false || this.state.daysList[i].isPending) {
                        // isTableUpdateEnable = true
                        selectedDays = selectedDays + 1
                    }
                }
            }
        }

        var isDirectPayment = false

        // console.log(daysList, ' Single Day Pass / All D',isCoordinator)
        if (false == null) {
            for (var i = 0; i < this.state.daysList.length; i++) {
                if (this.state.daysList[i].isPending != undefined) {
                    if (this.state.daysList[i].isPending) {
                        toShowOut = true
                    }
                }
            }
            for (var i = 0; i < this.state.seminarInterestList.length; i++) {
                if (this.state.seminarInterestList[i].isPending != undefined) {
                    if (this.state.seminarInterestList[i].isPending) {
                        toShowOut = true
                    }
                }
            }

        }
        if (false == null) {
            if (PIID != '' && PIID != null) {
                if (toShowOut) {
                    isDirectPayment = true
                    for (var i = 0; i < this.state.daysList.length; i++) {
                        if (!this.state.daysList[i].isReadOnly && this.state.daysList[i].isSelect) {
                            isDirectPayment = false
                            break
                        }
                    }
                }
            }
        } else {
            // console.log(isDirectPayment)
            if (PIID != '' && PIID != null) {
                if (toShowOutGroup) {
                    isDirectPayment = true
                    for (var i = 0; i < groupVisitDaysList.length; i++) {
                        for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                            if (!groupVisitDaysList[i].finalDaysList[i].isReadOnly && groupVisitDaysList[i].finalDaysList[i].isSelect) {
                                isDirectPayment = false
                                break
                            }
                        }
                    }
                }
            }
        }
        var toShowSwipe = false
        if (false == null) {
            var tempValid = false
            for (var j = 0; j < this.state.daysList.length; j++) {
                if (this.state.daysList[j].isReadOnly == false) {
                    tempValid = true
                }
            }
            if (tempValid) {
                for (var i = 0; i < this.state.daysList.length; i++) {
                    // console.log('//////////tempValid', tempValid, this.state.currentTime)
                    if (this.state.currentTime != '' && this.state.currentTime != null) {
                        if (new Date(`${this.state.daysList[i].VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                        } else {
                            if (this.state.daysList[i].isSelect && this.state.daysList[i].isReadOnly) {
                                // if (groupVisitDaysList[i].finalDaysList[j].isReadOnly == false) {
                                toShowSwipe = true
                                // }
                            }
                        }
                    }
                }
            }
            else {
                toShowSwipe = false
            }
        } else if (false) {
            for (var i = 0; i < groupVisitDaysList.length; i++) {
                var toShowSwipeGrp = false
                var tempValid = false
                for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                    if (groupVisitDaysList[i].finalDaysList[j].isReadOnly == false) {
                        tempValid = true
                    }
                }
                if (tempValid) {
                    for (var j = 0; j < groupVisitDaysList[i].finalDaysList.length; j++) {
                        if (this.state.currentTime != '' && this.state.currentTime != null) {
                            if (new Date(`${groupVisitDaysList[i].finalDaysList[j].VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime()) {
                            } else {
                                if (groupVisitDaysList[i].finalDaysList[j].isSelect && groupVisitDaysList[i].finalDaysList[j].isReadOnly) {
                                    // if (groupVisitDaysList[i].finalDaysList[j].isReadOnly == false) {
                                    groupVisitDaysList[i].toShowSwipe = true
                                    // }
                                }
                            }
                        }
                    }
                } else {
                    groupVisitDaysList[i].toShowSwipe = false
                }
            }
        }
        // var 
        setTimeout(() => {
            console.log(this.state.totalCharges, this.state.toShow, this.state.additionalChargesUSD, this.state.additionalChargesUSDper, this.state.conversionRate)
            // console.log('//////////', toShowSwipe, isOpenConfirmationModal, toShowOut, false == null, this.state.changeVisitDays)

        }, 2000);

        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
        var paymentFlag = false
        var newnoOfDaysSelected = 0
        daysList.length > 0 && daysList.map((item => {
            if (item.isSelect) {
                newnoOfDaysSelected++
            }
        }))
        if (newnoOfDaysSelected > noOfDaysSelected) {
            paymentFlag = true
        }
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <Modal isOpen={isOpen2} onRequestClose={(e) => this.toggleModal(e)}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail"
                    // tabIndex={-1}
                    // aria-labelledby="detailLabel"
                    // aria-hidden="true"
                    >
                        <div className="modal-dialog modal-md">
                            <div className="modal-content estimate-details2">
                                <div className="modal-header pb-1">
                                    <h5 className="modal-title" id="detailLabel">
                                        <strong>Exhibitor list for meeting at respective booth.</strong>
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close pt-6"
                                        data-bs-dismiss="modal"
                                        style={{ fontSize: 12 }}
                                        aria-label="Close"
                                        onClick={(e) => this.toggleModal(e)}
                                    />
                                </div>
                                <iframe
                                    id="myIframe"
                                    src='images/B2BEXHIBITOR.pdf#toolbar=0'
                                    width="800px"
                                    height="800px"
                                // title="Bing"
                                />

                            </div>
                        </div>
                    </div>
                </Modal>
                <div
                    className="main-content app-content mt-3 with-dr-container" >
                    <div style={{ marginTop: '20px !important' }}>


                        <div style={{ marginTop: '20px' }}>
                            {/* <VisitorTopMenu /> */}
                        </div>

                        <div className="side-app">
                            {/* <div className="container-fluid p-0">
                            <div className="row">
                                <div
                                    className="step-name" style={{ backgroundColor: "#bc202b", color: "#fff;", marginLeft: "225px" }}
                                >
                                    <p>ITME Africa &amp; Middle East 2023 Visitor Registration form</p>
                                </div>
                            </div>
                        </div> */}
                            {isCoordinator &&
                                <div class="table-responsive">
                                    <div className="combine-section">
                                        <div className="needs-validation after-step mt-1">
                                            <div id="Menu1">
                                                <div id="section-1">
                                                    <div className="one-section">
                                                        <div className="containerfluid">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="p-1 title-bg">
                                                                        <p className="mb-0">Visitor List</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="m-3">
                                                            <table className="table border table-bordered mb-0 mt-1 " >
                                                                <thead>
                                                                    <tr>
                                                                        {/* <th className="text-center" style={{ width: '50px' }}>Selected Visitor</th> */}
                                                                        <th className="text-center" style={{ width: '180px' }}>Visitor Registration No.</th>
                                                                        <th className="text-center" style={{ width: '180px' }}>Name</th>
                                                                        <th className="text-center" style={{ width: '380px' }}>Institue/Organization</th>
                                                                        <th className="text-center" style={{ width: '450px' }}>Visit Days</th>
                                                                        <th className="text-center" style={{ width: '70px' }}>Action</th>
                                                                        {/* {toShowOut &&
                                                                <th className="text-center" style={{ width: '180px' }}>Outstanding</th>
                                                            }
                                                            <th className="text-center" style={{ width: '180px' }}>Total Payable</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        groupVisitDaysList.length > 0 && groupVisitDaysList.map((data) => (
                                                                            <tr key={Math.random()}>
                                                                                {/* <td className="text-center">
                                                                        <input type="checkbox" select={data.isSelected}
                                                                            checked={data.isSelected} value={data.ExhVisitorID}
                                                                            onChange={}
                                                                        />
                                                                    </td> */}
                                                                                <td className="text-center"><p style={{ cursor: 'pointer' }} className={data.isSelected ? 'text-primary text-center' : 'text-center'} onClick={(e) => this.onVisitorSelect(data)}>
                                                                                    {data.VisitorRegistrationNo}</p></td>
                                                                                <td className="text-center">{data.PersonIncharge}</td>
                                                                                <td className="text-center">{data.Institute_Organisation}</td>
                                                                                <td>
                                                                                    <div className="row">
                                                                                        {data.finalDaysList.length > 0 && data.finalDaysList.map((item) => (
                                                                                            <div className={window.innerWidth < 1200 ? "col-sm-12" : "col-sm-4"} key={item.Code}>
                                                                                                <label className="d-flex"
                                                                                                    style={{ color: item.isPending && "red" }}
                                                                                                >
                                                                                                    <input type="checkbox" select={item.isSelect} disabled
                                                                                                        disabled={this.state.currentTime != '' && this.state.currentTime != null ? new Date(`${item.VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime() ? true : item.isReadOnly : item.isReadOnly}
                                                                                                        checked={item.isSelect} value={item.Code}
                                                                                                        onChange={(e) => this.state.changeVisitDays ? this.state.changeVisitDaysId != data.ExhVisitorID ? toastError("Cant swap visit days of different visitors") : this.onSelectGroupDates(e, data) : this.onSelectGroupDates(e, data)}
                                                                                                    />
                                                                                                    <span style={{ whiteSpace: "nowrap" }}>{item.VisitDate}</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    {data.toShowSwipe ? this.state.changeVisitDays ? this.state.changeVisitDaysId == data.ExhVisitorID ?
                                                                                        <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                                                                                            <button className="btn btn-aqua btn-sm rounded-0 mr-0"
                                                                                                // style={ }
                                                                                                // disabled={toShowOut}
                                                                                                // onClick={(e) => this.onSubmitdaysSwap(data.ExhVisitorID)}
                                                                                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [data.ExhVisitorID] })}
                                                                                            >Submit</button>
                                                                                            <button className="btn btn-gray btn-sm rounded-0  ms-0"
                                                                                                // style={ }
                                                                                                // disabled={toShowOut}
                                                                                                onClick={(e) => this.onCancelSwap()}
                                                                                            >cancel</button>
                                                                                        </div>
                                                                                        : <button className="btn btn-aqua rounded-0  mr-2"
                                                                                            // style={ }
                                                                                            disabled={isTableUpdateEnable ? true : this.state.changeVisitDays}
                                                                                            onClick={(e) => this.changeVisitDays(data.ExhVisitorID)}
                                                                                        >Swipe Days</button> : <button className="btn btn-aqua rounded-0  mr-2"
                                                                                            // style={ }
                                                                                            disabled={isTableUpdateEnable ? true : this.state.changeVisitDays}
                                                                                            onClick={(e) => this.changeVisitDays(data.ExhVisitorID)}
                                                                                        >Swipe Days</button>
                                                                                        : <></>}
                                                                                </td>
                                                                                {/* {toShowOut &&
                                                                        <td className="text-center">{data.Outstanding == null ? 0 : data.Outstanding}</td>}
                                                                    <td className="text-center">{data.TotalPayable == null || data.TotalPayable == 0 ? 'NA' : data.TotalPayable}</td> */}

                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            }
                            {isCoordinator && isTableUpdateEnable && !changeVisitDays &&
                                <div className="row mt-4 m-3">
                                    <div className="col-md-4">
                                        <div className="row mb-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <h5 className="mb-0">Visitor Registration Charges</h5>
                                                <h5 className="mb-0">{this.state.countryId == 91 ? '₹' : '$'}{visitorCharges}</h5>
                                            </div>
                                            <div className="row" style={{ paddingRight: 0, textAlign: 'left' }}>
                                                {/* {console.log('paymentDatesList', paymentDatesList[0])} */}
                                                {/* {paymentDatesList.length > 0 && paymentDatesList.map((item, i) => (
                                                                    <div className="d-flex justify-content-between" style={{ padding: 0 }}>
                                                                        <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                            <>{item2}
                                                                                {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                &nbsp;
                                                                            </>))})</p>
                                                                    </div>
                                                                ))} */}
                                                {/* <strong onClick={() => this.setState({ isOpen4: true })} className="text-primary" style={{ cursor: 'pointer' }}>(Click here to view Visit Days)</strong> */}
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="d-flex justify-content-between mb-2">
                                                <h5 className="mb-0">Total Taxable </h5>
                                                <h5 className="mb-0">{this.state.countryId == 91 ? '₹' : '$'}{this.state.totaltaxable}</h5>
                                            </div>
                                        </div>

                                        {/* {isParkingAvailable && isCarParking != 0 && parkingCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="col-6">
                                                                        <h6>Parking Charges</h6>
                                                                    </div>
                                                                    <div className="col-6 text-end">
                                                                        <h6>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{isCarParking ? parkingCharges : 0}</h6>
                                                                    </div>
                                                                </div>
                                                            )} */}

                                        {this.state.CGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0">CGST</h5>
                                                    <h5 className="mb-0">{this.state.countryId == 91 ? '₹' : '$'}{this.state.CGST}</h5>
                                                </div>
                                            </div>
                                        )}

                                        {this.state.SGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0">SGST</h5>
                                                    <h5 className="mb-0">{this.state.countryId == 91 ? '₹' : '$'}{this.state.SGST}</h5>
                                                </div>
                                            </div>
                                        )}

                                        {this.state.IGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0">IGST</h5>
                                                    <h5 className="mb-0">{this.state.countryId == 91 ? '₹' : '$'}{this.state.IGST}</h5>
                                                </div>
                                            </div>
                                        )}


                                        <div className="row mt-n2">
                                            <div className="col-md-12">
                                                <hr />
                                            </div>
                                        </div>
                                        <div className="row  " >
                                            <div className="d-flex justify-content-between mb-2">
                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>Total Charges</h6>
                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>{this.state.countryId == 91 ? '₹' : '$'}{this.state.totalCharges}</h6>
                                            </div>
                                        </div>
                                        <div className="row mt-n2">
                                            <div className="col-md-12">
                                                <hr />
                                            </div>
                                        </div>
                                        {/* <div className="row border-top pt-2 mt-2 align-items-start">
                                                                
                                                                <div className="col-6">
                                                                    <h5>Total Charges</h5>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h5>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{totalCharges}</h5>
                                                                </div>
                                                            </div> */}
                                    </div>
                                    {toShowOutGroup && <div className="mt-2" style={{ textAlign: 'left', color: 'red' }}>
                                        <p><strong>(Your Payment was not completed. Please Try again)</strong></p>
                                    </div>}
                                    <div style={{ textAlign: 'left' }}>
                                        <button className="btn btn-aqua rounded-0 "
                                            // style={ }
                                            disabled={!isTableUpdateEnable}
                                            // this.navToPayment() 
                                            onClick={(e) => isDirectPayment ?
                                                this.togglePGCharges(1, 3)
                                                : toShowOutGroup ? this.setState({ repayPOP: true }) :
                                                    this.togglePGCharges(1, 2)
                                            }
                                        //  this.onUpdateGroupDays()
                                        >{toShowOutGroup ? 'Re-Pay' : 'Pay'}</button>
                                        {toShowOutGroup && <button className="btn btn-gray rounded-0 ms-2"
                                            // style={ }
                                            disabled={!toShowOutGroup}
                                            onClick={(e) => this.setState({ cancelPOP: true })}
                                        >Cancel Payment</button>}
                                    </div>
                                </div>
                            }
                            {/* {isCoordinator && <div className='col-md-4 mt-4 mb-2 ms-2'>
                            <div className=" mb-0">
                                <label className=''>Selected Visitor Profile</label>
                                <select className="form-control select2 select-hidden-accessible pl-0"
                                    style={{ width: "100%" }}
                                    value={selectedVisitorID}
                                    onChange={e => this.onVisitorSelect(e)}
                                >
                                    {
                                        visitorList.length > 0 && visitorList.map((item) => (
                                            <option key={item.AccountID} value={item.AccountID}>{item.PersonIncharge} {item.LastNamePersonIncharge}</option>
                                        ))
                                    }
                                </select>

                            </div>
                        </div>} */}
                            <div className="combine-section">
                                <div className="needs-validation after-step mt-1">
                                    <div id="Menu1">
                                        <div id="section-1">
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Country</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 mb-3">
                                                    <div className="d-flex">
                                                        <label className="mt-3 w-auto" >
                                                            Select Country
                                                            <span className="text-red">*</span>

                                                        </label>
                                                        {/* {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdErr}</span>} */}
                                                    </div>
                                                    <select className="form-control"
                                                        value={countryId} disabled={true}
                                                    // onChange={(e) => this.onCountrySelect(e)}
                                                    >
                                                        <option value={''}>Select Your Country</option>
                                                        {
                                                            countryList.length > 0 && countryList.map((data) => (
                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Visitor Type <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.visitorTypeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            this.state.visitorTypeList.length > 0 && this.state.visitorTypeList.map((data) => (
                                                                <div className="col-sm-4" key={data.VisitorTypeID}>
                                                                    <label className="d-flex">
                                                                        <input type="radio" name="vistorType" value={data.VisitorTypeID}
                                                                            checked={data.VisitorTypeID == this.state.VisitorTypeID}
                                                                            disabled
                                                                            // onChange={e => this.setState({ attendeeType: "Business Visitor" })}
                                                                            onChange={(e) => this.setState({ VisitorTypeID: data.VisitorTypeID, })}
                                                                        />
                                                                        {data.VisitorType}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Attendee Type <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{attendeeTypeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-8 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            attendeeList.length > 0 && attendeeList.map((data) => (
                                                                <div className="col-sm-4" key={data.AttendeeTypeID}>
                                                                    <label className="d-flex">
                                                                        <input type="radio" name="attendeeType" value={data.AttendeeTypeID}
                                                                            checked={data.isChecked}
                                                                            disabled
                                                                            onChange={(e) => this.onAttendeeSelect(e)}
                                                                        />
                                                                        {data.AttendeeTypeName}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <span className="mb-0" onClick={() => !isExhibitionFree ? this.setState({ isOpen4: true }, () => console.log("click")) : null}>
                                                                    Date of Visit Single Day Pass / All Day Pass <span className="text-red">*</span> &nbsp; &nbsp; &nbsp;  {!isExhibitionFree && <spa style={{ color: 'red' }}>Visit days Charges</spa>}
                                                                </span>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* {console.log('daysList', daysList)} */}
                                                <div className="col-xl-4 mb-4">
                                                    <div className="row mt-4" >
                                                        {
                                                            daysList.length > 0 && daysList.map((data) => (
                                                                <div className="col-sm-4" key={data.Code}>
                                                                    <label className="d-flex"
                                                                        style={{ color: data.isPending && isCoordinator == null && "red" }}
                                                                    >
                                                                        <input type="checkbox" select={data.isSelect} disabled
                                                                            // disabled={!isIndi ? true : this.state.currentTime != '' && this.state.currentTime != null ? new Date(`${data.VisitDate} ${this.state.ExhSrtTime}`).getTime() < new Date(this.state.currentTime).getTime() ? true : data.isReadOnly : data.isReadOnly}
                                                                            checked={isCoordinator != null ? data.isPending ? false : data.isSelect : data.isSelect} value={data.Code}
                                                                            onChange={(e) => this.onSelectDates(e)}
                                                                        />
                                                                        {data.VisitDate}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                    {toShowSwipe ? !toShowOut && false == null && !this.state.changeVisitDays && <div style={{ textAlign: 'left' }}>
                                                        <button className="btn btn-aqua rounded-0  mr-2"
                                                            // style={ }
                                                            disabled={toShowOut}
                                                            onClick={(e) => this.changeVisitDays()}
                                                        >Swipe Days</button>
                                                    </div> : <></>}
                                                    {!toShowOut && false == null && this.state.changeVisitDays && <div style={{ textAlign: 'left' }}>
                                                        <button className="btn btn-aqua rounded-0  mr-2"
                                                            // style={ }
                                                            disabled={toShowOut}
                                                            // onClick={(e) => this.onSubmitdaysSwap()}
                                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 3 }, popArg: [] })}
                                                        >Submit</button>
                                                        <button className="btn btn-gray rounded-0  ms-2"
                                                            // style={ }
                                                            disabled={toShowOut}
                                                            onClick={(e) => this.onCancelSwap()}
                                                        >cancel</button>
                                                    </div>}
                                                    {/* {!toShowOut && false == null && this.state.changeVisitDays && <div style={{ textAlign: 'left' }}>
                                                    
                                                </div>} */}
                                                </div>

                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Personal Information</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-3 mt-3">
                                                            <label>
                                                                First Name<span className="text-red">*</span>
                                                            </label>
                                                            <div className="name-input-group">
                                                                <select
                                                                            className="form-control name-prefix"
                                                                            id="validationCustom03"
                                                                            required=""
                                                                            disabled
                                                                            value={preName}
                                                                        // onChange={(e) => this.setState({
                                                                        //     preName: e.target.value,
                                                                        //     isOtherPreName: e.target.value == "Other" && true
                                                                        // })}
                                                                        >
                                                                            <option value="Mr">Mr</option>
                                                                            <option value="Ms">Ms</option>
                                                                            <option value="DR">DR</option>
                                                                            <option value="Prof">Prof</option>
                                                                            <option value="Other">Other</option>
                                                                        </select>
                                                                {
                                                                    isOtherPreName &&
                                                                    <input
                                                                        type="text"
                                                                        className="form-control name-other"
                                                                        maxLength={'40'}
                                                                        value={otherName}
                                                                        disabled
                                                                        onChange={e => this.setState({ otherName: e.target.value })}
                                                                        placeholder={'Other'}
                                                                    />
                                                                }
                                                                <input
                                                                    type="text"
                                                                    className="form-control name-no"
                                                                    maxLength={'50'}
                                                                    disabled
                                                                    value={firstName}
                                                                // onChange={(e) => this.setState({ firstName: e.target.value, firstNameErr: "" })}
                                                                />
                                                            </div>
                                                            {/* {<span className='text-danger text-start text-left d-block'>{firstNameErr}</span>} */}

                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Middle Name</label>
                                                            <input type="text" className="form-control"
                                                                value={middleName} disabled
                                                                maxLength={'50'}
                                                            // onChange={(e) => this.setState({ middleName: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Last Name
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control"
                                                                value={lastName} maxLength={'50'} disabled
                                                            // onChange={(e) => this.setState({ lastName: e.target.value, lastNameErr: "" })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErr}</span>} */}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="d-flex mt-3">
                                                                Institute/Organisation <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control"
                                                                value={institute} maxLength={'500'} disabled
                                                                onChange={(e) => this.setState({ institute: e.target.value, instituteErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{instituteErr}</span>}

                                                        </div>

                                                    </div>
                                                </div>
                                                {/* <div className="col-xl-4 mb-4">
                                            <div className="row mt-2">
                                                <div className="col-sm-2">
                                                    <label className="d-flex">
                                                        Gender:
                                                        <span className="text-red">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-sm-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="gender"
                                                            checked={gender == "Male"}
                                                            onChange={e => this.setState({ gender: "Male" })}
                                                        />
                                                        Male
                                                    </label>
                                                </div>
                                                <div className="col-sm-4">
                                                    <label className="d-flex">
                                                        <input type="radio" name="gender"
                                                            checked={gender == "Female"}
                                                            onChange={e => this.setState({ gender: "Female" })}
                                                        />
                                                        Female
                                                    </label>
                                                </div>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{genderErr}</span>}
                                            </div>
                                        </div> */}
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row">

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2"> Email
                                                                <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control"
                                                                value={email} maxLength={'50'} disabled
                                                            // onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>} */}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">Mobile No
                                                                <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" readOnly
                                                                    placeholder="ISD" maxLength={'4'}
                                                                    value={preMobNo} disabled
                                                                />
                                                                <input
                                                                    type="number" disabled
                                                                    className="form-control phone-no"
                                                                    value={mobNo}
                                                                    maxLength={'10'}
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 &&
                                                                        this.setState({ mobNo: e.target.value, mobNoErr: "" })}
                                                                />
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{mobNoErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2"> WhatsApp Mobile No
                                                                <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" readOnly
                                                                    value={preWhatsAppMobNo}
                                                                    placeholder="ISD"
                                                                    maxLength={'4'} disabled
                                                                />
                                                                <input
                                                                    type="number"
                                                                    className="form-control phone-no" disabled
                                                                    value={whatsAppMobNo}
                                                                    maxLength={'10'}
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 &&
                                                                        this.setState({ whatsAppMobNo: e.target.value, whatsAppMobNoErr: "" })}
                                                                />
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{whatsAppMobNoErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-6">
                                                                <input type="checkbox" name="fav_language" disabled
                                                                    value={isSameAsMobNo} checked={isSameAsMobNo}
                                                                    onClick={(e) => this.onSameAsMobNoClick(e)}
                                                                />
                                                                Same as Mobile No
                                                            </label>
                                                        </div>
                                                        {toShowEduRole && <div className="col-xl-3">
                                                            <div className="d-flex">
                                                                <label className="w-auto mt-2" >
                                                                    Education Role
                                                                    <span className="text-red">*</span>

                                                                </label>

                                                            </div>
                                                            <select className="form-control" value={this.state.educationRoleTypeId}
                                                                onChange={(e) => this.onEduRoleSelect(e)}
                                                            >
                                                                <option value={''}>Select Education Role</option>
                                                                {
                                                                    this.state.educationRoleTypeList.length > 0 && this.state.educationRoleTypeList.map((data) => (
                                                                        <option key={data.EducationRoleTypeID} value={data.EducationRoleTypeID} >{data.EducationRoleTypeName}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{this.state.educationRoleTypeIdErr}</span>}
                                                        </div>}
                                                        {toShowEduRole && (this.state.eduRoleName.toLowerCase().includes('student') || this.state.eduRoleName.toLowerCase().includes('faculty')) && <div className="col-xl-3">
                                                            <label className="d-flex mt-2">
                                                                Identity Card <span className="text-red">*</span>
                                                                {this.state.identityCardPath ? <a href={this.state.identityCardPath} target="_blank" rel="noreferrer" className="ms-2 text-primary" style={{ fontSize: '12px', fontWeight: 'normal' }}>View</a> : null}
                                                            </label>
                                                            <input
                                                                type="file" disabled
                                                                className="form-control"
                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                onChange={(e) => this.onIdentityCardFilePick(e)}
                                                            />
                                                            {this.state.identityCardFileName ? <span className="text-success mt-1 d-block" style={{ fontSize: '12px' }}>{this.state.identityCardFileName}</span> : null}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{this.state.identityCardFileErr}</span>}
                                                        </div>}
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Designation <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" disabled={toShowEduRole && this.state.educationRoleTypeId != 5}
                                                                value={designation} maxLength={'50'} disabled
                                                                onChange={(e) => this.setState({ designation: e.target.value, designationErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{designationErr}</span>}

                                                        </div>
                                                        {/* <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Photo <span className="rad-star">*</span>
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="photoFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                        />
                                                        {
                                                            photoFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{photoFileErr}</span>}
                                                </div>
                                                <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Photo ID <span className="rad-star">*</span>
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="photoIdFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                        />
                                                        {
                                                            photoIdFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(2)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{photoIdFileErr}</span>}

                                                </div>
                                                <div className="col-xl-4">
                                                    <label className="mt-4">
                                                        Upload Fully Vaccination Certificate
                                                    </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="vaccFile" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 3)}
                                                        />
                                                        {
                                                            vaccineCertificateFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(3)}></i>
                                                        }
                                                    </form>

                                                    <p>
                                                        <strong>Note:</strong> Upload Maximum 2mb Size Only /
                                                        Allowed File Type: .jpg,.png
                                                    </p>
                                                </div> */}
                                                        {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 1</label>
                                                    <input type="text" className="form-control" value={add1}
                                                        onChange={(e) => this.setState({ add1: e.target.value })}
                                                    />
                                                </div> */}
                                                        {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 2</label>
                                                    <input type="text" className="form-control" value={add2}
                                                        onChange={(e) => this.setState({ add2: e.target.value })}
                                                    />
                                                </div> */}
                                                        {/* <div className="col-sm-6">
                                                    <label className="d-flex mt-2"> Address Line 3</label>
                                                    <input type="text" className="form-control" value={add3}
                                                        onChange={(e) => this.setState({ add3: e.target.value })}
                                                    />
                                                </div> */}
                                                        {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2">
                                                        Country<span className="red-star text-danger">*</span>
                                                    </label>
                                                    <input type="text" className="form-control" value={personalCountry}
                                                        onChange={(e) => this.onPersonalCountrySearch(e)}
                                                    />
                                                    {isDisplayPersonalCountryList && this.renderPersonalCountryList()}
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{personalCountryErr}</span>}
                                                </div> */}
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Pincode/Zipcode
                                                                {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            {/* {
                                                            countryId == "91" &&
                                                            // <input type="number" className="form-control"
                                                            //     value={pincode}
                                                            //     maxLength={6} onChange={(e) => this.onPincodeSearch(e)}
                                                            // />
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={6} onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e) : null}
                                                            />
                                                        }
                                                        {
                                                            countryId != "91" &&
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e)}
                                                                onInput={toInputUppercase}
                                                            />
                                                        }
                                                        {isDisplayPincodeList && this.renderPincodeList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                value={pincode} disabled
                                                                maxLength={countryId == "91" ? 6 : 10}
                                                                // onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 0) : null}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => pincode.length > 0 && this.setState({ isOpenDropDownPin: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownPin: false })}
                                                                onBlur={() => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownPin: false })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 2, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownPin && tempPincodeList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempPincodeList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 0)}
                                                                            // className={this.state.focusedIndexPin === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexPin === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 2, 0)}
                                                                        >
                                                                            {item.Pincode}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                State/Province
                                                                {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            {/* <input type="text" className="form-control" value={regState} maxLength={'50'}
                                                            onChange={(e) => this.onStateSearch(e)}
                                                        />
                                                        {isDisplayStateList && this.renderStateList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                disabled
                                                                value={regState}
                                                                onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => regState.length > 0 && this.setState({ isOpenDropDownState: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownState: false })}
                                                                onBlur={() => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownState: false })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 0, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownState && tempStateList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempStateList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 0)}
                                                                            // className={this.state.focusedIndexState === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexState === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 0, 0)}
                                                                        >
                                                                            {item.Description}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{regStateErr}</span>}
                                                        </div>

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">City
                                                                <span className="red-star text-danger">*</span>
                                                            </label>
                                                            {/* <input type="text" className="form-control" value={city} maxLength={'50'}
                                                            onChange={(e) => this.onCitySearch(e)} />
                                                        {isDisplayCityList && this.renderCityList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                value={city} disabled
                                                                onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 0)}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => city.length > 0 && this.setState({ isOpenDropDownCity: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                                onBlur={() => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownCity: false })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 1, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownCity && tempCityList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempCityList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 0)}
                                                                            // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexCity === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 1, 0)}
                                                                        >
                                                                            {item.Description}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{cityErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2"> Website</label>
                                                            <input type="text" className="form-control"
                                                                value={website} maxLength={'50'} disabled
                                                                onChange={(e) => this.setState({ website: e.target.value })}
                                                            />
                                                        </div>
                                                        {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> GST No</label>
                                                    <input type="text" className="form-control" value={gstNo}
                                                        onChange={(e) => this.setState({ gstNo: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> PAN No</label>
                                                    <input type="text" className="form-control" value={panNo}
                                                        onChange={(e) => this.setState({ panNo: e.target.value })}
                                                    />
                                                </div> */}

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">Telephone No</label>
                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" disabled
                                                                    value={preTelNo} placeholder="STD" maxLength={'4'}
                                                                    onChange={(e) => this.setState({ preTelNo: e.target.value })}
                                                                />
                                                                <input
                                                                    type="number"
                                                                    className="form-control phone-no" disabled
                                                                    value={telNo}
                                                                    maxLength={'10'}
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.preventMinus(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 && this.setState({ telNo: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">Telephone No 1</label>
                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" disabled
                                                                    value={preTel1No} placeholder="STD" maxLength={'4'}
                                                                    onChange={(e) => this.setState({ preTel1No: e.target.value })}
                                                                />
                                                                <input
                                                                    type="number" disabled
                                                                    className="form-control phone-no"
                                                                    value={tel1No}
                                                                    maxLength={'10'}
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 && this.setState({ tel1No: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {showINVdetails && <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg ">
                                                                <label className="ms-3">
                                                                    <input type="checkbox" name="fav_language"
                                                                        value={this.state.isInvoice} checked={this.state.isInvoice}
                                                                        disabled
                                                                        onClick={(e) => this.setState({
                                                                            isInvoice: !this.state.isInvoice,
                                                                            INVPersonNameErr: '',
                                                                            INVCompanyNameErr: '',
                                                                            INVAddressErr: '',
                                                                            INVTanNoErr: '',
                                                                            GSTNoErr: '',
                                                                            PANNoErr: '',
                                                                        })}
                                                                    />Invoice Details
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.isInvoice && <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Person Incharge Name<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={INVPersonName}
                                                                disabled
                                                                maxLength={'50'}
                                                                onChange={(e) => this.setState({ INVPersonName: e.target.value, INVPersonNameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVPersonNameErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Company Name<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={INVCompanyName}
                                                                disabled
                                                                maxLength={'200'}
                                                                onChange={(e) => this.setState({ INVCompanyName: e.target.value, INVCompanyNameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVCompanyNameErr}</span>}

                                                        </div>
                                                        <div className="col-xl-6 mb-1">
                                                            <label className="mt-3">Address
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={INVAddress} maxLength={'50'}
                                                                disabled
                                                                onChange={(e) => this.setState({ INVAddress: e.target.value, INVAddressErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVAddressErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mt-2">
                                                            <div className="d-flex">
                                                                <label className=" w-auto" >
                                                                    Select Country
                                                                    <span className="text-red">*</span>

                                                                </label>
                                                                {/* {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdINVErr}</span>} */}
                                                            </div>
                                                            <select className="form-control" value={countryIdINV}
                                                                disabled
                                                            // onChange={(e) => this.onCountrySelectINV(e)}
                                                            >
                                                                <option value={''}>Select Your Country</option>
                                                                {
                                                                    countryId != 91 ? countryList.length > 0 && countryList.map((data) => (
                                                                        data.Code != 91 && <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    )) : countryList.length > 0 && countryList.map((data) => (
                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Pincode/Zipcode
                                                                {countryIdINV == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            {
                                                                countryIdINV == "91" &&
                                                                <input type="text" className="form-control" value={pincodeINV}
                                                                    disabled
                                                                // maxLength={6} onChange={(e) => this.onPincodeSearchINV(e)}
                                                                />
                                                            }
                                                            {
                                                                countryIdINV != "91" &&
                                                                <input type="text" className="form-control" value={pincodeINV}
                                                                    disabled
                                                                // maxLength={10} onChange={(e) => this.onPincodeSearchINV(e)}
                                                                // onInput={toInputUppercase}
                                                                />
                                                            }
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{pincodeINVErr}</span>} */}
                                                            {/* {isDisplayPincodeListINV && this.renderPincodeListINV()} */}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                State/Province
                                                                {countryIdINV == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            <input type="text" className="form-control" value={regStateINV} maxLength={'50'}
                                                                disabled
                                                            // onChange={(e) => this.onStateSearchINV(e)}
                                                            />
                                                            {/* {isDisplayStateListINV && this.renderStateListINV()} */}
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regStateINVErr}</span>} */}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">City
                                                                <span className="red-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={cityINV} maxLength={'50'}
                                                                disabled
                                                            // onChange={(e) => this.onCitySearchINV(e)} 
                                                            />
                                                            {/* {isDisplayCityListINV && this.renderCityListINV()} */}
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{cityINVErr}</span>} */}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">PAN Number<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={PANNo}
                                                                disabled
                                                                maxLength={'50'}
                                                                onChange={(e) => {
                                                                    const errMsg = panNoValidator(e.target.value)
                                                                    this.setState({ PANNo: e.target.value, PANNoErr: '' })
                                                                    if (errMsg != '') {
                                                                        this.setState({
                                                                            PANNoErr: errMsg,
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            PANNoErr: "",
                                                                        })
                                                                    }
                                                                }
                                                                }
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{PANNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">TAN Number<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={INVTanNo}
                                                                disabled
                                                                maxLength={'50'}
                                                                onChange={(e) => {
                                                                    const errMsg = tanNoValidator(e.target.value)
                                                                    this.setState({
                                                                        INVTanNo: e.target.value,
                                                                    })
                                                                    if (errMsg != '') {
                                                                        this.setState({
                                                                            INVTanNoErr: errMsg,
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            INVTanNoErr: "",
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVTanNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">GST Number<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={GSTNo}
                                                                disabled
                                                                maxLength={'50'}
                                                                onChange={(e) =>
                                                                    this.onGSTchange(e.target.value)
                                                                }
                                                                onInput={toInputUppercase}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{GSTNoErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>}
                                            <div style={{ height: 20 }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="needs-validation after-step mt-1" style={{ marginTop: 115 }}>
                                    <div id="Menu2">
                                        <div className="containerfluid">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg d-flex">
                                                        <p className="mb-0">Industry Segment <span className="text-red">*</span>
                                                        </p>
                                                        {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{chapterErr}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mt-2" id="section-2">
                                            <div className="one-section">
                                                <div className=" mb-2">
                                                    <div className="row mt-1">
                                                        <div className="asc">
                                                            <div className="" style={{ paddingLeft: 10 }}>
                                                                <form className="needs-validation pb-2" noValidate="">
                                                                    <div className="form-row mt-3">
                                                                        {
                                                                            industryChapterList.length > 0 && industryChapterList.map((data) => (
                                                                                <div className="col-sm-3 mb-3">
                                                                                    <section className="accordion" key={data.IndustrySegmentID}>
                                                                                        {/* <input type="checkbox" name="collapse"
                                                                                    select={data.IsSelect} checked={data.IsSelect}
                                                                                    value={data.IndustrySegmentID}

                                                                                /> */}
                                                                                        <h2 className="handle-no-icon m-0" style={{ fontSize: '13px' }}>
                                                                                            <label>
                                                                                                <input type="checkbox" disabled
                                                                                                    select={data.IsSelect} checked={data.IsSelect}
                                                                                                    value={data.IndustrySegmentID}
                                                                                                    onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                                {data['Industrial Segment']}
                                                                                            </label>
                                                                                        </h2>
                                                                                    </section>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Products <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        <div class="accordion" id="accordionExample">
                                                            {
                                                                level2.length > 0 && level2.map(level2Data => (
                                                                    <>
                                                                        {
                                                                            // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                            <div class="accordion-item">
                                                                                <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                    <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                        type="button" data-bs-toggle="collapse"
                                                                                        data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                        aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                        {/* // checkbox for level2 */}
                                                                                        {
                                                                                            level2Data.IsCheckbox &&
                                                                                            <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID} disabled
                                                                                                checked={level2Data.IsSelect}
                                                                                                onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                        }
                                                                                        {level2Data.ChapterName} </button>
                                                                                </h2>
                                                                                {this.recordTwo(level2Data, level3, level4)}
                                                                            </div>
                                                                        }

                                                                    </>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="" style={{ marginLeft: "10px" }}>
                                                    <p className="mb-0" style={{ fontSize: 15 }}>
                                                        <strong> Selected Products</strong>
                                                    </p>
                                                </div>
                                                <div style={{ padding: "0px 0px 0px 10px" }}>
                                                    {
                                                        filerArray.length > 0 ? filerArray.map((data) => (
                                                            <p>
                                                                {data.ChapterName}
                                                            </p>
                                                        )) :
                                                            <p>
                                                                {"No Results"}
                                                            </p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Purpose of Visit <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-2">
                                                    <div className="row mt-4">
                                                        {
                                                            visitPurposeList.length > 0 && visitPurposeList.map((data) => (
                                                                <div className="col-sm-3 mb-2" key={data.PurposeofVisitID}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" name="fav_language"
                                                                            select={data.isSelect} checked={data.isSelect}
                                                                            value={data.PurposeofVisitID} disabled
                                                                            onChange={(e) => this.onSelectPurpose(e)}
                                                                        />
                                                                        {data.PurposeofVisitName}
                                                                    </label>
                                                                    {
                                                                        data.PurposeofVisitID == 10 && data.isSelect &&
                                                                        <input
                                                                            className="form-control"
                                                                            maxLength={'100'}
                                                                            value={data.otherDetail} disabled
                                                                            onChange={(e) => this.otherDetailsChange(e)}
                                                                        >
                                                                        </input>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/* {!(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && <div className="one-section mb-3">
                                            <div className="col-sm-3 ">
                                                <label className="d-flex">
                                                    <input className="do-you"
                                                        type="checkbox"
                                                        name="fav_language"
                                                        checked={isGrpDelegation}
                                                        onChange={(e) => this.setState({
                                                            isGrpDelegation: !isGrpDelegation

                                                        })}
                                                    />
                                                    <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>Are you part of Group Delegation ?</strong>
                                                        (If yes below section would open)</span>
                                                </label>
                                            </div>
                                            {
                                                isGrpDelegation &&
                                                <div
                                                    className="col-md-12 mb-2"
                                                    id="divMsg"
                                                >
                                                    <div className="row">
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Delegation Leader/Organisation<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={leader} maxLength={'50'}
                                                                onChange={(e) => this.setState({ leader: e.target.value, leaderErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{leaderErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Country/Region<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={delegationCountry}
                                                                onChange={(e) => this.onDelegationCountrySearch(e)}
                                                            />
                                                            {isDisplayDelegationCountryList && this.renderDelegationCountryList()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{delegationCountryErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">Arrival Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={arrivalDate}
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        arrivalDateErr: ""
                                                                    })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Arrival Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">Departure Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={departureDate}
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        departureDateErr: ""
                                                                    })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Departure Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>}
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xl-12 mb-1">
                                                                <label className="mt-3">Remark
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <textarea
                                                                    className="form-control"
                                                                    rows={3}
                                                                    maxLength={'250'}
                                                                    defaultValue={""}
                                                                    value={delegationRemark}
                                                                    onChange={(e) => this.setState({ delegationRemark: e.target.value, delegationRemarkErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{delegationRemarkErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>} */}
                                            {/* {
                                        !isStudentAttendee &&

                                        <div>
                                            <div>
                                                <p style={{ marginLeft: 12 }} className="mb-2">
                                                    <strong>
                                                        Letter from the employer giving the position of applicant in the
                                                        company, the reason for the visit with particulars of companies
                                                        to be visited.
                                                        <a
                                                            target="_blank"
                                                            href={Visitorletter}
                                                            download="Visitorletter"
                                                        >
                                                            <i
                                                                className="fa fa-file-pdf-o text-primary"
                                                                style={{ fontSize: 17 }}
                                                                aria-hidden="true"
                                                            />
                                                        </a>
                                                    </strong>
                                                </p>
                                                <div className="col-xl-6">
                                                    <label className="">Upload file </label>
                                                    <form action="/action_page.php">
                                                        <input type="file" id="visitorLetter" name="filename"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                        />
                                                        {
                                                            visitorLetterFile != "" &&
                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(2)}></i>
                                                        }
                                                    </form>
                                                    <p>
                                                        <strong>NOTE:</strong> Upload Maximum 1mb Size Only / Allowed
                                                        File Type: pdf
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="one-section ">
                                        <div className="containerfluid">
                                            <div className="row">
                                                <div className="col-md-12 mt-2">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Note</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-12 mb-1">
                                                    <label className="d-flex">
                                                        {" "}
                                                        1. In case you are applying for business visa kindly upload the
                                                        Permission/NOC from your company to travel to ITME Africa &amp; M.E.
                                                        2023 in Kenya
                                                    </label>
                                                </div>
                                                <div className="col-sm-12 mb-2">
                                                    <label className="d-flex">
                                                        {" "}
                                                        2. In case you are applying for non-business visa you need not
                                                        required to upload the document
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                            {/* {console.log(JSON.parse(sessionStorage.getItem("isVisitorSeminar")), (JSON.parse(sessionStorage.getItem("isVisitorB2B") || JSON.parse(sessionStorage.getItem("isVisitorSeminar")))), 'JSON.parse(sessionStorage.getItem("isVisitorSeminar")')} */}
                                            <div className="one-section ">
                                                {
                                                    (
                                                        // JSON.parse(sessionStorage.getItem("isVisitorB2B") ||
                                                        JSON.parse(sessionStorage.getItem("isVisitorSeminar"))) &&
                                                    <>
                                                        <div className="containerfluid">
                                                            <div className="row">
                                                                <div className="col-md-12 mt-2">
                                                                    <div className="p-1 title-bg">
                                                                        <p className="mb-0">Interested</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* {console.log('interestList', interestList)} */}
                                                        <div className="col-xl-12 mb-4">
                                                            <div className="row mt-4">
                                                                {
                                                                    interestList.length > 0 && interestList.map((data) => (
                                                                        <div className="col-sm-12 mb-2" key={data.AreaofInterestID}>
                                                                            {data.AreaofInterestID == 1 && <label className="d-flex">
                                                                                <input type="checkbox" name="fav_language" value={data.AreaofInterestID}
                                                                                    select={data.isSelect} checked={data.isSelect} disabled
                                                                                    onChange={(e) => this.onSelectInterest(e)}
                                                                                />
                                                                                {data.AreaofInterestID == 1 ? 'Yes, I wish to attend Seminar' : data.Name}
                                                                            </label>}
                                                                            {isInterestTwo && data.AreaofInterestID == 2 &&
                                                                                < div >
                                                                                    <div className="col-sm-3 ">
                                                                                        <label className="d-flex">
                                                                                            <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>If interested Please fill preferred Date & Time</strong>
                                                                                                (Exhibition time is 09:00hrs to 17:00hrs) <a className="text-primary"
                                                                                                    onClick={(e) => this.onFileClick(e)}><spa className="text-danger blink-soft">Click here</spa> to view exhibitor list for meeting at respective booth.</a></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-12 mb-2"
                                                                                        id="divMsg"
                                                                                    >
                                                                                        <div className="row">
                                                                                            <div className="col-xl-3">
                                                                                                <label className="mt-1">Date
                                                                                                    <span className="text-red">*</span>
                                                                                                </label>
                                                                                                <DatePicker
                                                                                                    value={preffDate}
                                                                                                    onChange={(date) =>
                                                                                                        this.setState({
                                                                                                            preffDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                            preffDateErr: ""
                                                                                                        })} disabled
                                                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                                    peekNextMonth
                                                                                                    showMonthDropdown
                                                                                                    showYearDropdown
                                                                                                    dropdownMode="select"
                                                                                                    placeholderText="Preferred Date"
                                                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                                                    minDate={moment(sessionStorage.getItem('exhibitionDateFrom'), 'YYYY-MM-DD').toDate()}
                                                                                                    maxDate={moment(sessionStorage.getItem('exhibitionDateTo'), 'YYYY-MM-DD').toDate()}
                                                                                                    popperClassName="example-datepicker-class" />
                                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{preffDateErr}</span>}
                                                                                                <div>
                                                                                                    <div >
                                                                                                        <label>preferred Time:</label>
                                                                                                        <input
                                                                                                            type="time" disabled
                                                                                                            className="form-control"
                                                                                                            value={prefTime}
                                                                                                            onChange={(e) => this.handlePrefTime(e)}
                                                                                                        />
                                                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{preffTimeErr}</span>}
                                                                                                    </div>

                                                                                                </div>

                                                                                            </div>
                                                                                            <div className="row">
                                                                                                <div className="col-xl-8 mb-1">
                                                                                                    <label className="mt-1">Remark
                                                                                                    </label>
                                                                                                    <textarea
                                                                                                        className="form-control"
                                                                                                        rows={3}
                                                                                                        maxLength={'250'} disabled
                                                                                                        defaultValue={""}
                                                                                                        value={b2bRemark}
                                                                                                        onChange={(e) => this.setState({ b2bRemark: e.target.value, b2bRemarkErr: "" })}
                                                                                                    />
                                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{b2bRemarkErr}</span>}
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {isInterstOne && data.AreaofInterestID == 1 &&
                                                                                <div className="table-responsive" >
                                                                                    <table className="table border table-bordered mb-0 mt-1"
                                                                                    // style={{ width: '100%', tableLayout: 'fixed', }}
                                                                                    >
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                                                <th style={{ width: '250px' }} className="text-center">Register</th>
                                                                                                <th style={{ width: '350px' }}>Date & Time</th>
                                                                                                <th >Session Name</th>
                                                                                                {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                                                {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                seminarInterestList.length > 0 && seminarInterestList.map((data) => (
                                                                                                    <>
                                                                                                        {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                            <td style={{ borderRight: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            {/* <td style={{ border: 'none' }}></td> */}
                                                                                                            {/* <td style={{ borderLeft: 'none' }}></td> */}
                                                                                                        </tr>}
                                                                                                        {data.IsVisitor && <tr key={Math.random()}>
                                                                                                            {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                                                <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{data.Day}</td>
                                                                                                                : <></>}
                                                                                                            <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                                                                                {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                                                    (data.SeminarTypeID == 2 ?
                                                                                                                        <a
                                                                                                                            style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                                                            disabled
                                                                                                                            className="btn btn-aqua me-2"
                                                                                                                            // type="submit"
                                                                                                                            onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                        >
                                                                                                                            {data.isReadOnly ? "Requested for Invite" : data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                                                        </a>
                                                                                                                        : data.SeminarTypeID == 3 ?
                                                                                                                            <>
                                                                                                                                {data.isReadOnly ? <input
                                                                                                                                    // style={{ marginTop: '12px' }}
                                                                                                                                    disabled
                                                                                                                                    type="checkbox"
                                                                                                                                    checked={data.isSelect && !data.isPending}
                                                                                                                                    onChange={(e) =>
                                                                                                                                        this.setState({
                                                                                                                                            ChargesPop: !data.isSelect ? true : false,
                                                                                                                                            seminarCharges: countryId == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                                                            seminarCGST: countryId == 91 ? data.INRCGST : 0,
                                                                                                                                            seminarSGST: countryId == 91 ? data.INRSGST : 0,
                                                                                                                                            seminarIGST: countryId == 91 ? data.INRIGST : data.USDIGST,
                                                                                                                                            TotalPayable: countryId == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                                                        }, () => {
                                                                                                                                            this.onCheckedSeminar(e, data.SeminarID)
                                                                                                                                        })
                                                                                                                                    }
                                                                                                                                /> : false != null ?
                                                                                                                                    <span>
                                                                                                                                        Kindly register for this seminar at the <br />Seminar Registration Counter at the venue.                                                                                                                               </span> : <input
                                                                                                                                        // style={{ marginTop: '12px' }}
                                                                                                                                        disabled
                                                                                                                                        type="checkbox"
                                                                                                                                        checked={data.isSelect && !data.isPending}
                                                                                                                                        onChange={(e) =>
                                                                                                                                            this.setState({
                                                                                                                                                ChargesPop: !data.isSelect ? true : false,
                                                                                                                                                seminarCharges: countryId == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                                                                seminarCGST: countryId == 91 ? data.INRCGST : 0,
                                                                                                                                                seminarSGST: countryId == 91 ? data.INRSGST : 0,
                                                                                                                                                seminarIGST: countryId == 91 ? data.INRIGST : data.USDIGST,
                                                                                                                                                TotalPayable: countryId == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                                                            }, () => {
                                                                                                                                                this.onCheckedSeminar(e, data.SeminarID)
                                                                                                                                            })
                                                                                                                                        }
                                                                                                                                    />}
                                                                                                                            </>
                                                                                                                            :
                                                                                                                            <input type="checkbox"
                                                                                                                                value={data.isSelect} disabled
                                                                                                                                checked={data.isSelect}
                                                                                                                                onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                            />)
                                                                                                                }
                                                                                                            </td>
                                                                                                            <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }} className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.DateTime}</td>

                                                                                                            <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }} className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.SessionName}</td>
                                                                                                            {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                                            {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                                            {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                                            {/* <td className="text-center">
                                                                                                                {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                    <span onClick={() => {
                                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                    }}>
                                                                                                                        <i class="bi bi-info-circle"></i>
                                                                                                                    </span> : <></>}
                                                                                                            </td> */}
                                                                                                        </tr>}
                                                                                                    </>
                                                                                                ))
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>

                                                                                    <div />
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </>}
                                                {!(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && <div className="one-section mb-3">
                                                    <div className="col-sm-3 ">
                                                        <label className="d-flex">
                                                            <input className="do-you" style={{ marginBottom: '25px' }}
                                                                type="checkbox"
                                                                name="fav_language"
                                                                checked={needVisaAssistance}
                                                                disabled
                                                                onChange={(e) => this.setState({
                                                                    needVisaAssistance: !needVisaAssistance,
                                                                    applicantMobNo: applicantMobNo != '' ? applicantMobNo : this.state.mobNo,
                                                                    preApplicantMobNo: preApplicantMobNo != '' ? preApplicantMobNo : this.state.preMobNo,
                                                                    applicantEmail: applicantEmail != '' ? applicantEmail : this.state.email,
                                                                    isVisaUpdated: false
                                                                })}
                                                            />
                                                            <span className="do-you1" style={{ whiteSpace: "nowrap" }}><strong>Do you need Visa Assistance?</strong>
                                                                (<b>Note</b> : Visa Application letter will be issued from {sessionStorage.getItem('ExhVisitorVisaIssueDate')}.In case applying for Business visa kindly. fill the below details to obtain Visa Invitation Letter.)</span>
                                                        </label>
                                                    </div>
                                                    {
                                                        needVisaAssistance &&
                                                        <div
                                                            className="col-md-12 mb-2"
                                                            id="divMsg"
                                                        >
                                                            <div className="row">
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">
                                                                        Name as per Passport<span className="text-red">*</span>
                                                                    </label>
                                                                    <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                        disabled
                                                                        onChange={(e) => this.setState({ passName: e.target.value, passNameErr: "", isVisaUpdated: true })}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">
                                                                        Applicant mobile number<span className="text-red">*</span>
                                                                    </label>
                                                                    <div className="phone-input-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control phone-code mt-2" autoComplete="off" placeholder="ISD" readOnly
                                                                            // placeholder="ISD"
                                                                            maxLength={'4'} value={preApplicantMobNo}
                                                                            disabled
                                                                        />
                                                                        <input type="number" className="form-control phone-no" value={applicantMobNo} disabled
                                                                            maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                            onChange={(e) => e.target.value >= 0 &&
                                                                                this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "", isVisaUpdated: true })}
                                                                        />
                                                                    </div>
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">
                                                                        Applicant email id<span className="text-red">*</span>
                                                                    </label>
                                                                    <input type="text" className="form-control" value={applicantEmail} maxLength={'50'} disabled
                                                                        onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "", isVisaUpdated: true })}

                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">Passport No
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <input type="text" className="form-control" value={passNo} maxLength={'10'} disabled
                                                                        onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "", isVisaUpdated: true })}

                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">Passport issue Date
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <DatePicker selected={passDate}
                                                                        value={passDate}

                                                                        onChange={(date) =>
                                                                            this.setState({
                                                                                passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                passDateErr: "", isVisaUpdated: true
                                                                            })}
                                                                        dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        maxDate={passExipryDate} disabled
                                                                        dropdownMode="select"
                                                                        placeholderText="Passport Issued Date"
                                                                        dayClassName={() => "example-datepicker-day-class"}
                                                                        popperClassName="example-datepicker-class" />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">Passport Expiry Date
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <DatePicker selected={passExipryDate}
                                                                        value={passExipryDate}
                                                                        disabled
                                                                        onChange={(date) =>
                                                                            this.setState({
                                                                                passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                passExipryDateErr: "", isVisaUpdated: true
                                                                            })}
                                                                        dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        minDate={passDate}
                                                                        dropdownMode="select"
                                                                        placeholderText="Passport Expiry Date"
                                                                        dayClassName={() => "example-datepicker-day-class"}
                                                                        popperClassName="example-datepicker-class" />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label className="mt-3">
                                                                        Passport issuing Country<span className="text-red">*</span>
                                                                    </label>
                                                                    <input type="text" className="form-control" value={passCountry} disabled
                                                                        onChange={(e) => this.onPassportCountrySearch(e)}
                                                                    />
                                                                    {isDisplayPassCountryList && this.renderPassCountryList()}
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{passCountryErr}</span>}
                                                                </div>
                                                                {!(isPassportFilePresent) &&
                                                                    <div className="col-xl-7">
                                                                        <label className="mt-3">
                                                                            Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                            <span className="text-red">*</span>
                                                                            {<span className='text-danger text-start text-left mt-1 ms-3'>{passportFileErr}</span>}
                                                                        </label>
                                                                        <form action="/action_page.php" style={{ textAlign: 'left', position: 'relative' }}>
                                                                            <input type="file" id="passportFile" name="filename" disabled
                                                                                accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}

                                                                                onChange={e => this.onFilePick(e, e.target.files, 1)}

                                                                            />
                                                                            {
                                                                                passportFile != "" && passportFile != 0 && passportFile != null &&
                                                                                <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                            }
                                                                        </form>
                                                                    </div>
                                                                }
                                                                {
                                                                    isVisaApplied && passportFile != "" && passportFile != null && isPassportFilePresent && passportFile != 0 &&
                                                                    <div className="col-xl-5">
                                                                        <label className="mt-3">
                                                                            Passport Front Page File
                                                                            <span className="text-red">*</span>
                                                                        </label>
                                                                        <div style={{
                                                                            border: '1px solid #ccc',
                                                                            padding: '10px',
                                                                            // display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            marginTop: '10px',
                                                                            // marginLeft: '12px',
                                                                            maxWidth: '300px'
                                                                        }}>
                                                                            <span style={{ marginRight: '10px' }}
                                                                            >{passPortFileName}</span>
                                                                            <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>}
                                            </div>
                                            {/* <div className="one-section">
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg">
                                                        <p className="mb-0">Car Parking Required (Paid Service)</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 mb-4">
                                            <div className="row mt-4">
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "Yes"}
                                                            onChange={(e) => this.setState({ carParking: "Yes" })}
                                                        />
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="col-sm-1 mb-2">
                                                    <label className="d-flex">
                                                        <input type="radio" name="carParking"
                                                            checked={carParking == "No"}
                                                            onChange={(e) => this.setState({ carParking: "No" })}
                                                        />
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                            {isParkingAvailable &&
                                                <div className="one-section">
                                                    <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg">
                                                                    <p className="mb-0">Car Parking</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-12 mb-4">
                                                        <div className="row mt-2">
                                                            <div className="col-sm-1">
                                                                <label className="d-flex" htmlFor="carParkingYes">
                                                                    {" "}
                                                                    <input type="radio" name="billingRadio"
                                                                        id="carParkingYes"
                                                                        // disabled={isPaid}
                                                                        disabled
                                                                        checked={isCarParking == 1}
                                                                        onChange={(e) => this.setState({ isCarParking: 1 })}
                                                                    />
                                                                    <strong>Yes</strong>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-1">
                                                                <label className="d-flex" htmlFor="carParkingNo">
                                                                    {" "}
                                                                    <input type="radio" name="billingRadio"
                                                                        id="carParkingNo"
                                                                        // disabled={isPaid}
                                                                        disabled
                                                                        checked={isCarParking == 0}
                                                                        onChange={(e) => this.setState({ isCarParking: 0 })}
                                                                    />
                                                                    <strong>No</strong>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {isParkingChargable && isCarParking == 1 &&
                                                            <div className="row mt-3 left-align">
                                                                <strong>Car Parking Charges:- {parkingCharges}</strong>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Remarks</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-2">
                                                        <div className="col-xl-12 mb-1">
                                                            <textarea
                                                                className="form-control" disabled
                                                                rows={3}
                                                                maxLength={'250'}
                                                                defaultValue={""}
                                                                value={remarks}
                                                                onChange={(e) => this.setState({ remarks: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-2">
                                                        <div className="col-sm-12 mb-2">

                                                            <label className="term">
                                                                <input
                                                                    type="checkbox"
                                                                    className="mt-1 d-flex" disabled
                                                                    style={{ float: "left" }}
                                                                    checked={isAgree}
                                                                    onChange={(e) => this.setState({ isAgree: !isAgree })}
                                                                />
                                                                I have read and accept the Visitor
                                                                <a>Terms &amp; Conditions &amp; Privacy Policy</a> on this
                                                                website and agree to register as visitor to {sessionStorage.getItem('ExhibitionName')}. By Submitting my registration, I give my consent to India
                                                                ITME Society to verify the provided information submitted by me online
                                                                by telephonic call or by Email and also to send me promotional
                                                                information via digital and offline channels not limited to email,
                                                                SMS, WhatsApp, print newsletter and invitation card.
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-2">
                                                        <div className="col-sm-12 mb-2">
                                                            {toShowOut && <div className="mt-2" style={{ textAlign: 'left', color: 'red' }}>
                                                                <p><strong>(Your Previous Payment was not completed. Please Try again)</strong></p>
                                                            </div>}
                                                            {toShowOut && <div style={{ textAlign: 'left' }}>
                                                                <button className="btn btn-success rounded-0  mr-2"
                                                                    // style={ }
                                                                    // disabled={!t/oShowOut}
                                                                    disabled
                                                                    onClick={(e) => toShowOut ? this.setState({ repayPOP: true }) : this.onUpdate(e)}
                                                                // onClick={(e) => toShowOut ? this.setState({ repayPOP: true }) : this.togglePGCharges(1, 1)}
                                                                >Re-Pay</button>
                                                                <button className="btn btn-danger rounded-0 ms-2"
                                                                    // style={ }
                                                                    // disabled={!toShowOut}
                                                                    disabled
                                                                    onClick={(e) => this.setState({ cancelPOP: true })}
                                                                >Cancel Payment</button>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="main-container m-3">
                                                <div className="mt-1 mb-4">
                                                    {/* <a
                                                    className="btn btn-success rounded-0"
                                                    style={{ padding: "4px 25px" }}
                                                    type="submit"
                                                    onClick={(e) => this.onUpdate(e)}
                                                >
                                                    Update
                                                </a> */}
                                                    {/* {this.state.changeVisitDays ? <button class="btn btn-success rounded-0 ">Update</button> : false ? <div>  <button type="btn" class="btn btn-aqua"
                                                        onClick={(e) => this.togglePGCharges(1, 1)}
                                                    >
                                                        Update

                                                    </button></div> : <form onSubmit={(e) => this.onUpdate(e)} disabled={this.state.changeVisitDays} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                                        action={this.state.paymentLink}

                                                    >

                                                        <button class="btn btn-success rounded-0 ">Update</button>

                                                    </form>} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={pgViewChargesModal}
                    onRequestClose={() => this.setState({ pgViewChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-success text-center fw-bold w-100">
                                    Bank Charges
                                </h4>
                            </div>
                            <div className="row m-3" >
                                <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mg-b-0">
                                        <thead>
                                            <tr>
                                                <th>Payment Mode</th>
                                                <th>Bank Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody id="myTable">
                                            {this.state.pgViewChargesFillList.length > 0 ? (
                                                this.state.pgViewChargesFillList.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                        <td>{data.Value}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td colSpan={6}>No Records Found...</td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1 col-3">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.state.updateType == 1 ? this.onUpdate(e, this.state.metadata[0], this.state.metadata[1]) : this.onUpdateGroupDays(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                                        value={encPayload} />
                                                                    <input type="hidden" name="access_code" id="access_code"
                                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={pgViewAddChargesModal}
                    onRequestClose={() => this.setState({ pgViewAddChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-white text-center fw-bold w-100">
                                    Additional Charges
                                </h4>
                            </div>
                            <div className="row mb-3" >
                                <div className="containerfluid m-0  px-3 ">
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg d-flex ps-3">
                                                <p className="mb-0">
                                                    Choose Payment Currency<span className="text-red">*</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ms-3" >
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={this.state.isPaidByUSD}
                                                checked={this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: true, toShow: totalCharges })}
                                            />
                                            Pay in USD ($)
                                        </label>
                                    </div>
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={!this.state.isPaidByUSD}
                                                checked={!this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: false, toShow: (totalCharges * this.state.conversionRate).toFixed(2) })}
                                            />
                                            Pay in INR (₹)
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-3" >
                                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p> */}
                                {/* <>“”</> */}
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Visitor Registration Charges</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.toShow}</h5>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Additional charges ({this.state.additionalChargesUSDper}%)</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? (this.state.additionalChargesUSD) : ((this.state.additionalChargesUSDper / 100) * this.state.toShow).toFixed(2)}</h5>
                                    </div>
                                </div>
                                {this.state.IGST != 0 && (
                                    <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">Total Payable</h5>
                                            <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2)}</h5>
                                        </div>
                                    </div>
                                )}
                                <p className='mt-2 '><strong>Kindly note that an additional {this.state.additionalChargesUSDper}% charge towards currency conversion will be applicable at the time of final payment as you proceed to the payment gateway.</strong></p>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.state.updateType == 1 ? this.onUpdate(e, this.state.metadata[0], this.state.metadata[1]) : this.state.updateType == 2 ? this.onUpdateGroupDays(e) : this.navToPayment()} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            className="pay-btn-form"
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                                        value={encPayload} />
                                                                    <input type="hidden" name="access_code" id="access_code"
                                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.isForeignVisitorPop} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-Primary"></h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <strong>
                                        Payments can currently be made only using Visa, Master Card, and RuPay cards issued by non-Indian banks.                                    </strong>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            this.togglePGCharges(2)
                                            this.setState({ isForeignVisitorPop: false })
                                        }
                                        }
                                    >Ok</button>
                                    <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.estimatePop} onRequestClose={() => this.setState({ estimatePop: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ marginTop: '6em', left: '-8em' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    {`Below is the revised estimate for extra ${selectedDays} days  which you have to pay`}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ estimatePop: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        {this.state.visitorCharges != 0 && <div className="row mb-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <h5 className="mb-0">Visitor Registration Charges</h5>
                                                <h5 className="mb-0">{countryId == 91 ? '₹' : '$'}{visitorCharges}</h5>
                                            </div>
                                            <div className="row" style={{ paddingRight: 0, textAlign: 'left' }}>
                                                {/* {console.log('paymentDatesList', paymentDatesList[0])} */}
                                                {/* {paymentDatesList.length > 0 && paymentDatesList.map((item, i) => (
                                                                    <div className="d-flex justify-content-between" style={{ padding: 0 }}>
                                                                        <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                            <>{item2}
                                                                                {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                &nbsp;
                                                                            </>))})</p>
                                                                    </div>
                                                                ))} */}
                                                {/* <strong onClick={() => this.setState({ isOpen4: true })} className="text-primary" style={{ cursor: 'pointer' }}>(Click here to view Visit Days)</strong> */}
                                            </div>
                                        </div>}
                                        {/* {promoCodeDiscount != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0">Promo Code Discount({discountpercent}%)</h5>
                                                    <h5 className="mb-0 text-danger">-{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.promoCodeDiscount}</h5>
                                                </div>
                                            </div>
                                        )} */}
                                        {this.state.seminarCharges != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0">Seminar Charges </h5>
                                                    <h5 className="mb-0">{countryId == 91 ? '₹' : '$'}{this.state.seminarCharges}</h5>
                                                </div>
                                                {/* <div className="col-xl-9" style={{ paddingRight: 0 }}>
                                                    <div className="d-flex justify-content-between mb-2" style={{ padding: 0 }}>
                                                        <strong>
                                                            <p style={{ padding: 0, textAlign: 'left' }}>({seminarChargesShowList.map((item, i) => (
                                                                <>
                                                                    &nbsp;{item}{i != seminarChargesShowList.length - 1 && ','}  &nbsp;{i == 2 && <br></br>}
                                                                </>
                                                            ))})</p>
                                                        </strong>
                                                    </div>
                                                </div> */}
                                            </div>
                                        )}
                                        {/* {promoCodeDiscount != 0 && ( */}
                                        <div className="row mb-2">
                                            <div className="d-flex justify-content-between mb-2">
                                                <h5 className="mb-0">Total Taxable </h5>
                                                <h5 className="mb-0">{countryId == 91 ? '₹' : '$'}{this.state.totaltaxable}</h5>
                                            </div>
                                        </div>
                                        {/* )} */}
                                        {/* {isParkingAvailable && isCarParking != 0 && parkingCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="col-6">
                                                                        <h6>Parking Charges</h6>
                                                                    </div>
                                                                    <div className="col-6 text-end">
                                                                        <h6>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{isCarParking ? parkingCharges : 0}</h6>
                                                                    </div>
                                                                </div>
                                                            )} */}

                                        {this.state.CGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>CGST</h5>
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>{countryId == 91 ? '₹' : '$'}{this.state.CGST}</h5>
                                                </div>
                                            </div>
                                        )}

                                        {this.state.SGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>SGST</h5>
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>{countryId == 91 ? '₹' : '$'}{this.state.SGST}</h5>
                                                </div>
                                            </div>
                                        )}

                                        {this.state.IGST != 0 && (
                                            <div className="row mb-2">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>IGST</h5>
                                                    <h5 className="mb-0" style={{ scale: 0.9 }}>{countryId == 91 ? '₹' : '$'}{this.state.IGST}</h5>
                                                </div>
                                            </div>
                                        )}


                                        <div className="row mt-n2">
                                            <div className="col-md-12">
                                                <hr />
                                            </div>
                                        </div>
                                        <div className="row  " >
                                            <div className="d-flex justify-content-between mb-2">
                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>Total Charges</h6>
                                                <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>{countryId == 91 ? '₹' : '$'}{this.state.totalCharges}</h6>
                                            </div>
                                        </div>

                                        {/* <div className="row border-top pt-2 mt-2 align-items-start">
                                                                
                                                                <div className="col-6">
                                                                    <h5>Total Charges</h5>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h5>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{totalCharges}</h5>
                                                                </div>
                                                            </div> */}
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    {/* {this.state.is1stPiCreated ? <button type="button" class="btn btn-del-pop"
                                                        onClick={(e => this.setState({
                                                            // isUpdatePerm: true
                                                        }, () => this.viewPI(1)))}
                                                    >View 1st PI</button> : <></>}
                                                    {this.state.is2ndPiCreated ? <button type="button" class="btn btn-del-pop" style={{ marginLeft: '5px' }}
                                                        onClick={(e => this.setState({
                                                            // isUpdatePerm: true
                                                        }, () => this.viewPI(0)))}
                                                    >View 2nd PI</button> : <></>} */}
                                    <button type="button" class="btn btn-del-pop" style={{ marginLeft: '5px' }}
                                        // onClick={(e => this.setState({
                                        //     isUpdatePerm: true
                                        // }, () => this.editSpaceBooking()))}
                                        onClick={(e) =>
                                        //  isDirectPayment ? this.navToPayment() :
                                        // this.onUpdate(e, 1, toShowOut)}
                                        {
                                            this.togglePGCharges(1, 1, [1, toShowOut])
                                            this.setState({ estimatePop: false })
                                        }
                                        }
                                    // onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Pay and Update", action: 4 }, popArg: [e, 1, toShowOut] })}
                                    >Pay and Update</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ estimatePop: false })}>cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-danger">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this Document?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpen4} >
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-danger">Visit Days Charges</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen4: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" >
                                                        No of Days
                                                    </th>
                                                    <th className="text-center">Price INR</th>
                                                    <th className="text-center">Price USD</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pricingList.length > 0 ? pricingList.map((data, index) => (
                                                        <tr key={Math.random()}>
                                                            <td className="text-center">{data.VisitDays}</td>
                                                            <td className="text-center">{data.PriceINR != null && data.PriceINR != '' ? data.PriceINR : '-'}</td>
                                                            <td className="text-center">{data.PriceUSD != null && data.PriceUSD != '' ? data.PriceUSD : '-'}</td>

                                                        </tr>
                                                    )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen4: false })}>close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={cancelPOP} onRequestClose={() => this.setState({ cancelPOP: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-white">Confirm Cancel Payment</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ cancelPOP: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you want to cance this payment? (this visit days or paid seminars which was selected against this payment will be null and void)</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.onCancelPayment()}>Yes</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ cancelPOP: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={repayPOP} onRequestClose={() => this.setState({ repayPOP: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-Dark">Re-Pay</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ repayPOP: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Your last payment was failed please try again </p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-success" onClick={(e) => isCoordinator ? this.togglePGCharges(1, 2) : this.onUpdate(e)}>Yes</button>
                                    {/* <button type="button" class="btn btn-success" onClick={(e) => isCoordinator ? this.togglePGCharges(1, 2) : this.togglePGCharges(1, 1)}>Yes</button> */}
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ repayPOP: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={successPOP} onRequestClose={() => this.setState({ successPOP: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-white">SUCCESS</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ successPOP: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Your payment is completed and recipt for the same tranction send on your email</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    {/* <button type="button" class="btn btn-success" onClick={(e) => isCoordinator ? this.onUpdateGroupDays() : this.onUpdate()}>Yes</button> */}
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ successPOP: false })}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.ChargesPop} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                {/* <h5 class="modal-title modal_title_text text-Primary">
                                                </h5> */}
                            </div>
                            <div class="modal-body">
                                {(this.state.TotalPayable != '' && this.state.TotalPayable != null) && <>                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Seminar Charges</h5>
                                        <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{this.state.seminarCharges}</strong></h5>
                                    </div>
                                </div>
                                    {this.state.seminarCGST != '' && <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">CGST</h5>
                                            <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{this.state.seminarCGST}</strong></h5>
                                        </div>
                                    </div>}
                                    {this.state.seminarSGST != '' && <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">SGST</h5>
                                            <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{this.state.seminarSGST}</strong></h5>
                                        </div>
                                    </div>}
                                    {this.state.seminarIGST != '' && <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">IGST</h5>
                                            <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{this.state.seminarIGST}</strong></h5>
                                        </div>
                                    </div>}
                                    <div className="row mb-2 mt-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">Total Payable</h5>
                                            <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{this.state.TotalPayable}</strong></h5>
                                        </div>
                                    </div>
                                    {this.state.toShowExtraDaysinPop && <hr></hr>}
                                </>}
                                {this.state.toShowExtraDaysinPop && <span style={{ fontWeight: '500' }}>Please be advised that the selection of an Exhibition Visit Date was not completed in the previous step for this conference. Consequently, standard visitor registration fees will be included in the final payment summary.</span>}
                                {false == true && <span style={{ fontWeight: '500' }}><br></br><br></br>
                                    <strong>Please register and complete payment for the selected date before choosing a seminar.</strong></span>}
                                {this.state.cantSelectSeminarFlag && <span style={{ fontWeight: '500' }}>Please be advised that the selection of an Exhibition Visit Date was not completed in the previous step for this conference. Consequently, standard visitor registration fees will be included in the final payment summary.<br></br><br></br>
                                    <strong>Kindly coordinate with your coordinator to register for this seminar</strong></span>}
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            // this.togglePGCharges(2)
                                            this.setState({
                                                ChargesPop: false,
                                                seminarCharges: '',
                                                seminarCGST: '',
                                                seminarSGST: '',
                                                seminarIGST: '',
                                                TotalPayable: '',
                                            })
                                        }
                                        }
                                    >Ok</button>
                                    {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                                    >Close</button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.HTMLEDITOR} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                {/* <h5 class="modal-title modal_title_text text-Primary">
                                                </h5> */}
                            </div>
                            <div class="modal-body">
                                <ul className="p-0">
                                    <li dangerouslySetInnerHTML={{ __html: `${this.state.HtmlContent != null ? this.state.HtmlContent : ''}` }}></li>
                                </ul>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            // this.togglePGCharges(2)
                                            this.setState({
                                                HTMLEDITOR: false,
                                            })
                                        }
                                        }
                                    >Ok</button>
                                    {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                                    >Close</button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
            </>
        )
    }
}
export default withRouter(connect(null, {
    fill_action, combineVisitorRegistrationDetail2_action, visitorRegistrationUpdate_action, cancelVisitorCharges_action, payment_action, updateVisitorEstimate_action, updateGroupVisitorDays_action, swapVisitorDate_action,
    deleteVisaDoc_action, getVisitorRegistrationCredentials_action, getDrawerDetails_action, getCoordinatorVisitor_action, sendPaymentForm_action
})(VisitorFormView))

